//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import type * as Custom from './Reinforced.Typings.CustomTypes';

export namespace MiaPlaza {
	export interface IPlaceholder
	{
		Placeholder: string;
	}
	export abstract class RoutedHelper
	{
		public static GetParameter(parameter: any) : string
		{
			return parameter?.Placeholder ?? encodeURIComponent(JSON.stringify(parameter));
		}
	}
}
export namespace MiaPlaza.Collections.Multitude {
	export enum OffsetPrecision {
		Exact = "Exact",
		AlmostExact = "AlmostExact",
		Unfiltered = "Unfiltered"
	}
	export enum LimitPrecision {
		Exact = "Exact",
		AlmostExact = "AlmostExact",
		Unfiltered = "Unfiltered"
	}
}
export namespace MiaPlaza.ConfigModel.FAQ {
	export interface IAnsweredQuestion
	{
		Question: string;
		Answer: string;
	}
	export interface IFAQCategory
	{
		Category: string;
		AnsweredQuestions: MiaPlaza.ConfigModel.FAQ.IAnsweredQuestion[];
	}
}
export namespace MiaPlaza.ConfigModel.LandingPage {
	export interface IMenuOptions
	{
		Title: string;
		Url: string;
		Submenus: MiaPlaza.ConfigModel.LandingPage.IMenuOptions[];
	}
}
export namespace MiaPlaza.ConfigModel.Lesson {
	export interface ILessonBackground
	{
		Id: string;
		Title: string;
		Url: string;
	}
}
export namespace MiaPlaza.ConfigModel.ResourceLinks {
	export interface INamedLink
	{
		Title: string;
		Url: string;
	}
}
export namespace MiaPlaza.ConfigModel.Video {
	export interface IVimeoFallbackOptions
	{
		Enabled: boolean;
		S3BucketEndpoint: string;
	}
}
export namespace MiaPlaza.Content {
	export enum MessageListType {
		ReceivedYouOnly = "ReceivedYouOnly",
		ReceivedMoreThanYou = "ReceivedMoreThanYou",
		Sent = "Sent",
		Trash = "Trash",
		Starred = "Starred"
	}
	export class ArcadeGames
	{
		public static GetArcadeGamesUrl() : string
		{
			return "/Content.ArcadeGames/GetArcadeGames?_=";
		}
	}
	export class Message
	{
		public static GetMessagesUrl(mailboxType: MiaPlaza.Content.MessageListType | MiaPlaza.IPlaceholder, isAscendingOrder: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Content.Message/GetMessages?mailboxType=${MiaPlaza.RoutedHelper.GetParameter(mailboxType)}&isAscendingOrder=${MiaPlaza.RoutedHelper.GetParameter(isAscendingOrder)}&_=`;
		}
		public static GetToggleSortOrderUrl(mailboxType: MiaPlaza.Content.MessageListType | MiaPlaza.IPlaceholder, isAscendingOrder: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Content.Message/ToggleSortOrder?mailboxType=${MiaPlaza.RoutedHelper.GetParameter(mailboxType)}&isAscendingOrder=${MiaPlaza.RoutedHelper.GetParameter(isAscendingOrder)}&_=`;
		}
		public static GetDeleteAllMessagesUrl(mailboxType: MiaPlaza.Content.MessageListType | MiaPlaza.IPlaceholder, isAscendingOrder: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Content.Message/DeleteAllMessages?mailboxType=${MiaPlaza.RoutedHelper.GetParameter(mailboxType)}&isAscendingOrder=${MiaPlaza.RoutedHelper.GetParameter(isAscendingOrder)}&_=`;
		}
		public static GetMarkAllMessagesAsReadUrl(mailboxType: MiaPlaza.Content.MessageListType | MiaPlaza.IPlaceholder, isAscendingOrder: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Content.Message/MarkAllMessagesAsRead?mailboxType=${MiaPlaza.RoutedHelper.GetParameter(mailboxType)}&isAscendingOrder=${MiaPlaza.RoutedHelper.GetParameter(isAscendingOrder)}&_=`;
		}
	}
	export class MessageSend
	{
		public static GetPreviousConversationsUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Content.MessageSend/GetPreviousConversations?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
	}
	export class NewspaperAdCreator
	{
		public static GetCreateOrUpdateAdUrl(ad: Custom.ModelId<'Newspaper.AdvertisingTemplate'> | MiaPlaza.IPlaceholder, inDraftMode: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Content.NewspaperAdCreator/CreateOrUpdateAd?ad=${MiaPlaza.RoutedHelper.GetParameter(ad)}&inDraftMode=${MiaPlaza.RoutedHelper.GetParameter(inDraftMode)}&_=`;
		}
		public static GetVisibleItemsUrl() : string
		{
			return "/Content.NewspaperAdCreator/GetVisibleItems?_=";
		}
	}
	export class NewspaperCreator
	{
		public static GetDraftsUrl() : string
		{
			return "/Content.NewspaperCreator/GetDrafts?_=";
		}
	}
	export class PostingOverview
	{
		public static GetTeamMembersUrl(team: Custom.ModelId<'Team'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Content.PostingOverview/GetTeamMembers?team=${MiaPlaza.RoutedHelper.GetParameter(team)}&_=`;
		}
	}
	export class ScoopsOverview
	{
		public static GetUserTransactionsUrl() : string
		{
			return "/Content.ScoopsOverview/GetUserTransactions?_=";
		}
	}
}
export namespace MiaPlaza.Content.Admin {
	export class Accounts
	{
		public static GetMembersOnlineUrl() : string
		{
			return "/Content.Admin.Accounts/GetMembersOnline?_=";
		}
	}
	export class ImageUpload
	{
		public static GetUploadedImagesUrl() : string
		{
			return "/Content.Admin.ImageUpload/GetUploadedImages?_=";
		}
	}
	export class Newsletter
	{
		public static GetNewslettersUrl() : string
		{
			return "/Content.Admin.Newsletter/GetNewsletters?_=";
		}
	}
}
export namespace MiaPlaza.Control {
	export class DeleteMessageDesign
	{
		public static GetRenderPreviewUrl(recipient: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, subject: string | MiaPlaza.IPlaceholder, message: string | MiaPlaza.IPlaceholder, itemId: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.DeleteMessageDesign/RenderPreview?recipient=${MiaPlaza.RoutedHelper.GetParameter(recipient)}&subject=${MiaPlaza.RoutedHelper.GetParameter(subject)}&message=${MiaPlaza.RoutedHelper.GetParameter(message)}&itemId=${MiaPlaza.RoutedHelper.GetParameter(itemId)}&_=`;
		}
	}
	export class FriendRequestPending
	{
		public static GetPendingFriendsUrl() : string
		{
			return "/Control.FriendRequestPending/GetPendingFriends?_=";
		}
	}
	export class GiveGiftBox
	{
		public static GetPossibleGiftsUrl() : string
		{
			return "/Control.GiveGiftBox/GetPossibleGifts?_=";
		}
	}
	export class LoginFormChildren
	{
		public static GetStoreChildDataInSessionForForgotPasswordPageUrl(firstName: string | MiaPlaza.IPlaceholder, lastName: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.LoginFormChildren/StoreChildDataInSessionForForgotPasswordPage?firstName=${MiaPlaza.RoutedHelper.GetParameter(firstName)}&lastName=${MiaPlaza.RoutedHelper.GetParameter(lastName)}&_=`;
		}
	}
	export class ProfileEmailChange
	{
		public static GetChangeEmailUrl() : string
		{
			return "/Control.ProfileEmailChange/ChangeEmail?_=";
		}
	}
	export class TeamMemberships
	{
		public static GetTeamsUrl(owner: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.TeamMemberships/GetTeams?owner=${MiaPlaza.RoutedHelper.GetParameter(owner)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Admin {
	export class TransferTextResources
	{
		public static TRANSFER_CONFIGURATION_CLASS: string = `mia-transferConfiguration`;
		public static TRANSFER_BUTTON_CLASS: string = `mia-transfer`;
		public static DRY_RUN_CHECKBOX_CLASS: string = `mia-dryRun`;
		public static TRANSFER_TRS_TABLE_CLASS: string = `textResourceTransferTable`;
		public static GetDownloadTextResourcesUrl() : string
		{
			return "/Control.Admin.TransferTextResources/DownloadTextResources?_=";
		}
	}
	export class AccountDetails
	{
		public static GetToggleGovernmentNotAcceptedContentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Admin.AccountDetails/ToggleGovernmentNotAcceptedContent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Games.MiniWorldHouseInside {
	export class InventoryList
	{
		public static GetInventoryItemsUrl(category: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Games.MiniWorldHouseInside.InventoryList/GetInventoryItems?category=${MiaPlaza.RoutedHelper.GetParameter(category)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Games.Multiplayer {
	export class MultiplayerConstruction
	{
		public static GetgoBack_ClickUrl(instance: Custom.ModelId<'MultiplayerInstance'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Games.Multiplayer.MultiplayerConstruction/goBack_Click?instance=${MiaPlaza.RoutedHelper.GetParameter(instance)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Games.Shop {
	export enum PublicShopType {
		Clothing = "Clothing",
		Furniture = "Furniture",
		Art = "Art"
	}
}
export namespace MiaPlaza.Control.Newspaper {
	export interface IExampleArticle
	{
		CategoryId: number;
		Category: string;
		Title: string;
		Body: string;
	}
	export class NewspaperEditor
	{
		public static GetExampleArticlesUrl() : string
		{
			return "/Control.Newspaper.NewspaperEditor/GetExampleArticles?_=";
		}
		public static GetItemsForSaleUrl() : string
		{
			return "/Control.Newspaper.NewspaperEditor/GetItemsForSale?_=";
		}
	}
	export class NewspaperOptions
	{
		public static GetOnWriteBtnClickUrl() : string
		{
			return "/Control.Newspaper.NewspaperOptions/OnWriteBtnClick?_=";
		}
	}
}
export namespace MiaPlaza.Control.ProfilePage {
	export class ProfilePage
	{
		public static GetFriendsUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.ProfilePage.ProfilePage/GetFriends?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
		public static GetPublishedNewspaperArticlesUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.ProfilePage.ProfilePage/GetPublishedNewspaperArticles?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Tracking {
	export interface IAmplitudeTrackingOptions
	{
		ApiKey: string;
		UserId: string;
		SessionId: number;
		DeviceId: string;
		DomainsServedByOtherSites: string[];
		CrossDomainLinkTaggingEnabled: boolean;
		SessionReplayEnabled: boolean;
	}
	export interface IFacebookPixelTrackingEvent
	{
		EventType: string;
		EventId: string;
		CustomData: string;
	}
	export interface IFacebookPixelTrackingOptions
	{
		Id: string;
		Events: MiaPlaza.Control.Tracking.IFacebookPixelTrackingEvent[];
	}
	export interface IGoogleAdsTrackingOptions
	{
		ConversionId: string;
		ConversionEvents: MiaPlaza.LO.Tracking.GoogleAds.IGoogleAdsConversionEvent[];
	}
	export interface IIHeartMediaPixelTrackingEvent
	{
		EventType: string;
		CustomData: string;
	}
	export interface IIHeartMediaPixelTrackingOptions
	{
		Id: string;
		Events: MiaPlaza.Control.Tracking.IIHeartMediaPixelTrackingEvent[];
	}
	export interface IKlaviyoFormTrackingOptions
	{
		PublicKey: string;
	}
	export interface IPinterestTagTrackingEvent
	{
		EventType: string;
		CustomData: string;
	}
	export interface IPinterestTagTrackingOptions
	{
		Id: string;
		Events: MiaPlaza.Control.Tracking.IPinterestTagTrackingEvent[];
	}
	export interface IUnbounceTrackingOptions
	{
		Domain: string;
	}
}
export namespace MiaPlaza.Control.Vue {
	export enum ContactFormVisitorType {
		AnonymousChild = "AnonymousChild",
		Child = "Child",
		AnonymousParent = "AnonymousParent",
		Parent = "Parent",
		OnlineSchoolParent = "OnlineSchoolParent"
	}
	export interface IUserData
	{
		FirstName: string;
		LastName: string;
		Email: string;
	}
	export interface IProfileData
	{
		Name: string;
		Avatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		ProfileUrl: string;
		FundsAmount: number;
		FundsPageUrl: string;
		NewGuestBookEntries: number;
		IsPawsPartnerStudent: boolean;
	}
	export class I18Next
	{
		public static Default: string = `en-US`;
		public static US: string = `en-US`;
		public static UK: string = `en-GB`;
		public static C: string = `C`;
		public static STORE: string = `I18Next`;
		public static I18NEXT_KEY: string = `⸤…⸣`;
		public static GetConvertUrl(cultures: string[] | MiaPlaza.IPlaceholder, keys: string[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.I18Next/Convert?cultures=${MiaPlaza.RoutedHelper.GetParameter(cultures)}&keys=${MiaPlaza.RoutedHelper.GetParameter(keys)}&_=`;
		}
	}
	export interface INoServiceDayData
	{
		Name: string;
		IconUrl: string;
	}
	export interface IPublicHolidayData
	{
		PublicHoliday: MiaPlaza.Model.PublicHoliday;
		Observed: boolean;
	}
	export class MiaTourStoreRegistration
	{
		public static STORE_NAME: string = `MiaTourStore`;
	}
	export interface IMyWorldActivity
	{
		Name: string;
		Image: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Target: string;
	}
	export enum RulesType {
		DesignStudio = 0,
		Community = 1
	}
	export interface ITeamMember
	{
		Title: string;
		About: string;
		PictureUrl: string;
	}
	export interface IMedalInformation
	{
		MedalPicture: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
	}
	export interface IVueGameData
	{
		CommonIdentifier: string;
		RawGameData: string;
		ProgressUrl: string;
		RedirectUrl: string;
		CurrentLevel: number;
		InitialMedalPicture: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		IsIncludedInCurriculum: boolean;
		IsMedalReceived: boolean;
	}
	export class ModeratorsNote
	{
		public static GetSaveMemberNoteUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, note: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.ModeratorsNote/SaveMemberNote?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&note=${MiaPlaza.RoutedHelper.GetParameter(note)}&_=`;
		}
	}
	export class VueGame
	{
		public static GetVueGameDataUrl(game: Custom.ModelId<'Games.VueGame'> | MiaPlaza.IPlaceholder, medal?: MiaPlaza.Model.Games.MedalType | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.VueGame/GetVueGameData?game=${MiaPlaza.RoutedHelper.GetParameter(game)}&medal=${MiaPlaza.RoutedHelper.GetParameter(medal)}&_=`;
		}
		public static GetReportProgressUrl(commonIdentifier: string | MiaPlaza.IPlaceholder, level: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.VueGame/ReportProgress?commonIdentifier=${MiaPlaza.RoutedHelper.GetParameter(commonIdentifier)}&level=${MiaPlaza.RoutedHelper.GetParameter(level)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Vue.Admin {
	export interface IVideoRejectionPresetMessage
	{
		Name: string;
		Message: string;
	}
	export interface IContentSynchronizationState
	{
		ToBeDeletedUnits: [string,boolean][];
		ToBeDeletedCourses: [string,boolean][];
		ToBeDeletedLessons: string[];
		ToBeDeletedGames: string[];
		ToBeInstalledGames: string[];
		ToBeDeletedVideos: string[];
		ToBeDeletedSupplementalMaterialPdfs: string[];
		ToBeDeletedSupplementalMaterialIFrames: string[];
		Version: string;
		Error: string;
	}
	export interface IConfigurationSection
	{
		Name: string;
		Branch: string;
		Version: string;
	}
	export interface ISectionDetails
	{
		Branch: string;
		Version: string;
		Data: { [key:string]: string };
	}
	export class RegulatorSections
	{
		public static GetReloadUrl(section: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Admin.RegulatorSections/Reload?section=${MiaPlaza.RoutedHelper.GetParameter(section)}&_=`;
		}
		public static GetSetBranchUrl(section: string | MiaPlaza.IPlaceholder, branch: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Admin.RegulatorSections/SetBranch?section=${MiaPlaza.RoutedHelper.GetParameter(section)}&branch=${MiaPlaza.RoutedHelper.GetParameter(branch)}&_=`;
		}
		public static GetLoadDataUrl(section: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Admin.RegulatorSections/LoadData?section=${MiaPlaza.RoutedHelper.GetParameter(section)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Vue.CampaignAccessoryGiveaway {
	export interface IAccessory
	{
		Name: string;
		Url: string;
	}
}
export namespace MiaPlaza.Control.Vue.Lists {
	export class AdminAccountPaymentList
	{
		private static PAGE_SIZE: number = 25;
		public static GetPaymentsUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminAccountPaymentList/GetPayments?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
		public static GetConvertUrl(payment: Custom.ModelId<'Payments.AdminPayment' | 'Payments.BraintreePayment' | 'Payments.ClassWalletPayment' | 'Payments.GiftCodeBundlePayment' | 'Payments.PausedSubscriptionPayment' | 'Payments.Payment' | 'Payments.PayPalPayment' | 'Payments.RemotePayment'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminAccountPaymentList/Convert?payment=${MiaPlaza.RoutedHelper.GetParameter(payment)}&_=`;
		}
	}
	export interface IAdminAccountPayment
	{
		Type: string;
		Product: string;
		Creation: string;
		Amount: string;
		BraintreeTransactionId: string;
		Coupon: string;
	}
	export class AdminCouponCodeList
	{
		public static PAGE_SIZE: number = 30;
		public static GetConvertUrl(couponCode: Custom.ModelId<'Payments.CouponCode'> | MiaPlaza.IPlaceholder, selectedItemStore: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminCouponCodeList/Convert?couponCode=${MiaPlaza.RoutedHelper.GetParameter(couponCode)}&selectedItemStore=${MiaPlaza.RoutedHelper.GetParameter(selectedItemStore)}&_=`;
		}
		public static GetDeleteUrl(couponCode: Custom.ModelId<'Payments.CouponCode'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminCouponCodeList/Delete?couponCode=${MiaPlaza.RoutedHelper.GetParameter(couponCode)}&_=`;
		}
	}
	export interface IAdminCouponCode
	{
		UUId: Custom.ModelId<'Payments.CouponCode'>;
		Code: string;
		Expiration: string;
		VisitorCount: number;
		Notes: string;
		IsUsed: boolean;
		CouponCodeDiscounts: MiaPlaza.Control.Vue.Lists.IAdminCouponCodeDiscount[];
		SelectedItemStore: string;
	}
	export interface IAdminCouponCodeDiscount
	{
		UUId: Custom.ModelId<'Payments.CouponCodeDiscount'>;
		Discount: number;
		PurchaseCount: number;
		Product: MiaPlaza.Model.Payments.ProductType;
	}
	export class AdminEmbeddedSubscriptionList
	{
		public static PAGE_SIZE: number = 5;
		public static GetConvertUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminEmbeddedSubscriptionList/Convert?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&_=`;
		}
		public static GetSubscriptionsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminEmbeddedSubscriptionList/GetSubscriptions?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetSynchronizeSubscriptionUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminEmbeddedSubscriptionList/SynchronizeSubscription?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&_=`;
		}
	}
	export interface IAdminSubscriptionEmbedded
	{
		Creation: string;
		Canceled: boolean;
		Product: string;
		NextBillingSubjects: string;
		ExternalId: string;
		SyncUrl: string;
		Start: string;
		FutureStartDate: boolean;
		PastDue: boolean;
	}
	export class AdminFriendList
	{
		private static PAGE_SIZE: number = 25;
		public static GetFriendshipsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminFriendList/GetFriendships?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetConvertUrl(membership: [string, string] | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminFriendList/Convert?membership=${MiaPlaza.RoutedHelper.GetParameter(membership)}&_=`;
		}
	}
	export interface IAdminFriend
	{
		Id: string;
		Name: string;
		DetailsUrl: string;
		Started: string;
	}
	export class AdminLostPetList
	{
		public static PAGE_SIZE: number = 20;
		public static GetConvertUrl(gnomObject: Custom.ModelId<'Games.GNOM.GNOMObject'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminLostPetList/Convert?gnomObject=${MiaPlaza.RoutedHelper.GetParameter(gnomObject)}&_=`;
		}
		public static GetGiveGNOMBackUrl(gnomObject: Custom.ModelId<'Games.GNOM.GNOMObject'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminLostPetList/GiveGNOMBack?gnomObject=${MiaPlaza.RoutedHelper.GetParameter(gnomObject)}&_=`;
		}
	}
	export interface ILostPet
	{
		PetPicture: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		OwnerName: string;
		OwnerId: number;
		PetName: string;
		GiveBackLink: string;
	}
	export interface IAdminMember
	{
		Id: string;
		Name: string;
		DetailsUrl: string;
		Type: MiaPlaza.Model.PortalType;
	}
	export class AdminNewsletterContentList
	{
		public static PAGE_SIZE: number = 10;
		public static GetConvertUrl(entry: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminNewsletterContentList/Convert?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
		public static GetActionLinkUrl(entry: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminNewsletterContentList/GetActionLink?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
		public static GetActionByStatusUrl(currentStatus: MiaPlaza.Model.Newsletter.Status | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminNewsletterContentList/GetActionByStatus?currentStatus=${MiaPlaza.RoutedHelper.GetParameter(currentStatus)}&_=`;
		}
		public static GetGenerateProgressUrl(entry: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminNewsletterContentList/GenerateProgress?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
		public static GetSendUrl(entry: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminNewsletterContentList/Send?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
		public static GetPauseUrl(entry: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminNewsletterContentList/Pause?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
		public static GetDeleteUrl(entry: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminNewsletterContentList/Delete?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
		public static GetDuplicateNewsletterUrl(newsletter: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminNewsletterContentList/DuplicateNewsletter?newsletter=${MiaPlaza.RoutedHelper.GetParameter(newsletter)}&_=`;
		}
	}
	export enum NewsletterAction {
		Approve = "Approve",
		Pause = "Pause",
		Resume = "Resume",
		None = "None"
	}
	export interface INewsletterContent
	{
		CreationDate: string;
		OpenLink: string;
		OpenLabel: string;
		Subject: string;
		Status: string;
		Progress: string;
		Action: MiaPlaza.Control.Vue.Lists.NewsletterAction;
		ActionLink: string;
		DuplicateLink: string;
		DeleteLink: string;
		Newsletter: Custom.ModelId<'Newsletter.NewsletterContent'>;
		ShownOnParentPortal: boolean;
	}
	export class AdminTextResourceList
	{
		public static PAGE_SIZE: number = 20;
		public static GetReplaceUrl(key: string | MiaPlaza.IPlaceholder, data: MiaPlaza.Control.Vue.Lists.IAdminTextResourceData[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminTextResourceList/Replace?key=${MiaPlaza.RoutedHelper.GetParameter(key)}&data=${MiaPlaza.RoutedHelper.GetParameter(data)}&_=`;
		}
		public static GetConvertUrl(key: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminTextResourceList/Convert?key=${MiaPlaza.RoutedHelper.GetParameter(key)}&_=`;
		}
	}
	export interface IAdminTextResource
	{
		Key: string;
		Data: MiaPlaza.Control.Vue.Lists.IAdminTextResourceData[];
		Extra: MiaPlaza.Control.Vue.Lists.IAdminTextResourceExtra[];
		DeleteUrl: string;
		EditUrl: string;
		SupportedPortals: MiaPlaza.Model.PortalType[];
		SupportedApplications: MiaPlaza.Data.PortalInstance[];
	}
	export interface IAdminTextResourceData
	{
		Text: string;
		Culture: string;
		PortalInstance: MiaPlaza.Data.PortalInstance;
		TTSMode: MiaPlaza.Model.TTSModeType | null;
		TTSData: string | null;
	}
	export interface IAdminTextResourceExtra
	{
		TTSUrl: string;
	}
	export class AdminUploadedImageList
	{
		public static PAGE_SIZE: number = 20;
		public static GetConvertUrl(image: Custom.ModelId<'UploadedImage'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminUploadedImageList/Convert?image=${MiaPlaza.RoutedHelper.GetParameter(image)}&_=`;
		}
		public static GetDeleteUrl(image: Custom.ModelId<'UploadedImage'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminUploadedImageList/Delete?image=${MiaPlaza.RoutedHelper.GetParameter(image)}&_=`;
		}
	}
	export interface IUploadedImage
	{
		Id: number;
		PathOnDisk: string;
		PathOnWebsite: string;
		DeleteLink: string;
		CreationDateAndTime: string;
	}
	export class ArcadeGameList
	{
		public static PAGE_SIZE: number = 20;
		public static GetConvertUrl(game: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Game' | 'MultiplayerGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.ArcadeGameList/Convert?game=${MiaPlaza.RoutedHelper.GetParameter(game)}&_=`;
		}
	}
	export interface IArcadeGame
	{
		Name: string;
		Url: string;
		Thumbnail: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
	}
	export class ArticleList
	{
		public static PAGE_SIZE: number = 2;
		public static GetConvertUrl(article: Custom.ModelId<'Newspaper.NewspaperArticle'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.ArticleList/Convert?article=${MiaPlaza.RoutedHelper.GetParameter(article)}&_=`;
		}
	}
	export interface IArticle
	{
		NewspaperUrl: string;
		NewspaperImage: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Title: string;
		TitleUrl: string;
		PublishingDate: string;
		Category: string;
	}
	export class DesignedItemList
	{
		public static PAGE_SIZE: number = 12;
		public static GetConvertUrl(entry: Custom.ModelId<'Games.MiniWorld.DesignedItem'> | MiaPlaza.IPlaceholder, store: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.DesignedItemList/Convert?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&store=${MiaPlaza.RoutedHelper.GetParameter(store)}&_=`;
		}
	}
	export interface IDesignedItem
	{
		Id: number;
		Image: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		SelectedItemStore: string;
	}
	export class FriendRequestList
	{
		public static PAGE_SIZE: number = 10;
		public static GetConvertUrl(sender: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.FriendRequestList/Convert?sender=${MiaPlaza.RoutedHelper.GetParameter(sender)}&_=`;
		}
		public static GetAcceptFriendRequestUrl(fromStudent: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.FriendRequestList/AcceptFriendRequest?fromStudent=${MiaPlaza.RoutedHelper.GetParameter(fromStudent)}&_=`;
		}
		public static GetBlockFriendRequestUrl(studentToBlock: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.FriendRequestList/BlockFriendRequest?studentToBlock=${MiaPlaza.RoutedHelper.GetParameter(studentToBlock)}&_=`;
		}
		public static GetDeclineFriendRequestUrl(fromStudent: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.FriendRequestList/DeclineFriendRequest?fromStudent=${MiaPlaza.RoutedHelper.GetParameter(fromStudent)}&_=`;
		}
	}
	export interface IFriendRequest
	{
		Name: string;
		Avatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		MemberUrl: string;
		AcceptUrl: string;
		DeclineUrl: string;
		BlockUrl: string;
	}
	export class GiveGiftList
	{
		public static PAGE_SIZE: number = 12;
		public static GetConvertUrl(gift: Custom.ModelId<'Games.MiniWorld.ItemInstance'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.GiveGiftList/Convert?gift=${MiaPlaza.RoutedHelper.GetParameter(gift)}&_=`;
		}
	}
	export interface IGift
	{
		Image: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Link: string;
	}
	export class InventoryList
	{
		public static PAGE_SIZE: number = 12;
		public static LIMIT: number = 1024;
		public static GetConvertUrl(itemInstance: Custom.ModelId<'Games.MiniWorld.ItemInstance'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.InventoryList/Convert?itemInstance=${MiaPlaza.RoutedHelper.GetParameter(itemInstance)}&_=`;
		}
		public static GetDeleteItemUrl(itemInstance: Custom.ModelId<'Games.MiniWorld.ItemInstance'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.InventoryList/DeleteItem?itemInstance=${MiaPlaza.RoutedHelper.GetParameter(itemInstance)}&_=`;
		}
	}
	export interface IInventoryListItem
	{
		Type: MiaPlaza.Model.Games.MiniWorld.Type;
		Id: string;
		Height: string;
		Width: string;
		Position: boolean;
		Image: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		DeleteLink: string | null;
		PetWorldLink: string | null;
	}
	export interface IMedalListItem
	{
		ImageUrl: string;
		GameTitle: string;
		GameLink: string;
	}
	export interface IMemberInfo
	{
		Name: string;
		AvatarSettings: string | null;
		Picture: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Description: string;
		ProfileLink: string;
		FriendshipState: MiaPlaza.LO.Social.FriendshipState;
	}
	export class MemberList
	{
		public static PAGE_SIZE: number = 3;
		public static GetConvertUrl(students: Custom.ModelId<'Member'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.MemberList/Convert?students=${MiaPlaza.RoutedHelper.GetParameter(students)}&_=`;
		}
	}
	export class MessageList
	{
		public static PAGE_SIZE: number = 5;
		public static GetConvertUrl(mailboxType: MiaPlaza.Content.MessageListType | MiaPlaza.IPlaceholder, message: Custom.ModelId<'Posting.Message'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.MessageList/Convert?mailboxType=${MiaPlaza.RoutedHelper.GetParameter(mailboxType)}&message=${MiaPlaza.RoutedHelper.GetParameter(message)}&_=`;
		}
		public static GetDeleteMessageUrl(message: Custom.ModelId<'Posting.Message'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.MessageList/DeleteMessage?message=${MiaPlaza.RoutedHelper.GetParameter(message)}&_=`;
		}
		public static GetMarkMessageAsViewedUrl(message: Custom.ModelId<'Posting.Message'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.MessageList/MarkMessageAsViewed?message=${MiaPlaza.RoutedHelper.GetParameter(message)}&_=`;
		}
		public static GetMarkMessageAsStarredUrl(message: Custom.ModelId<'Posting.Message'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.MessageList/MarkMessageAsStarred?message=${MiaPlaza.RoutedHelper.GetParameter(message)}&_=`;
		}
	}
	export interface IMessage
	{
		Subject: string;
		Text: string;
		MemberName: string;
		MemberAvatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		MemberUrl: string;
		Timestamp: string;
		ReplyUrl: string;
		DeleteUrl: string;
		IsNew: boolean;
		IsUnread: boolean;
		DisplayReplyTo: boolean;
		MailboxType: MiaPlaza.Content.MessageListType;
		MessageReadUrl: string;
		IsStarred: boolean;
		ToggleIsStarredUrl: string;
	}
	export class NewspaperArticleList
	{
		public static PAGE_SIZE: number = 3;
		public static GetConvertUrl(entry: Custom.ModelId<'Newspaper.NewspaperArticle'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.NewspaperArticleList/Convert?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
	}
	export interface INewspaperArticle
	{
		Title: string;
		Body: string;
		CreationDate: string;
		ClickUrl: string;
		LinkText: string;
	}
	export class NewspaperPreviewList
	{
		public static PAGE_SIZE: number = 4;
		public static GetConvertUrl(entry: Custom.ModelId<'Newspaper.NewspaperArticle'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.NewspaperPreviewList/Convert?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
	}
	export class TeamList
	{
		public static PAGE_SIZE: number = 5;
		public static GetConvertUrl(entry: Custom.ModelId<'Team'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.TeamList/Convert?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
	}
	export interface ITeam
	{
		TeamName: string;
		TeamUrl: string;
		NumberOfUsers: number;
		IsNew: boolean;
	}
	export class TransactionList
	{
		public static PAGE_SIZE: number = 3;
		public static GetConvertUrl(transaction: Custom.ModelId<'VirtualCurrency.Transaction.ChallengeTransaction' | 'VirtualCurrency.Transaction.GameTransaction' | 'VirtualCurrency.Transaction.NewspaperAdBuyingTransaction' | 'VirtualCurrency.Transaction.NewspaperBuyingTransaction' | 'VirtualCurrency.Transaction.ParentTransaction' | 'VirtualCurrency.Transaction.PostingThumbsUpRewardTransaction' | 'VirtualCurrency.Transaction.PresetTransaction' | 'VirtualCurrency.Transaction.QuestionTutorialVideoTransaction' | 'VirtualCurrency.Transaction.ReturnBoughtItemTransaction' | 'VirtualCurrency.Transaction.RewardAuthorForAdTransaction' | 'VirtualCurrency.Transaction.StreakTransaction' | 'VirtualCurrency.Transaction.TeachingVideoTransaction' | 'VirtualCurrency.Transaction.UserUploadedVideoTransaction' | 'VirtualCurrency.Transaction.VideoTransaction' | 'VirtualCurrency.Transaction.VideoTransactionBase' | 'VirtualCurrency.Transaction.VirtualCurrencyTransaction'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.TransactionList/Convert?transaction=${MiaPlaza.RoutedHelper.GetParameter(transaction)}&_=`;
		}
	}
	export interface ITransaction
	{
		Picture: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Time: string;
		Text: string;
	}
	export class AdminMemberList
	{
		public static GetConvertUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.AdminMemberList/Convert?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
	}
	export class MedalList
	{
		public static GetMedalsUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.MedalList/GetMedals?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
		public static GetConvertUrl(memberMedal: Custom.ModelId<'Games.MemberMedal'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.MedalList/Convert?memberMedal=${MiaPlaza.RoutedHelper.GetParameter(memberMedal)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Vue.Lists.Searchable {
	export interface IAdminEditableCouponCode
	{
		Code: string;
		Expiration: string;
		Notes: string;
		CouponCodeDiscounts: MiaPlaza.Control.Vue.Lists.Searchable.IAdminEditableCouponCodeDiscount[];
	}
	export interface IAdminEditableCouponCodeDiscount
	{
		Discount: number;
		Product: MiaPlaza.Model.Payments.ProductType;
	}
	export interface ICourseFilteringOptions
	{
		CourseName: string;
		Course: Custom.ModelId<'Curriculum.Course'>;
	}
	export interface ISubjectFilteringOptions
	{
		Subject: MiaPlaza.Model.Subject;
		CourseOptions: MiaPlaza.Control.Vue.Lists.Searchable.ICourseFilteringOptions[];
	}
	export class AdminCouponCodeEditor
	{
		public static GetCouponCodesUrl(expired: boolean | MiaPlaza.IPlaceholder, code: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.Searchable.AdminCouponCodeEditor/GetCouponCodes?expired=${MiaPlaza.RoutedHelper.GetParameter(expired)}&code=${MiaPlaza.RoutedHelper.GetParameter(code)}&_=`;
		}
		public static GetCreateUrl(editableCouponCode: MiaPlaza.Control.Vue.Lists.Searchable.IAdminEditableCouponCode | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.Searchable.AdminCouponCodeEditor/Create?editableCouponCode=${MiaPlaza.RoutedHelper.GetParameter(editableCouponCode)}&_=`;
		}
		public static GetEditUrl(editableCouponCode: MiaPlaza.Control.Vue.Lists.Searchable.IAdminEditableCouponCode | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.Searchable.AdminCouponCodeEditor/Edit?editableCouponCode=${MiaPlaza.RoutedHelper.GetParameter(editableCouponCode)}&_=`;
		}
	}
	export class AdminLostPetSearch
	{
		public static GetLostPetsUrl(memberId: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.Searchable.AdminLostPetSearch/GetLostPets?memberId=${MiaPlaza.RoutedHelper.GetParameter(memberId)}&_=`;
		}
	}
	export class AdminTextResourceSearch
	{
		public static GetTextResourcesUrl(key: string | MiaPlaza.IPlaceholder, text: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.Searchable.AdminTextResourceSearch/GetTextResources?key=${MiaPlaza.RoutedHelper.GetParameter(key)}&text=${MiaPlaza.RoutedHelper.GetParameter(text)}&_=`;
		}
		public static GetCreateEmptyUrl(key: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.Searchable.AdminTextResourceSearch/CreateEmpty?key=${MiaPlaza.RoutedHelper.GetParameter(key)}&_=`;
		}
	}
	export class MemberSearch
	{
		public static GetMembersUrl(searchNameAndCode: string | MiaPlaza.IPlaceholder, searchInterest: string | MiaPlaza.IPlaceholder, group: Custom.ModelId<'Friendslist' | 'Group' | 'Team'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.Searchable.MemberSearch/GetMembers?searchNameAndCode=${MiaPlaza.RoutedHelper.GetParameter(searchNameAndCode)}&searchInterest=${MiaPlaza.RoutedHelper.GetParameter(searchInterest)}&group=${MiaPlaza.RoutedHelper.GetParameter(group)}&_=`;
		}
	}
	export class NewspaperPreviewSearch
	{
		public static GetNewspaperArticlesUrl(newspaperEdition: Custom.ModelId<'Newspaper.NewspaperEdition'> | MiaPlaza.IPlaceholder, newspaperCategory: Custom.ModelId<'Newspaper.NewspaperCategory'> | MiaPlaza.IPlaceholder, search: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.Searchable.NewspaperPreviewSearch/GetNewspaperArticles?newspaperEdition=${MiaPlaza.RoutedHelper.GetParameter(newspaperEdition)}&newspaperCategory=${MiaPlaza.RoutedHelper.GetParameter(newspaperCategory)}&search=${MiaPlaza.RoutedHelper.GetParameter(search)}&_=`;
		}
	}
	export class TeamSearch
	{
		public static GetTeamSuggestionsUrl(search: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Lists.Searchable.TeamSearch/GetTeamSuggestions?search=${MiaPlaza.RoutedHelper.GetParameter(search)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Vue.Navbar {
	export interface IMenuTab
	{
		Title: string;
		Url: string;
		Selected: boolean;
	}
}
export namespace MiaPlaza.Control.Vue.Notifications {
	export interface IBanner extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'Banner';
		Message: string;
		LinkText: string;
		LinkUrl: string;
		Deadline: string;
		SnoozeUrl: string;
		BannerImage: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
	}
	export interface ICurriculumInitialized extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'CurriculumInitialized';
	}
	export interface IIntroductionTutorialVideos extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'IntroductionTutorialVideos';
	}
	export interface IMemberPenalty extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'MemberPenalty';
		SnoozeForHours: number;
		Portal: MiaPlaza.Model.PortalType;
		Reason: string;
		Until: string;
		PenaltyImage: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
	}
	export interface IMiaPrepAnnouncement extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'MiaPrepAnnouncement';
	}
	export interface IMultiplayerGameInvitation extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'MultiplayerGameInvitation';
		HostName: string;
		GameName: string;
		AcceptLink: string;
		DeclineLink: string;
		DeclineWeekLink: string;
	}
	export interface ISessionMessage extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'SessionMessage';
		Type: MiaPlaza.Control.Vue.Notifications.SessionMessageType;
		Message: string;
	}
	export enum SessionMessageType {
		Error = "Error",
		Warning = "Warning",
		Info = "Info",
		Success = "Success"
	}
	export interface ISiteSlowWarning extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'SiteSlowWarning';
		uuid: string;
		SiteSlowWarningState: [MiaPlaza.Control.Vue.Notifications.WarningType,string];
	}
	export enum WarningType {
		None = 0,
		ChildPortal = 1,
		ParentPortal = 2,
		Unauthorized = 4,
		All = 7
	}
	export interface IValidationError extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'ValidationError';
		AffectedControls: string[];
		Message: string;
	}
}
export namespace MiaPlaza.Control.Vue.Notifications.Aki {
	export interface IAkiMessage extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'AkiMessage';
		akiMessageOptions: any;
		LinkText: string;
		LinkUrl: string;
		HasAdditionalCloseButton: boolean;
		Message: string;
		Avatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		IsShownImmediately: boolean;
	}
}
export namespace MiaPlaza.Control.Vue.Notifications.Shared {
	export interface INotification
	{
		Template: string;
		Lifetime: MiaPlaza.Model.Lifetime;
		UniqueIdentifier: string;
		DismissUrl?: string;
	}
	export class PendingNotifications
	{
		public static GetDismissUrl(uniqueIdentifier: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Notifications.Shared.PendingNotifications/Dismiss?uniqueIdentifier=${MiaPlaza.RoutedHelper.GetParameter(uniqueIdentifier)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Vue.Payments {
	export interface IStudentInfo
	{
		Id: number;
		Student: Custom.ModelId<'Member'>;
		Name: string;
		AccountDetailsLink: string;
		MembershipData: MiaPlaza.LO.Memberships.IAdminManageMembershipData;
	}
	export class PaymentRequiresAttentionBanner
	{
		public static GetMarkSubscriptionAsManuallyCancelledUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Payments.PaymentRequiresAttentionBanner/MarkSubscriptionAsManuallyCancelled?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
}
export namespace MiaPlaza.Control.Vue.Stores.Shared {
	export abstract class AjaxHelpers
	{
		public static PLACEHOLDER_CONVERT_ONE: string = `PLH_ONE_`;
		public static PLACEHOLDER_CONVERT_MANY: string = `PLH_MANY_`;
		public static PLACEHOLDER_CONVERT_BULK: string = `PLH_BULK_`;
		public static PLACEHOLDER_LIMIT: string = `PLH_LIMIT_`;
		public static PLACEHOLDER_OFFSET: string = `PLH_OFFSET_`;
		public static GetRangeAsyncUrl(dataUrl: string | MiaPlaza.IPlaceholder, offset: number | MiaPlaza.IPlaceholder, limit: number | MiaPlaza.IPlaceholder, offsetPrecision: MiaPlaza.Collections.Multitude.OffsetPrecision | MiaPlaza.IPlaceholder = MiaPlaza.Collections.Multitude.OffsetPrecision.Unfiltered, limitPrecision: MiaPlaza.Collections.Multitude.LimitPrecision | MiaPlaza.IPlaceholder = MiaPlaza.Collections.Multitude.LimitPrecision.AlmostExact) : string
		{
			return `/Control.Vue.Stores.Shared.AjaxHelpers/GetRangeAsync?dataUrl=${MiaPlaza.RoutedHelper.GetParameter(dataUrl)}&offset=${MiaPlaza.RoutedHelper.GetParameter(offset)}&limit=${MiaPlaza.RoutedHelper.GetParameter(limit)}&offsetPrecision=${MiaPlaza.RoutedHelper.GetParameter(offsetPrecision)}&limitPrecision=${MiaPlaza.RoutedHelper.GetParameter(limitPrecision)}&_=`;
		}
		public static GetConvertAsyncUrl(data: string | MiaPlaza.IPlaceholder, converterUrl: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Control.Vue.Stores.Shared.AjaxHelpers/ConvertAsync?data=${MiaPlaza.RoutedHelper.GetParameter(data)}&converterUrl=${MiaPlaza.RoutedHelper.GetParameter(converterUrl)}&_=`;
		}
	}
	export interface IRangeWithOffset<S>
	{
		Items: S[];
		UnfilteredOffset: number;
		UnfilteredLimit: number;
		TotalCountEstimate: number;
	}
}
export namespace MiaPlaza.Control.Vue.Toggleable {
	export interface IKeyReplacementPair
	{
		Key: string;
		Replacements: any;
	}
}
export namespace MiaPlaza.Control.Vue.Video {
	export interface IUploader
	{
		Name: string;
		Avatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		ProfileUrl: string;
	}
}
export namespace MiaPlaza.Controllers {
	export interface IGiveMoneyResult
	{
		Amount: number;
		Successful: boolean;
	}
	export class AllLessonsController
	{
		public static GetSubjectsUrl() : string
		{
			return "/Controllers.AllLessonsController/GetSubjects?_=";
		}
		public static GetUnitsUrl(subject: MiaPlaza.Model.Subject | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.AllLessonsController/GetUnits?subject=${MiaPlaza.RoutedHelper.GetParameter(subject)}&_=`;
		}
		public static GetLessonsUrl(searchString: string | MiaPlaza.IPlaceholder, subject: MiaPlaza.Model.Subject | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.AllLessonsController/GetLessons?searchString=${MiaPlaza.RoutedHelper.GetParameter(searchString)}&subject=${MiaPlaza.RoutedHelper.GetParameter(subject)}&_=`;
		}
	}
	export class ChildSettingsController
	{
		public static GetToggleDailyVocabularyPracticeUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, enabled: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/ToggleDailyVocabularyPractice?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&enabled=${MiaPlaza.RoutedHelper.GetParameter(enabled)}&_=`;
		}
		public static GetEnableCompetitionAccessUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/EnableCompetitionAccess?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableCompetitionAccessUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/DisableCompetitionAccess?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetEnableSupervisorReportUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/EnableSupervisorReport?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableSupervisorReportUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/DisableSupervisorReport?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetEnableVideosPageUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/EnableVideosPage?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableVideosPageUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/DisableVideosPage?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetAcceptRulesUrl(type: MiaPlaza.Control.Vue.RulesType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/AcceptRules?type=${MiaPlaza.RoutedHelper.GetParameter(type)}&_=`;
		}
		public static GetEnableTextToSpeechSettingUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/EnableTextToSpeechSetting?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableTextToSpeechSettingUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/DisableTextToSpeechSetting?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetToggleTextToSpeechSettingForChildUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/ToggleTextToSpeechSettingForChild?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&_=`;
		}
		public static GetToggleFeedbackSoundUrl() : string
		{
			return "/Controllers.ChildSettingsController/ToggleFeedbackSound?_=";
		}
		public static GetToggleSpeechMarksUrl() : string
		{
			return "/Controllers.ChildSettingsController/ToggleSpeechMarks?_=";
		}
		public static GetSetTtsOnboardingCarouselSeenUrl() : string
		{
			return "/Controllers.ChildSettingsController/SetTtsOnboardingCarouselSeen?_=";
		}
		public static GetSetPdfSplittingOnboardingSeenUrl() : string
		{
			return "/Controllers.ChildSettingsController/SetPdfSplittingOnboardingSeen?_=";
		}
		public static GetSetTextToSpeechVoiceUrl(voice: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/SetTextToSpeechVoice?voice=${MiaPlaza.RoutedHelper.GetParameter(voice)}&_=`;
		}
		public static GetEnableReviewAssessmentAnswersPageUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/EnableReviewAssessmentAnswersPage?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableReviewAssessmentAnswersPageUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ChildSettingsController/DisableReviewAssessmentAnswersPage?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDismissAutoplayControlsTooltipUrl() : string
		{
			return "/Controllers.ChildSettingsController/DismissAutoplayControlsTooltip?_=";
		}
	}
	export class FeatureLevelController
	{
		public static GetSetFeatureLevelUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, featureLevel: MiaPlaza.Model.FeatureAccessLevel | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.FeatureLevelController/SetFeatureLevel?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&featureLevel=${MiaPlaza.RoutedHelper.GetParameter(featureLevel)}&_=`;
		}
	}
	export class VirtualCurrencyController
	{
		public static GetGiveMoneyToCurrentMemberInGameUrl(amount: number | MiaPlaza.IPlaceholder, game: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Game' | 'MultiplayerGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder, textResourceKey: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.VirtualCurrencyController/GiveMoneyToCurrentMemberInGame?amount=${MiaPlaza.RoutedHelper.GetParameter(amount)}&game=${MiaPlaza.RoutedHelper.GetParameter(game)}&textResourceKey=${MiaPlaza.RoutedHelper.GetParameter(textResourceKey)}&_=`;
		}
		public static GetGiveMoneyToChildUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, amount: number | MiaPlaza.IPlaceholder, reason: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.VirtualCurrencyController/GiveMoneyToChild?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&amount=${MiaPlaza.RoutedHelper.GetParameter(amount)}&reason=${MiaPlaza.RoutedHelper.GetParameter(reason)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin {
	export interface IAnswerAttemptStats
	{
		GameId: string;
		GameName: string;
		CorrectRate: string;
		TotalAnswers: string;
	}
	export interface ICustomGame
	{
		CommonIdentifier: string;
		LocalVersion: MiaPlaza.Controllers.Admin.ICustomGameVersion;
		RemoteVersion: MiaPlaza.Controllers.Admin.ICustomGameVersion;
		IsInstalled: boolean;
		LessonLink: string;
		PracticeLink: string;
		AssessmentLink: string;
	}
	export interface ICustomGameVersion
	{
		Number: number;
		Text: string;
	}
	export interface IBuyerData
	{
		Id: number;
		AccountLink: string;
		Firstname: string;
		Lastname: string;
		EMail: string;
		NumberOfChildren: number;
		ChildrenLogins: number;
		PurchaseStatistics: MiaPlaza.LO.Payments.IPurchaseStatistics;
	}
	export interface IGiftCodeGenerationData
	{
		NumberOfCodes: number;
		SelectedMembershipType: MiaPlaza.Model.Payments.ProductType;
		IsGovernmentCode: boolean;
		IsAdminPreApproved: boolean;
		InitialFeatureLevel: MiaPlaza.Model.FeatureAccessLevel;
		MaxFeatureLevel: MiaPlaza.Model.FeatureAccessLevel;
		HasCustomParentEndDate: boolean;
		EndDate: string;
	}
	export interface IActiveModerator
	{
		Moderator: Custom.ModelId<'Member'>;
		Name: string;
		NumberOfLocks: number;
	}
	export interface IAdminProductPrice
	{
		FirstPeriodPrice: number;
		Price: number;
		Start: string;
		End: string;
		Product: string;
	}
	export interface ISpecialUserData
	{
		ProfileLink: string;
		FirstAndLastName: string;
		SpecialUserType: MiaPlaza.Model.SpecialUserType;
		EMail: string;
	}
	export interface ICompetitionLeader
	{
		Name: string;
		ProfileLink: string;
		MoneyEarned: number;
	}
	export interface ICompetitionWinner
	{
		Name: string;
		ProfileLink: string;
		CompetitionDate: string;
		CompetitionType: MiaPlaza.Model.CompetitionType;
		MoneyEarned: number;
		PrizeName: string | null;
	}
	export interface ITopEarner
	{
		Child: Custom.ModelId<'Member'>;
		ChildName: string;
		ChildProfileLink: string;
		VirtualMoney: number;
		EarningsOverPeriod: number;
		CheaterStatus: MiaPlaza.Model.CheaterStatus;
	}
	export interface IVirtualCurrencyTransaction
	{
		DateTime: string;
		Delta: number;
		PreviousAmount: number;
		Type: string;
		Reason: string | null;
	}
	export class AnswerAttemptsController
	{
		public static GetAttemptedGamesUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.AnswerAttemptsController/GetAttemptedGames?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetConvertUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, game: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Game' | 'MultiplayerGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.AnswerAttemptsController/Convert?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&game=${MiaPlaza.RoutedHelper.GetParameter(game)}&_=`;
		}
	}
	export class CourseProgressTransferController
	{
		public static GetExportMemberProgressUrl(memberId: number | MiaPlaza.IPlaceholder, startDate: string | MiaPlaza.IPlaceholder, endDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CourseProgressTransferController/ExportMemberProgress?memberId=${MiaPlaza.RoutedHelper.GetParameter(memberId)}&startDate=${MiaPlaza.RoutedHelper.GetParameter(startDate)}&endDate=${MiaPlaza.RoutedHelper.GetParameter(endDate)}&_=`;
		}
		public static GetPreviewImportMemberProgressUrl(memberId: number | MiaPlaza.IPlaceholder, transferredProgress: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ITransferredCourseProgress | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CourseProgressTransferController/PreviewImportMemberProgress?memberId=${MiaPlaza.RoutedHelper.GetParameter(memberId)}&transferredProgress=${MiaPlaza.RoutedHelper.GetParameter(transferredProgress)}&_=`;
		}
		public static GetImportMemberProgressUrl(memberId: number | MiaPlaza.IPlaceholder, transferredProgress: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ITransferredCourseProgress | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CourseProgressTransferController/ImportMemberProgress?memberId=${MiaPlaza.RoutedHelper.GetParameter(memberId)}&transferredProgress=${MiaPlaza.RoutedHelper.GetParameter(transferredProgress)}&_=`;
		}
	}
	export class CurriculumController
	{
		public static GetAssignAllTasksUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CurriculumController/AssignAllTasks?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
	export class CustomGameController
	{
		public static GetConvertUrl(commonIdentifier: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CustomGameController/Convert?commonIdentifier=${MiaPlaza.RoutedHelper.GetParameter(commonIdentifier)}&_=`;
		}
		public static GetInstallUrl(commonIdentifier: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CustomGameController/Install?commonIdentifier=${MiaPlaza.RoutedHelper.GetParameter(commonIdentifier)}&_=`;
		}
		public static GetUpdateUrl(commonIdentifier: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CustomGameController/Update?commonIdentifier=${MiaPlaza.RoutedHelper.GetParameter(commonIdentifier)}&_=`;
		}
		public static GetInstalledGamesUrl(identifier: string | MiaPlaza.IPlaceholder, upToDate: boolean | MiaPlaza.IPlaceholder, isActive: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CustomGameController/GetInstalledGames?identifier=${MiaPlaza.RoutedHelper.GetParameter(identifier)}&upToDate=${MiaPlaza.RoutedHelper.GetParameter(upToDate)}&isActive=${MiaPlaza.RoutedHelper.GetParameter(isActive)}&_=`;
		}
		public static GetNotInstalledGamesUrl(identifier: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CustomGameController/GetNotInstalledGames?identifier=${MiaPlaza.RoutedHelper.GetParameter(identifier)}&_=`;
		}
	}
	export class DownloadEmailsController
	{
		public static GetBuyersUrl(paymentTypes: MiaPlaza.Model.Payments.ProductType[] | MiaPlaza.IPlaceholder, startTime: string | MiaPlaza.IPlaceholder, endTime: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.DownloadEmailsController/GetBuyers?paymentTypes=${MiaPlaza.RoutedHelper.GetParameter(paymentTypes)}&startTime=${MiaPlaza.RoutedHelper.GetParameter(startTime)}&endTime=${MiaPlaza.RoutedHelper.GetParameter(endTime)}&_=`;
		}
		public static GetConvertBuyerUrl(buyer: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.DownloadEmailsController/ConvertBuyer?buyer=${MiaPlaza.RoutedHelper.GetParameter(buyer)}&_=`;
		}
	}
	export class GiftCodeGeneratorController
	{
		public static GetGenerateUrl(data: MiaPlaza.Controllers.Admin.IGiftCodeGenerationData | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.GiftCodeGeneratorController/Generate?data=${MiaPlaza.RoutedHelper.GetParameter(data)}&_=`;
		}
	}
	export class KlaviyoSynchronizeController
	{
		public static GetSyncParentDataUrl() : string
		{
			return "/Controllers.Admin.KlaviyoSynchronizeController/SyncParentData?_=";
		}
	}
	export class ManageBozoMembersController
	{
		public static GetBozoMembersUrl() : string
		{
			return "/Controllers.Admin.ManageBozoMembersController/GetBozoMembers?_=";
		}
		public static GetRemoveBozoFlagUrl(bozoMember: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.ManageBozoMembersController/RemoveBozoFlag?bozoMember=${MiaPlaza.RoutedHelper.GetParameter(bozoMember)}&_=`;
		}
		public static GetAddBozoFlagUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.ManageBozoMembersController/AddBozoFlag?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetConvertUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.ManageBozoMembersController/Convert?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
	}
	export class MemberController
	{
		public static GetIsMemberOnlineUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.MemberController/IsMemberOnline?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
	}
	export class MembershipController
	{
		public static GetSetLifetimeUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.MembershipController/SetLifetime?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
		public static GetSetExpirationDateUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, day: number | MiaPlaza.IPlaceholder, month: number | MiaPlaza.IPlaceholder, year: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.MembershipController/SetExpirationDate?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&day=${MiaPlaza.RoutedHelper.GetParameter(day)}&month=${MiaPlaza.RoutedHelper.GetParameter(month)}&year=${MiaPlaza.RoutedHelper.GetParameter(year)}&_=`;
		}
		public static GetSetPausedThroughUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, day: number | MiaPlaza.IPlaceholder, month: number | MiaPlaza.IPlaceholder, year: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.MembershipController/SetPausedThrough?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&day=${MiaPlaza.RoutedHelper.GetParameter(day)}&month=${MiaPlaza.RoutedHelper.GetParameter(month)}&year=${MiaPlaza.RoutedHelper.GetParameter(year)}&_=`;
		}
		public static GetSetSubjectsUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, fullCurriculum: boolean | MiaPlaza.IPlaceholder, subjects: MiaPlaza.Model.Subject[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.MembershipController/SetSubjects?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&fullCurriculum=${MiaPlaza.RoutedHelper.GetParameter(fullCurriculum)}&subjects=${MiaPlaza.RoutedHelper.GetParameter(subjects)}&_=`;
		}
		public static GetSetCommunityAccessLevelUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, communityAccessLevel: MiaPlaza.Model.FeatureAccessLevel | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.MembershipController/SetCommunityAccessLevel?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&communityAccessLevel=${MiaPlaza.RoutedHelper.GetParameter(communityAccessLevel)}&_=`;
		}
		public static GetMembershipChangeLogsUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.MembershipController/GetMembershipChangeLogs?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
		public static GetConvertMembershipChangeLogUrl(membershipChangeLog: Custom.ModelId<'Memberships.ChangeLog.MembershipChangeLog'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.MembershipController/ConvertMembershipChangeLog?membershipChangeLog=${MiaPlaza.RoutedHelper.GetParameter(membershipChangeLog)}&_=`;
		}
	}
	export class ModerationController
	{
		public static GetActiveModeratorsUrl() : string
		{
			return "/Controllers.Admin.ModerationController/GetActiveModerators?_=";
		}
		public static GetReleaseModeratorLocksUrl(moderator: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.ModerationController/ReleaseModeratorLocks?moderator=${MiaPlaza.RoutedHelper.GetParameter(moderator)}&_=`;
		}
		public static GetConvertModeratorUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.ModerationController/ConvertModerator?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
	}
	export class PricingController
	{
		public static GetConvertUrl(productPrice: Custom.ModelId<'Payments.Pricing.ProductPrice' | 'Payments.Pricing.RegularPrice' | 'Payments.Pricing.SalePrice'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.PricingController/Convert?productPrice=${MiaPlaza.RoutedHelper.GetParameter(productPrice)}&_=`;
		}
		public static GetRegularPricesUrl(product: MiaPlaza.Model.Payments.ProductType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.PricingController/GetRegularPrices?product=${MiaPlaza.RoutedHelper.GetParameter(product)}&_=`;
		}
		public static GetSalePricesUrl(product: MiaPlaza.Model.Payments.ProductType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.PricingController/GetSalePrices?product=${MiaPlaza.RoutedHelper.GetParameter(product)}&_=`;
		}
		public static GetCreateRegularPriceUrl(product: MiaPlaza.Model.Payments.ProductType | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, firstPeriodPrice: number | MiaPlaza.IPlaceholder, price: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.PricingController/CreateRegularPrice?product=${MiaPlaza.RoutedHelper.GetParameter(product)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&firstPeriodPrice=${MiaPlaza.RoutedHelper.GetParameter(firstPeriodPrice)}&price=${MiaPlaza.RoutedHelper.GetParameter(price)}&_=`;
		}
		public static GetCreateSalePriceUrl(product: MiaPlaza.Model.Payments.ProductType | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder, price: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.PricingController/CreateSalePrice?product=${MiaPlaza.RoutedHelper.GetParameter(product)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&price=${MiaPlaza.RoutedHelper.GetParameter(price)}&_=`;
		}
		public static GetUpdateSalePriceUrl(salePrice: Custom.ModelId<'Payments.Pricing.SalePrice'> | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder, price: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.PricingController/UpdateSalePrice?salePrice=${MiaPlaza.RoutedHelper.GetParameter(salePrice)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&price=${MiaPlaza.RoutedHelper.GetParameter(price)}&_=`;
		}
	}
	export class RoutingAffinityTestController
	{
		public static GetDiscoverInstancesUrl() : string
		{
			return "/Controllers.Admin.RoutingAffinityTestController/DiscoverInstances?_=";
		}
		public static GetCreateTestAffinityUrl() : string
		{
			return "/Controllers.Admin.RoutingAffinityTestController/CreateTestAffinity?_=";
		}
		public static GetResetTestAffinityUrl() : string
		{
			return "/Controllers.Admin.RoutingAffinityTestController/ResetTestAffinity?_=";
		}
	}
	export class SiteSlowWarningController
	{
		public static GetSetWarningTypeUrl(warningType: MiaPlaza.Control.Vue.Notifications.WarningType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.SiteSlowWarningController/SetWarningType?warningType=${MiaPlaza.RoutedHelper.GetParameter(warningType)}&_=`;
		}
	}
	export class SpecialUsersController
	{
		public static GetSpecialUsersUrl(search: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.SpecialUsersController/GetSpecialUsers?search=${MiaPlaza.RoutedHelper.GetParameter(search)}&_=`;
		}
		public static GetConvertSpecialUsersUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.SpecialUsersController/ConvertSpecialUsers?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
		public static GetAddSpecialUserRightsUrl(memberId: number | MiaPlaza.IPlaceholder, specialUserType: MiaPlaza.Model.SpecialUserType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.SpecialUsersController/AddSpecialUserRights?memberId=${MiaPlaza.RoutedHelper.GetParameter(memberId)}&specialUserType=${MiaPlaza.RoutedHelper.GetParameter(specialUserType)}&_=`;
		}
		public static GetRemoveSpecialUserRightsUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.SpecialUsersController/RemoveSpecialUserRights?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
		public static GetChangeSpecialUserRightsUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, specialUserType: MiaPlaza.Model.SpecialUserType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.SpecialUsersController/ChangeSpecialUserRights?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&specialUserType=${MiaPlaza.RoutedHelper.GetParameter(specialUserType)}&_=`;
		}
	}
	export class VirtualCurrencyController
	{
		public static GetGiveMoneyPresetUrl(type: MiaPlaza.Model.VirtualCurrency.Transaction.PresetTransactionType | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, amount: number | MiaPlaza.IPlaceholder, countsAsEarned: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/GiveMoneyPreset?type=${MiaPlaza.RoutedHelper.GetParameter(type)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&amount=${MiaPlaza.RoutedHelper.GetParameter(amount)}&countsAsEarned=${MiaPlaza.RoutedHelper.GetParameter(countsAsEarned)}&_=`;
		}
		public static GetTopEarnersUrl(numberOfMembers: number | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder, cheaterStatus?: MiaPlaza.Model.CheaterStatus | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/GetTopEarners?numberOfMembers=${MiaPlaza.RoutedHelper.GetParameter(numberOfMembers)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&cheaterStatus=${MiaPlaza.RoutedHelper.GetParameter(cheaterStatus)}&_=`;
		}
		public static GetSetCheaterStatusUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, cheaterStatus: MiaPlaza.Model.CheaterStatus | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/SetCheaterStatus?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&cheaterStatus=${MiaPlaza.RoutedHelper.GetParameter(cheaterStatus)}&_=`;
		}
		public static GetVirtualCurrencyTransactionsUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/GetVirtualCurrencyTransactions?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
		public static GetConvertTransactionUrl(transaction: Custom.ModelId<'VirtualCurrency.Transaction.ChallengeTransaction' | 'VirtualCurrency.Transaction.GameTransaction' | 'VirtualCurrency.Transaction.NewspaperAdBuyingTransaction' | 'VirtualCurrency.Transaction.NewspaperBuyingTransaction' | 'VirtualCurrency.Transaction.ParentTransaction' | 'VirtualCurrency.Transaction.PostingThumbsUpRewardTransaction' | 'VirtualCurrency.Transaction.PresetTransaction' | 'VirtualCurrency.Transaction.QuestionTutorialVideoTransaction' | 'VirtualCurrency.Transaction.ReturnBoughtItemTransaction' | 'VirtualCurrency.Transaction.RewardAuthorForAdTransaction' | 'VirtualCurrency.Transaction.StreakTransaction' | 'VirtualCurrency.Transaction.TeachingVideoTransaction' | 'VirtualCurrency.Transaction.UserUploadedVideoTransaction' | 'VirtualCurrency.Transaction.VideoTransaction' | 'VirtualCurrency.Transaction.VideoTransactionBase' | 'VirtualCurrency.Transaction.VirtualCurrencyTransaction'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/ConvertTransaction?transaction=${MiaPlaza.RoutedHelper.GetParameter(transaction)}&_=`;
		}
		public static GetConvertTopEarnerUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/ConvertTopEarner?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetConvertCompetitionWinnerUrl(winner: Custom.ModelId<'CompetitionWinner'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/ConvertCompetitionWinner?winner=${MiaPlaza.RoutedHelper.GetParameter(winner)}&_=`;
		}
		public static GetConvertCompetitionLeaderUrl(virtualMoneyMonthly: Custom.ModelId<'VirtualCurrency.VirtualMoneyMonthly'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/ConvertCompetitionLeader?virtualMoneyMonthly=${MiaPlaza.RoutedHelper.GetParameter(virtualMoneyMonthly)}&_=`;
		}
		public static GetCompetitionWinnersUrl(winnersCount: number | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder, competitionType?: MiaPlaza.Model.CompetitionType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/GetCompetitionWinners?winnersCount=${MiaPlaza.RoutedHelper.GetParameter(winnersCount)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&competitionType=${MiaPlaza.RoutedHelper.GetParameter(competitionType)}&_=`;
		}
		public static GetCompetitionLeadersUrl(limit: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.VirtualCurrencyController/GetCompetitionLeaders?limit=${MiaPlaza.RoutedHelper.GetParameter(limit)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin.CheckpointReports {
	export interface ICheckpointReport
	{
		Uuid: string;
		ReporterName: string;
		ReporterId: number;
		CreatedAt: string;
		SelectedReasonKey: string;
		AdditionalProvidedInfo: string | null;
		ReporterUuid: string;
		OnlineSchoolBaseUrl: string;
	}
	export class CheckpointReportsController
	{
		public static GetReportsUrl(uuid: string | null | MiaPlaza.IPlaceholder, start: string | null | MiaPlaza.IPlaceholder, end: string | null | MiaPlaza.IPlaceholder, studentSearch: string | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CheckpointReports.CheckpointReportsController/GetReports?uuid=${MiaPlaza.RoutedHelper.GetParameter(uuid)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&studentSearch=${MiaPlaza.RoutedHelper.GetParameter(studentSearch)}&_=`;
		}
		public static GetConvertReportsUrl(report: Custom.ModelId<'CheckpointReportProblem'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.CheckpointReports.CheckpointReportsController/ConvertReports?report=${MiaPlaza.RoutedHelper.GetParameter(report)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin.ClassWallet {
	export class ClassWalletInvoiceReportController
	{
		public static GetRenderCSVReportUrl(month: number | MiaPlaza.IPlaceholder, year: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.ClassWallet.ClassWalletInvoiceReportController/RenderCSVReport?month=${MiaPlaza.RoutedHelper.GetParameter(month)}&year=${MiaPlaza.RoutedHelper.GetParameter(year)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin.ContestDataExport {
	export enum ContestTypeFilter {
		Newspaper = "Newspaper",
		Video = "Video"
	}
	export class ContestDataExportController
	{
		public static GetRenderNewspaperContestArticlesCSVUrl(from: string | MiaPlaza.IPlaceholder, to: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.ContestDataExport.ContestDataExportController/RenderNewspaperContestArticlesCSV?from=${MiaPlaza.RoutedHelper.GetParameter(from)}&to=${MiaPlaza.RoutedHelper.GetParameter(to)}&_=`;
		}
		public static GetRenderContestVideosCSVUrl(from: string | MiaPlaza.IPlaceholder, to: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.ContestDataExport.ContestDataExportController/RenderContestVideosCSV?from=${MiaPlaza.RoutedHelper.GetParameter(from)}&to=${MiaPlaza.RoutedHelper.GetParameter(to)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin.FailedSubscriptionPauses {
	export interface IFailedSubscriptionPause
	{
		SubscriptionPause: Custom.ModelId<'Payments.SubscriptionPause'>;
		StudentId: number;
		StudentName: string;
		StudentAccountDetailsLink: string;
		StudentManageMembershipLink: string;
		ParentId: number;
		ParentName: string;
		ParentEmail: string;
		ParentAccountDetailsLink: string;
		BraintreeSubscriptionId: string;
		BraintreeTransactionId: string | null;
		StartDate: string;
		EndDate: string;
		RefundAmount: string;
	}
	export class FailedSubscriptionPauseController
	{
		public static GetFailedPausesUrl(start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.FailedSubscriptionPauses.FailedSubscriptionPauseController/GetFailedPauses?start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetConvertFailedPauseUrl(pause: Custom.ModelId<'Payments.SubscriptionPause'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.FailedSubscriptionPauses.FailedSubscriptionPauseController/ConvertFailedPause?pause=${MiaPlaza.RoutedHelper.GetParameter(pause)}&_=`;
		}
		public static GetMarkResolvedUrl(pause: Custom.ModelId<'Payments.SubscriptionPause'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.FailedSubscriptionPauses.FailedSubscriptionPauseController/MarkResolved?pause=${MiaPlaza.RoutedHelper.GetParameter(pause)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin.LessonFeedback {
	export interface ILessonFeedback
	{
		StudentId: number;
		SubmitDate: string;
		Course: string;
		Unit: string;
		Lesson: string;
		TaskType: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType;
		MinLevel: number | null;
		MaxLevel: number | null;
		Difficulty: number | null;
		Enjoyment: number | null;
		AdditionalFeedback: string | null;
	}
	export class LessonFeedbackController
	{
		public static GetFeedbacksUrl(date: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.LessonFeedback.LessonFeedbackController/GetFeedbacks?date=${MiaPlaza.RoutedHelper.GetParameter(date)}&_=`;
		}
		public static GetConvertLessonFeedbackUrl(lessonFeedback: Custom.ModelId<'Lesson.LessonFeedback'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.LessonFeedback.LessonFeedbackController/ConvertLessonFeedback?lessonFeedback=${MiaPlaza.RoutedHelper.GetParameter(lessonFeedback)}&_=`;
		}
		public static GetRenderCSVReportUrl(date: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.LessonFeedback.LessonFeedbackController/RenderCSVReport?date=${MiaPlaza.RoutedHelper.GetParameter(date)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin.Moderation {
	export interface IChildPenaltyItem
	{
		PenaltyType: string;
		IsActive: boolean;
		CreationDate: string;
		Until: string;
		Reason: MiaPlaza.LO.Moderation.ChildPenaltyReasons.IChildPenaltyReason;
		ChildPenalty: Custom.ModelId<'MemberPenalty.Blacklist' | 'MemberPenalty.Bozo' | 'MemberPenalty.Grounding' | 'MemberPenalty.MemberPenalty'>;
	}
	export abstract class ChildPenaltiesController
	{
		public static GetChildPenaltiesUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.Moderation.ChildPenaltiesController/GetChildPenalties?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
		public static GetDeactivateChildPenaltyUrl(childPenalty: Custom.ModelId<'MemberPenalty.Blacklist' | 'MemberPenalty.Bozo' | 'MemberPenalty.Grounding' | 'MemberPenalty.MemberPenalty'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.Moderation.ChildPenaltiesController/DeactivateChildPenalty?childPenalty=${MiaPlaza.RoutedHelper.GetParameter(childPenalty)}&_=`;
		}
		public static GetUpdateChildPenaltyUrl(childPenalty: Custom.ModelId<'MemberPenalty.Blacklist' | 'MemberPenalty.Bozo' | 'MemberPenalty.Grounding' | 'MemberPenalty.MemberPenalty'> | MiaPlaza.IPlaceholder, until: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.Moderation.ChildPenaltiesController/UpdateChildPenalty?childPenalty=${MiaPlaza.RoutedHelper.GetParameter(childPenalty)}&until=${MiaPlaza.RoutedHelper.GetParameter(until)}&_=`;
		}
		public static GetCreateGroundingChildPenaltyUrl(reasonText: string | MiaPlaza.IPlaceholder, until: string | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.Moderation.ChildPenaltiesController/CreateGroundingChildPenalty?reasonText=${MiaPlaza.RoutedHelper.GetParameter(reasonText)}&until=${MiaPlaza.RoutedHelper.GetParameter(until)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetSendEmailToParentUrl(reasonText: string | MiaPlaza.IPlaceholder, until: string | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.Moderation.ChildPenaltiesController/SendEmailToParent?reasonText=${MiaPlaza.RoutedHelper.GetParameter(reasonText)}&until=${MiaPlaza.RoutedHelper.GetParameter(until)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetConvertUrl(childPenalty: Custom.ModelId<'MemberPenalty.Blacklist' | 'MemberPenalty.Bozo' | 'MemberPenalty.Grounding' | 'MemberPenalty.MemberPenalty'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.Moderation.ChildPenaltiesController/Convert?childPenalty=${MiaPlaza.RoutedHelper.GetParameter(childPenalty)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin.Newsletter {
	export class NewsletterController
	{
		public static GetRenderPreviewUrl(subject: string | MiaPlaza.IPlaceholder, salutation: string | MiaPlaza.IPlaceholder, message: string | MiaPlaza.IPlaceholder, unsubscribeLink: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.Newsletter.NewsletterController/RenderPreview?subject=${MiaPlaza.RoutedHelper.GetParameter(subject)}&salutation=${MiaPlaza.RoutedHelper.GetParameter(salutation)}&message=${MiaPlaza.RoutedHelper.GetParameter(message)}&unsubscribeLink=${MiaPlaza.RoutedHelper.GetParameter(unsubscribeLink)}&_=`;
		}
		public static GetShowOnParentPortalUrl(newsletterContent: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.Newsletter.NewsletterController/ShowOnParentPortal?newsletterContent=${MiaPlaza.RoutedHelper.GetParameter(newsletterContent)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin.OnlineSchool {
	export interface IAttendanceData
	{
		MemberUuid: string;
		FirstName: string;
		NameAndLastNameInitial: string;
		IsPublicOnlineSchool: boolean;
		SelectedDateRange: MiaPlaza.Model.PremiumParent.PredefinedDateRangeType | null;
		MaxAttendanceMinutesPerDay: number | null;
	}
	export interface IOnlineSchoolStudent
	{
		UUId: string;
		ChildData: MiaPlaza.LO.OnlineSchool.Models.IChildData;
		ParentData: MiaPlaza.LO.OnlineSchool.Models.IParentData;
		NumberOfUngradedOrMissingCheckpoints: number;
		SapLink: string | null;
		IsActive: boolean;
		EMail: string | null;
		DateOfLastCompletedTask: string | null;
		HasCompleteAccountInfo: boolean;
	}
	export class OnlineSchoolController
	{
		public static GetAddStudentUrl(onlineSchoolStudentInformation: MiaPlaza.LO.OnlineSchool.Models.IOnlineSchoolStudentInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/AddStudent?onlineSchoolStudentInformation=${MiaPlaza.RoutedHelper.GetParameter(onlineSchoolStudentInformation)}&_=`;
		}
		public static GetEditStudentUrl(onlineSchoolStudentInformation: MiaPlaza.LO.OnlineSchool.Models.IOnlineSchoolStudentInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/EditStudent?onlineSchoolStudentInformation=${MiaPlaza.RoutedHelper.GetParameter(onlineSchoolStudentInformation)}&_=`;
		}
		public static GetStudentInformationUrl(childId: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/GetStudentInformation?childId=${MiaPlaza.RoutedHelper.GetParameter(childId)}&_=`;
		}
		public static GetTeachersUrl() : string
		{
			return "/Controllers.Admin.OnlineSchool.OnlineSchoolController/GetTeachers?_=";
		}
		public static GetStudentsUrl(onlineSchoolStudentFilter: MiaPlaza.LO.OnlineSchool.Models.IOnlineSchoolStudentFilter | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/GetStudents?onlineSchoolStudentFilter=${MiaPlaza.RoutedHelper.GetParameter(onlineSchoolStudentFilter)}&_=`;
		}
		public static GetConvertStudentUrl(student: Custom.ModelId<'OnlineSchoolStudent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/ConvertStudent?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
		public static GetActivateOnlineSchoolStudentUrl(student: Custom.ModelId<'OnlineSchoolStudent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/ActivateOnlineSchoolStudent?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
		public static GetDeactivateOnlineSchoolStudentUrl(student: Custom.ModelId<'OnlineSchoolStudent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/DeactivateOnlineSchoolStudent?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
		public static GetSetJoinedDateUrl(student: Custom.ModelId<'OnlineSchoolStudent'> | MiaPlaza.IPlaceholder, joinedDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/SetJoinedDate?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&joinedDate=${MiaPlaza.RoutedHelper.GetParameter(joinedDate)}&_=`;
		}
		public static GetSetLeftDateUrl(student: Custom.ModelId<'OnlineSchoolStudent'> | MiaPlaza.IPlaceholder, leftDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/SetLeftDate?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&leftDate=${MiaPlaza.RoutedHelper.GetParameter(leftDate)}&_=`;
		}
		public static GetRenderCSVReportUrl() : string
		{
			return "/Controllers.Admin.OnlineSchool.OnlineSchoolController/RenderCSVReport?_=";
		}
		public static GetOnlineSchoolGradebookDataUrl(student: Custom.ModelId<'OnlineSchoolStudent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/GetOnlineSchoolGradebookData?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
		public static GetPublicOnlineSchoolGradebookDataUrl(student: Custom.ModelId<'OnlineSchoolStudent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/GetPublicOnlineSchoolGradebookData?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
		public static GetOnlineSchoolCurriculumDataUrl(student: Custom.ModelId<'OnlineSchoolStudent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/GetOnlineSchoolCurriculumData?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
		public static GetOnlineSchoolAttendanceDataUrl(student: Custom.ModelId<'OnlineSchoolStudent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.OnlineSchoolController/GetOnlineSchoolAttendanceData?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
	}
	export class PublicOnlineSchoolController
	{
		public static GetAddPublicStudentUrl(publicOnlineSchoolStudentInformation: MiaPlaza.LO.OnlineSchool.Models.IPublicOnlineSchoolStudentInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.PublicOnlineSchoolController/AddPublicStudent?publicOnlineSchoolStudentInformation=${MiaPlaza.RoutedHelper.GetParameter(publicOnlineSchoolStudentInformation)}&_=`;
		}
		public static GetEditPublicStudentUrl(publicOnlineSchoolStudentInformation: MiaPlaza.LO.OnlineSchool.Models.IPublicOnlineSchoolStudentInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.PublicOnlineSchoolController/EditPublicStudent?publicOnlineSchoolStudentInformation=${MiaPlaza.RoutedHelper.GetParameter(publicOnlineSchoolStudentInformation)}&_=`;
		}
		public static GetPublicStudentInformationUrl(childId: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.OnlineSchool.PublicOnlineSchoolController/GetPublicStudentInformation?childId=${MiaPlaza.RoutedHelper.GetParameter(childId)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Admin.RegisterMember {
	export interface IMemberCredential
	{
		Identifier: string;
		Password: string;
		MemberId: number | null;
	}
	export interface IRegisterMemberData
	{
		Parent: MiaPlaza.LO.Registration.IParentRegistrationData;
		Students: MiaPlaza.LO.Registration.IStudentRegistrationData[];
		ExistingParentId: number | null;
	}
	export interface IRegisterMemberResult
	{
		Success: boolean;
		ErrorMessage: string;
		Credentials: MiaPlaza.Controllers.Admin.RegisterMember.IMemberCredential[];
	}
	export class RegisterMemberController
	{
		public static GetSubmitUrl(data: MiaPlaza.Controllers.Admin.RegisterMember.IRegisterMemberData | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Admin.RegisterMember.RegisterMemberController/Submit?data=${MiaPlaza.RoutedHelper.GetParameter(data)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Attendance {
	export interface IGetRejectedActivitiesQuery
	{
		AdvisorUuid: string | null;
		SearchTerm: string;
	}
	export abstract class AttendanceReportingController
	{
		public static GetAttendanceUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, startDate: string | MiaPlaza.IPlaceholder, endDate: string | MiaPlaza.IPlaceholder, courseFilter: MiaPlaza.LO.Attendance.Dtos.IAttendanceCourseFilter | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.AttendanceReportingController/GetAttendance?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&startDate=${MiaPlaza.RoutedHelper.GetParameter(startDate)}&endDate=${MiaPlaza.RoutedHelper.GetParameter(endDate)}&courseFilter=${MiaPlaza.RoutedHelper.GetParameter(courseFilter)}&_=`;
		}
		public static GetAttendanceReportByWeeksUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, startDate: string | MiaPlaza.IPlaceholder, endDate: string | MiaPlaza.IPlaceholder, courseFilter: MiaPlaza.LO.Attendance.Dtos.IAttendanceCourseFilter | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.AttendanceReportingController/GetAttendanceReportByWeeks?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&startDate=${MiaPlaza.RoutedHelper.GetParameter(startDate)}&endDate=${MiaPlaza.RoutedHelper.GetParameter(endDate)}&courseFilter=${MiaPlaza.RoutedHelper.GetParameter(courseFilter)}&_=`;
		}
		public static GetAttendanceReportForSerializedDateRangeUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, serializedDateRange: string | MiaPlaza.IPlaceholder, courseFilter: MiaPlaza.LO.Attendance.Dtos.IAttendanceCourseFilter | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.AttendanceReportingController/GetAttendanceReportForSerializedDateRange?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&serializedDateRange=${MiaPlaza.RoutedHelper.GetParameter(serializedDateRange)}&courseFilter=${MiaPlaza.RoutedHelper.GetParameter(courseFilter)}&_=`;
		}
		public static GetAttendanceReportSummaryUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, startDate: string | MiaPlaza.IPlaceholder, endDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.AttendanceReportingController/GetAttendanceReportSummary?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&startDate=${MiaPlaza.RoutedHelper.GetParameter(startDate)}&endDate=${MiaPlaza.RoutedHelper.GetParameter(endDate)}&_=`;
		}
	}
	export class CustomAttendanceActivityController
	{
		public static GetCreateCustomAttendanceActivityAsStudentUrl(activityInformation: MiaPlaza.LO.PremiumParent.ICustomAttendanceActivityInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/CreateCustomAttendanceActivityAsStudent?activityInformation=${MiaPlaza.RoutedHelper.GetParameter(activityInformation)}&_=`;
		}
		public static GetCreateCustomAttendanceActivityAsParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, activityInformation: MiaPlaza.LO.PremiumParent.ICustomAttendanceActivityInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/CreateCustomAttendanceActivityAsParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&activityInformation=${MiaPlaza.RoutedHelper.GetParameter(activityInformation)}&_=`;
		}
		public static GetCreateCustomAttendanceActivityAsTeacherUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, activityInformation: MiaPlaza.LO.PremiumParent.ICustomAttendanceActivityInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/CreateCustomAttendanceActivityAsTeacher?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&activityInformation=${MiaPlaza.RoutedHelper.GetParameter(activityInformation)}&_=`;
		}
		public static GetUpdateCustomAttendanceActivityAsStudentUrl(activity: Custom.ModelId<'Attendance.CustomAttendanceActivity'> | MiaPlaza.IPlaceholder, activityInformation: MiaPlaza.LO.PremiumParent.ICustomAttendanceActivityInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/UpdateCustomAttendanceActivityAsStudent?activity=${MiaPlaza.RoutedHelper.GetParameter(activity)}&activityInformation=${MiaPlaza.RoutedHelper.GetParameter(activityInformation)}&_=`;
		}
		public static GetUpdateCustomAttendanceActivityAsParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, activity: Custom.ModelId<'Attendance.CustomAttendanceActivity'> | MiaPlaza.IPlaceholder, activityInformation: MiaPlaza.LO.PremiumParent.ICustomAttendanceActivityInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/UpdateCustomAttendanceActivityAsParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&activity=${MiaPlaza.RoutedHelper.GetParameter(activity)}&activityInformation=${MiaPlaza.RoutedHelper.GetParameter(activityInformation)}&_=`;
		}
		public static GetUpdateCustomAttendanceActivityAsTeacherUrl(activity: Custom.ModelId<'Attendance.CustomAttendanceActivity'> | MiaPlaza.IPlaceholder, activityInformation: MiaPlaza.LO.PremiumParent.ICustomAttendanceActivityInformation | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/UpdateCustomAttendanceActivityAsTeacher?activity=${MiaPlaza.RoutedHelper.GetParameter(activity)}&activityInformation=${MiaPlaza.RoutedHelper.GetParameter(activityInformation)}&_=`;
		}
		public static GetDeleteOwnCustomAttendanceActivityAsStudentUrl(activity: Custom.ModelId<'Attendance.CustomAttendanceActivity'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/DeleteOwnCustomAttendanceActivityAsStudent?activity=${MiaPlaza.RoutedHelper.GetParameter(activity)}&_=`;
		}
		public static GetDeleteCustomAttendanceActivityAsParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, activity: Custom.ModelId<'Attendance.CustomAttendanceActivity'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/DeleteCustomAttendanceActivityAsParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&activity=${MiaPlaza.RoutedHelper.GetParameter(activity)}&_=`;
		}
		public static GetDeleteCustomAttendanceActivityAsTeacherUrl(activity: Custom.ModelId<'Attendance.CustomAttendanceActivity'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/DeleteCustomAttendanceActivityAsTeacher?activity=${MiaPlaza.RoutedHelper.GetParameter(activity)}&_=`;
		}
		public static GetApproveCustomAttendanceActivitiesUrl(requests: MiaPlaza.LO.PremiumParent.ITeacherReviewRequest[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/ApproveCustomAttendanceActivities?requests=${MiaPlaza.RoutedHelper.GetParameter(requests)}&_=`;
		}
		public static GetRejectCustomAttendanceActivitiesUrl(requests: MiaPlaza.LO.PremiumParent.ITeacherReviewRequest[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/RejectCustomAttendanceActivities?requests=${MiaPlaza.RoutedHelper.GetParameter(requests)}&_=`;
		}
		public static GetRequestClarificationForCustomAttendanceActivitiesUrl(requests: MiaPlaza.LO.PremiumParent.ITeacherReviewRequest[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/RequestClarificationForCustomAttendanceActivities?requests=${MiaPlaza.RoutedHelper.GetParameter(requests)}&_=`;
		}
		public static GetPendingReviewCountUrl() : string
		{
			return "/Controllers.Attendance.CustomAttendanceActivityController/GetPendingReviewCount?_=";
		}
		public static GetPendingReviewSubjectsUrl() : string
		{
			return "/Controllers.Attendance.CustomAttendanceActivityController/GetPendingReviewSubjects?_=";
		}
		public static GetPendingReviewActivitiesUrl(subject: MiaPlaza.Model.Subject | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/GetPendingReviewActivities?subject=${MiaPlaza.RoutedHelper.GetParameter(subject)}&_=`;
		}
		public static GetRejectedActivitiesUrl(query?: MiaPlaza.Controllers.Attendance.IGetRejectedActivitiesQuery | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/GetRejectedActivities?query=${MiaPlaza.RoutedHelper.GetParameter(query)}&_=`;
		}
		public static GetConvertRejectedActivitiesUrl(activity: Custom.ModelId<'Attendance.CustomAttendanceActivity'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/ConvertRejectedActivities?activity=${MiaPlaza.RoutedHelper.GetParameter(activity)}&_=`;
		}
		public static GetPendingReviewActivitiesForStudentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/GetPendingReviewActivitiesForStudent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetActivityTraysForStudentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Attendance.CustomAttendanceActivityController/GetActivityTraysForStudent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.CampaignAccessoryGiveaway {
	export class CampaignAccessoryGiveawayController
	{
		public static GetAwardAccessoriesUrl(accessoryNames: string[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.CampaignAccessoryGiveaway.CampaignAccessoryGiveawayController/AwardAccessories?accessoryNames=${MiaPlaza.RoutedHelper.GetParameter(accessoryNames)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Curriculum {
	export interface IAssignedCourseData extends MiaPlaza.Controllers.Curriculum.ICourseData
	{
		LearningPathTask: MiaPlaza.Controllers.Curriculum.ILearningPathTaskData;
		State: MiaPlaza.LO.CourseState;
		CompletedTasksCount: number;
		TotalTasksCount: number;
	}
	export interface ICourseData
	{
		Title: string;
	}
	export interface ILearningPathTaskData
	{
		TaskType: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType;
		ThumbnailTitle: string;
		Thumbnail: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Icon: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Description: string;
		Link: string;
		ScheduledForToday: boolean;
		CheckpointAssessment: boolean;
	}
	export interface IVocabularyTaskData
	{
		LearningPathTask: MiaPlaza.Controllers.Curriculum.ILearningPathTaskData;
		HasCompletedVocabularyTaskForToday: boolean;
		IsLocked: boolean;
	}
	export interface ILightboxContent<T>
	{
		Content: T;
		Component: string;
		Mode: MiaPlaza.LO.Curriculum.Display.LightboxMode;
	}
	export interface IPracticeAndAssessment
	{
		Version: string;
		AudioSettings: MiaPlaza.LO.Games.IAudioSettings;
		ReviewAssessmentAnswersPageEnabled: boolean | null;
		FreeInput: boolean;
		QuizAssessmentGoalId: number;
	}
	export class LearningPathController
	{
		public static GetCoursesWithTaskAssignmentsUrl() : string
		{
			return "/Controllers.Curriculum.LearningPathController/GetCoursesWithTaskAssignments?_=";
		}
		public static GetCoursesWithCompletedTaskAssignmentsUrl() : string
		{
			return "/Controllers.Curriculum.LearningPathController/GetCoursesWithCompletedTaskAssignments?_=";
		}
		public static GetConvertCourseUrl(course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.LearningPathController/ConvertCourse?course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetBatchConvertAssignedCoursesUrl(courses: Custom.ModelId<'Curriculum.Course'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.LearningPathController/BatchConvertAssignedCourses?courses=${MiaPlaza.RoutedHelper.GetParameter(courses)}&_=`;
		}
		public static GetCompletedTaskAssignmentsUrl(course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.LearningPathController/GetCompletedTaskAssignments?course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetBatchConvertTaskAssignmentsUrl(taskAssignments: Custom.ModelId<'Curriculum.Task.TaskAssignment'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.LearningPathController/BatchConvertTaskAssignments?taskAssignments=${MiaPlaza.RoutedHelper.GetParameter(taskAssignments)}&_=`;
		}
	}
	export class ProgressController
	{
		public static GetDailyAndWeeklyProgressAsStudentUrl() : string
		{
			return "/Controllers.Curriculum.ProgressController/GetDailyAndWeeklyProgressAsStudent?_=";
		}
		public static GetDailyAndWeeklyProgressAsParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.ProgressController/GetDailyAndWeeklyProgressAsParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetYearlyProgressAsStudentUrl() : string
		{
			return "/Controllers.Curriculum.ProgressController/GetYearlyProgressAsStudent?_=";
		}
		public static GetYearlyProgressAsParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.ProgressController/GetYearlyProgressAsParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
	export class TaskPreviewController
	{
		public static GetLightboxVideoPreviewUrl(video: Custom.ModelId<'Video.TeachingVideo'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.TaskPreviewController/GetLightboxVideoPreview?video=${MiaPlaza.RoutedHelper.GetParameter(video)}&_=`;
		}
		public static GetEmbeddedGameContentUrl(url: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.TaskPreviewController/GetEmbeddedGameContent?url=${MiaPlaza.RoutedHelper.GetParameter(url)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Curriculum.Configuration {
	export interface ICourseData
	{
		Title: string;
		Description: string;
		RecommendedGradeMin: number;
		RecommendedGradeMax: number;
		RecommendedLength: number;
		RecommendedSchoolWeekLength: number;
		Enrolled: boolean;
		EnrollmentStatus: MiaPlaza.LO.Curriculum.Configuration.CourseEnrollmentStatus;
		InDevelopment: boolean;
		Credits: number;
	}
	export interface IEnrolledCourseOption
	{
		Course: Custom.ModelId<'Curriculum.Course'>;
		Title: string;
		Subject: MiaPlaza.Model.Subject;
	}
	export interface ICustomBreakData
	{
		Name: string;
		Start: string;
		End: string;
	}
	export interface ILessonData
	{
		Name: string;
		ExplanationParents: string | null;
		Progress: string | null;
		IsTextToSpeechEnabled: boolean;
		CheckpointAssessmentInLesson: boolean;
		IsExcused: boolean;
	}
	export interface INoServiceDayData
	{
		Date: string;
		Name: string;
		IconUrl: string;
		Selected: boolean;
	}
	export interface IPublicHolidayData
	{
		Date: string;
		Selected: boolean;
		Observed: boolean;
	}
	export interface IMedalTaskData extends MiaPlaza.Controllers.Curriculum.Configuration.ITaskData
	{
		MinLevel: number;
		MaxLevel: number;
		GameUuid: string;
	}
	export interface IPdfSplitParentData
	{
		PdfUuid: string;
		Title: string;
		Url: string;
	}
	export interface IQuizAssessmentTaskData extends MiaPlaza.Controllers.Curriculum.Configuration.ITaskData
	{
		PreviewData: MiaPlaza.LO.Curriculum.Display.IPreviewData;
		Progress: string;
	}
	export interface ISupplementalTaskData extends MiaPlaza.Controllers.Curriculum.Configuration.ITaskData
	{
		PreviewData: MiaPlaza.LO.Curriculum.Display.IPreviewData;
		CheckpointAssessment: boolean;
		IsExcused: boolean;
		PdfSplitParent: MiaPlaza.Controllers.Curriculum.Configuration.IPdfSplitParentData;
	}
	export interface ITaskData
	{
		Name: string;
		TaskType: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType;
	}
	export interface ITaskDetailData
	{
		Uuid: string;
		TaskData: MiaPlaza.Controllers.Curriculum.Configuration.ITaskData;
		State: MiaPlaza.Controllers.Curriculum.Models.IAssignableContentData;
	}
	export interface IVideoTaskData extends MiaPlaza.Controllers.Curriculum.Configuration.ITaskData
	{
		PreviewData: MiaPlaza.LO.Curriculum.Display.IPreviewData;
	}
	export interface IAnswerKeysPdfData
	{
		Title: string;
		Url: string;
	}
	export interface ILearningMaterialPdfData
	{
		Title: string;
		Url: string;
		ParentPdfData: MiaPlaza.Controllers.Curriculum.Configuration.IParentPdfData | null;
	}
	export interface ILessonPdfData
	{
		LessonTitle: string;
		AnswerKeysPdfs: MiaPlaza.Controllers.Curriculum.Configuration.IAnswerKeysPdfData[];
		LearningMaterialsPdfs: MiaPlaza.Controllers.Curriculum.Configuration.ILearningMaterialPdfData[];
	}
	export interface IParentPdfData
	{
		PdfUuid: string;
		Title: string;
		Url: string;
	}
	export interface IUnitData
	{
		Title: string;
		LessonPdfs: MiaPlaza.Controllers.Curriculum.Configuration.ILessonPdfData[];
	}
	export interface IVocabularyQuestion
	{
		Word: string;
		Meaning: string;
	}
	export class CourseController
	{
		public static GetCoursesUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, subject: MiaPlaza.Model.Subject | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/GetCourses?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&subject=${MiaPlaza.RoutedHelper.GetParameter(subject)}&_=`;
		}
		public static GetConvertCourseUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/ConvertCourse?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetEnrollUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, inheritAttemptLimit: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/Enroll?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&inheritAttemptLimit=${MiaPlaza.RoutedHelper.GetParameter(inheritAttemptLimit)}&_=`;
		}
		public static GetReenrollUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, inheritAttemptLimit: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/Reenroll?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&inheritAttemptLimit=${MiaPlaza.RoutedHelper.GetParameter(inheritAttemptLimit)}&_=`;
		}
		public static GetStateUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/GetState?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetUnenrollUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/Unenroll?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetFinalizeCoursesUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, courses: Custom.ModelId<'Curriculum.Course'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/FinalizeCourses?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&courses=${MiaPlaza.RoutedHelper.GetParameter(courses)}&_=`;
		}
		public static GetFinalizeCoursesAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, courses: Custom.ModelId<'Curriculum.Course'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/FinalizeCoursesAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&courses=${MiaPlaza.RoutedHelper.GetParameter(courses)}&_=`;
		}
		public static GetHasCourseReadyToFinalizeUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/HasCourseReadyToFinalize?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetHasCourseReadyToFinalizeAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/HasCourseReadyToFinalizeAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetSetAssessmentAttemptLimitUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, attemptLimit: number | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseController/SetAssessmentAttemptLimit?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&attemptLimit=${MiaPlaza.RoutedHelper.GetParameter(attemptLimit)}&_=`;
		}
	}
	export class CourseEnrollmentController
	{
		public static GetEnrolledCoursesUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, subjects: MiaPlaza.Model.Subject[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/GetEnrolledCourses?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&subjects=${MiaPlaza.RoutedHelper.GetParameter(subjects)}&_=`;
		}
		public static GetAllEnrolledCoursesParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/GetAllEnrolledCoursesParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetAllEnrolledCoursesStudentUrl() : string
		{
			return "/Controllers.Curriculum.Configuration.CourseEnrollmentController/GetAllEnrolledCoursesStudent?_=";
		}
		public static GetNumberOfEnrolledCoursesAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/GetNumberOfEnrolledCoursesAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetConvertEnrolledCoursesUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, courses: Custom.ModelId<'Curriculum.Course'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/ConvertEnrolledCourses?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&courses=${MiaPlaza.RoutedHelper.GetParameter(courses)}&_=`;
		}
		public static GetUpdateCourseEnrollmentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder, schoolWeeks: string[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/UpdateCourseEnrollment?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&schoolWeeks=${MiaPlaza.RoutedHelper.GetParameter(schoolWeeks)}&_=`;
		}
		public static GetSetCourseEnrollmentIsRequiredUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, isRequired: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/SetCourseEnrollmentIsRequired?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&isRequired=${MiaPlaza.RoutedHelper.GetParameter(isRequired)}&_=`;
		}
		public static GetSetCourseEnrollmentPassingScorePercentageUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, passingScorePercentage: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/SetCourseEnrollmentPassingScorePercentage?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&passingScorePercentage=${MiaPlaza.RoutedHelper.GetParameter(passingScorePercentage)}&_=`;
		}
		public static GetEditCourseEnrollmentDataUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/GetEditCourseEnrollmentData?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetSetCourseEnrollmentIsFreeInputPreferableUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, isFreeInputPreferable: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/SetCourseEnrollmentIsFreeInputPreferable?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&isFreeInputPreferable=${MiaPlaza.RoutedHelper.GetParameter(isFreeInputPreferable)}&_=`;
		}
		public static GetSetCourseAssessmentAttemptLimitUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, assessmentAttemptLimit: number | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/SetCourseAssessmentAttemptLimit?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&assessmentAttemptLimit=${MiaPlaza.RoutedHelper.GetParameter(assessmentAttemptLimit)}&_=`;
		}
		public static GetNumberOfAssessmentsToBeLockedUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, proposedAttemptLimit: number | MiaPlaza.IPlaceholder, course: string | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/GetNumberOfAssessmentsToBeLocked?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&proposedAttemptLimit=${MiaPlaza.RoutedHelper.GetParameter(proposedAttemptLimit)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetCourseEnrollmentStatusUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/GetCourseEnrollmentStatus?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetSetScheduleTypeUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, scheduleType: MiaPlaza.Model.Curriculum.Scheduling.ScheduleType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentController/SetScheduleType?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&scheduleType=${MiaPlaza.RoutedHelper.GetParameter(scheduleType)}&_=`;
		}
	}
	export class CourseEnrollmentShiftsController
	{
		public static GetCourseEnrollmentShiftsWithNewBreakUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentShiftsController/GetCourseEnrollmentShiftsWithNewBreak?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetCourseEnrollmentShiftsWithUpdatedBreakUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, customBreak: Custom.ModelId<'Curriculum.CurriculumChildBreak'> | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentShiftsController/GetCourseEnrollmentShiftsWithUpdatedBreak?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&customBreak=${MiaPlaza.RoutedHelper.GetParameter(customBreak)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetCourseEnrollmentShiftsWithDeletedBreakUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, customBreak: Custom.ModelId<'Curriculum.CurriculumChildBreak'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentShiftsController/GetCourseEnrollmentShiftsWithDeletedBreak?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&customBreak=${MiaPlaza.RoutedHelper.GetParameter(customBreak)}&_=`;
		}
		public static GetCourseEnrollmentShiftsWithIncludedHolidayUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, publicHoliday: MiaPlaza.Model.PublicHoliday | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentShiftsController/GetCourseEnrollmentShiftsWithIncludedHoliday?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&publicHoliday=${MiaPlaza.RoutedHelper.GetParameter(publicHoliday)}&_=`;
		}
		public static GetCourseEnrollmentShiftsWithExcludedHolidayUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, publicHoliday: MiaPlaza.Model.PublicHoliday | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentShiftsController/GetCourseEnrollmentShiftsWithExcludedHoliday?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&publicHoliday=${MiaPlaza.RoutedHelper.GetParameter(publicHoliday)}&_=`;
		}
		public static GetCourseEnrollmentShiftsWithIncludedNoServiceDayUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, date: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentShiftsController/GetCourseEnrollmentShiftsWithIncludedNoServiceDay?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&date=${MiaPlaza.RoutedHelper.GetParameter(date)}&_=`;
		}
		public static GetCourseEnrollmentShiftsWithExcludedNoServiceDayUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, date: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentShiftsController/GetCourseEnrollmentShiftsWithExcludedNoServiceDay?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&date=${MiaPlaza.RoutedHelper.GetParameter(date)}&_=`;
		}
		public static GetShiftCourseEnrollmentsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, courseEnrollmentSchedules: MiaPlaza.LO.Curriculum.Configuration.ICourseEnrollmentShift[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CourseEnrollmentShiftsController/ShiftCourseEnrollments?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&courseEnrollmentSchedules=${MiaPlaza.RoutedHelper.GetParameter(courseEnrollmentSchedules)}&_=`;
		}
	}
	export class CurriculumController
	{
		public static GetSetAssessmentAttemptLimitUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, assessmentAttemptLimit: number | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CurriculumController/SetAssessmentAttemptLimit?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&assessmentAttemptLimit=${MiaPlaza.RoutedHelper.GetParameter(assessmentAttemptLimit)}&_=`;
		}
	}
	export class CustomBreaksController
	{
		public static GetFutureCustomBreaksUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CustomBreaksController/GetFutureCustomBreaks?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetConvertCustomBreakUrl(customBreak: Custom.ModelId<'Curriculum.CurriculumChildBreak'> | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CustomBreaksController/ConvertCustomBreak?customBreak=${MiaPlaza.RoutedHelper.GetParameter(customBreak)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetCreateCustomBreakUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, name: string | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CustomBreaksController/CreateCustomBreak?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&name=${MiaPlaza.RoutedHelper.GetParameter(name)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetUpdateCustomBreakUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, customBreak: Custom.ModelId<'Curriculum.CurriculumChildBreak'> | MiaPlaza.IPlaceholder, name: string | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CustomBreaksController/UpdateCustomBreak?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&customBreak=${MiaPlaza.RoutedHelper.GetParameter(customBreak)}&name=${MiaPlaza.RoutedHelper.GetParameter(name)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetDeleteCustomBreakUrl(customBreak: Custom.ModelId<'Curriculum.CurriculumChildBreak'> | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.CustomBreaksController/DeleteCustomBreak?customBreak=${MiaPlaza.RoutedHelper.GetParameter(customBreak)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
	export class LessonController
	{
		public static GetAssignUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, lesson: Custom.ModelId<'Curriculum.Lesson'> | MiaPlaza.IPlaceholder, reassign: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.LessonController/Assign?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&reassign=${MiaPlaza.RoutedHelper.GetParameter(reassign)}&_=`;
		}
		public static GetUnassignUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, lesson: Custom.ModelId<'Curriculum.Lesson'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.LessonController/Unassign?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&_=`;
		}
		public static GetExcuseAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, lesson: Custom.ModelId<'Curriculum.Lesson'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.LessonController/ExcuseAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&_=`;
		}
		public static GetUnexcuseAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, lesson: Custom.ModelId<'Curriculum.Lesson'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.LessonController/UnexcuseAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&_=`;
		}
		public static GetIsAssignedUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, lesson: Custom.ModelId<'Curriculum.Lesson'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.LessonController/IsAssigned?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&_=`;
		}
		public static GetStateUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, lesson: Custom.ModelId<'Curriculum.Lesson'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.LessonController/GetState?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&_=`;
		}
		public static GetLessonsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, unit: Custom.ModelId<'Unit'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.LessonController/GetLessons?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&unit=${MiaPlaza.RoutedHelper.GetParameter(unit)}&_=`;
		}
		public static GetConvertLessonUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, lesson: Custom.ModelId<'Curriculum.Lesson'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.LessonController/ConvertLesson?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&_=`;
		}
	}
	export class NoServiceDaysController
	{
		public static GetAllUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.NoServiceDaysController/GetAll?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetConvertUrl(date: string | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.NoServiceDaysController/Convert?date=${MiaPlaza.RoutedHelper.GetParameter(date)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetIncludeNoServiceDayUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, date: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.NoServiceDaysController/IncludeNoServiceDay?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&date=${MiaPlaza.RoutedHelper.GetParameter(date)}&_=`;
		}
		public static GetExcludeNoServiceDayUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, date: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.NoServiceDaysController/ExcludeNoServiceDay?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&date=${MiaPlaza.RoutedHelper.GetParameter(date)}&_=`;
		}
	}
	export class PublicHolidaysController
	{
		public static GetNamesUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.PublicHolidaysController/GetNames?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetConvertUrl(publicHoliday: MiaPlaza.Model.PublicHoliday | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.PublicHolidaysController/Convert?publicHoliday=${MiaPlaza.RoutedHelper.GetParameter(publicHoliday)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetIncludePublicHolidayUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, publicHoliday: MiaPlaza.Model.PublicHoliday | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.PublicHolidaysController/IncludePublicHoliday?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&publicHoliday=${MiaPlaza.RoutedHelper.GetParameter(publicHoliday)}&_=`;
		}
		public static GetExcludePublicHolidayUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, publicHoliday: MiaPlaza.Model.PublicHoliday | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.PublicHolidaysController/ExcludePublicHoliday?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&publicHoliday=${MiaPlaza.RoutedHelper.GetParameter(publicHoliday)}&_=`;
		}
	}
	export abstract class TaskController
	{
		public static GetAssignUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder, reassign: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/Assign?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&reassign=${MiaPlaza.RoutedHelper.GetParameter(reassign)}&_=`;
		}
		public static GetAssignMultipleUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, tasks: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'>[] | MiaPlaza.IPlaceholder, reassign: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/AssignMultiple?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&tasks=${MiaPlaza.RoutedHelper.GetParameter(tasks)}&reassign=${MiaPlaza.RoutedHelper.GetParameter(reassign)}&_=`;
		}
		public static GetExcuseAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/ExcuseAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetExcuseMultipleAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, tasks: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/ExcuseMultipleAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&tasks=${MiaPlaza.RoutedHelper.GetParameter(tasks)}&_=`;
		}
		public static GetExcuseCheckpointAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/ExcuseCheckpointAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetUnassignUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/Unassign?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetUnassignMultipleUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, tasks: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/UnassignMultiple?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&tasks=${MiaPlaza.RoutedHelper.GetParameter(tasks)}&_=`;
		}
		public static GetUnexcuseAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/UnexcuseAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetUnexcuseMultipleAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, tasks: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/UnexcuseMultipleAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&tasks=${MiaPlaza.RoutedHelper.GetParameter(tasks)}&_=`;
		}
		public static GetIsAssignedUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/IsAssigned?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetStateUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/GetState?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetConvertedTasksUrl(lesson: Custom.ModelId<'Curriculum.Lesson'> | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/GetConvertedTasks?lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetAssignedTasksCountUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/GetAssignedTasksCount?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetAssignedTasksCountByTypeUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/GetAssignedTasksCountByType?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetQuizAssessmentDetailsRedirectUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, lesson: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/QuizAssessmentDetailsRedirect?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&_=`;
		}
		public static GetNumberOfCompletedTasksUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, date: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/GetNumberOfCompletedTasks?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&date=${MiaPlaza.RoutedHelper.GetParameter(date)}&_=`;
		}
		public static GetNumberOfCompletedTasksInRangeUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, startDate: string | MiaPlaza.IPlaceholder, endDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/GetNumberOfCompletedTasksInRange?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&startDate=${MiaPlaza.RoutedHelper.GetParameter(startDate)}&endDate=${MiaPlaza.RoutedHelper.GetParameter(endDate)}&_=`;
		}
		public static GetNumberOfScheduledTasksUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, date: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.TaskController/GetNumberOfScheduledTasks?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&date=${MiaPlaza.RoutedHelper.GetParameter(date)}&_=`;
		}
	}
	export class UnitController
	{
		public static GetAssignUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, unit: Custom.ModelId<'Unit'> | MiaPlaza.IPlaceholder, reassign: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.UnitController/Assign?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&unit=${MiaPlaza.RoutedHelper.GetParameter(unit)}&reassign=${MiaPlaza.RoutedHelper.GetParameter(reassign)}&_=`;
		}
		public static GetExcuseAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, unit: Custom.ModelId<'Unit'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.UnitController/ExcuseAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&unit=${MiaPlaza.RoutedHelper.GetParameter(unit)}&_=`;
		}
		public static GetUnassignUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, unit: Custom.ModelId<'Unit'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.UnitController/Unassign?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&unit=${MiaPlaza.RoutedHelper.GetParameter(unit)}&_=`;
		}
		public static GetUnexcuseAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, unit: Custom.ModelId<'Unit'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.UnitController/UnexcuseAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&unit=${MiaPlaza.RoutedHelper.GetParameter(unit)}&_=`;
		}
		public static GetStateUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, unit: Custom.ModelId<'Unit'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.UnitController/GetState?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&unit=${MiaPlaza.RoutedHelper.GetParameter(unit)}&_=`;
		}
		public static GetUnitsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.UnitController/GetUnits?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetConvertUnitUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, unit: Custom.ModelId<'Unit'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.UnitController/ConvertUnit?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&unit=${MiaPlaza.RoutedHelper.GetParameter(unit)}&_=`;
		}
	}
	export class VocabularyController
	{
		public static GetDailyVocabularyPracticeSettingsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.VocabularyController/GetDailyVocabularyPracticeSettings?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetVocabularyQuestionsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Configuration.VocabularyController/GetVocabularyQuestions?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Curriculum.Enums {
	export enum ProgressStatus {
		None = "None",
		Completed = "Completed"
	}
}
export namespace MiaPlaza.Controllers.Curriculum.Models {
	export interface IAssignableContentData
	{
		IsAssigned: boolean;
		IsCompleted: boolean;
		IsExcused: boolean;
		ContainsExcusedTasks: boolean;
	}
	export interface ICourseAssignmentResult
	{
		GoogleClassroomRosterSync: MiaPlaza.LO.Curriculum.Configuration.GoogleClassroomRoster.GoogleClassroomRosterSyncStatus | null;
	}
	export interface IExcuseResult
	{
		ErrorMessage: string;
		Success: boolean;
	}
}
export namespace MiaPlaza.Controllers.Curriculum.Schedule {
	export interface ISearchTaskAssignmentData extends MiaPlaza.LO.Curriculum.Display.ITaskAssignmentData
	{
		ScheduledDate: string;
		Unit: string;
		Subject: MiaPlaza.Model.Subject;
	}
	export class CalendarController
	{
		public static GetInitialWeeklyDataUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, subject: MiaPlaza.Model.Subject | MiaPlaza.IPlaceholder, weekStart: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Schedule.CalendarController/GetInitialWeeklyData?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&subject=${MiaPlaza.RoutedHelper.GetParameter(subject)}&weekStart=${MiaPlaza.RoutedHelper.GetParameter(weekStart)}&_=`;
		}
	}
	export class DayController
	{
		public static GetConvertManyUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, dates: string[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Schedule.DayController/ConvertMany?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&dates=${MiaPlaza.RoutedHelper.GetParameter(dates)}&_=`;
		}
	}
	export class SearchController
	{
		public static GetTaskAssignmentsOrderedUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, lessonSearch: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Schedule.SearchController/GetTaskAssignmentsOrdered?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&lessonSearch=${MiaPlaza.RoutedHelper.GetParameter(lessonSearch)}&_=`;
		}
		public static GetConvertTaskAssignmentUrl(taskAssignment: Custom.ModelId<'Curriculum.Task.TaskAssignment'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Schedule.SearchController/ConvertTaskAssignment?taskAssignment=${MiaPlaza.RoutedHelper.GetParameter(taskAssignment)}&_=`;
		}
	}
	export class TaskAssignmentController
	{
		public static GetTaskAssignmentsScheduledAtUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, unit: Custom.ModelId<'Unit'> | MiaPlaza.IPlaceholder, scheduledDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Schedule.TaskAssignmentController/GetTaskAssignmentsScheduledAt?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&unit=${MiaPlaza.RoutedHelper.GetParameter(unit)}&scheduledDate=${MiaPlaza.RoutedHelper.GetParameter(scheduledDate)}&_=`;
		}
		public static GetConvertManyUrl(taskAssignments: Custom.ModelId<'Curriculum.Task.TaskAssignment'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Schedule.TaskAssignmentController/ConvertMany?taskAssignments=${MiaPlaza.RoutedHelper.GetParameter(taskAssignments)}&_=`;
		}
	}
	export class UnitController
	{
		public static GetUnitsScheduledAtUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, subject: MiaPlaza.Model.Subject | MiaPlaza.IPlaceholder, scheduledDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Schedule.UnitController/GetUnitsScheduledAt?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&subject=${MiaPlaza.RoutedHelper.GetParameter(subject)}&scheduledDate=${MiaPlaza.RoutedHelper.GetParameter(scheduledDate)}&_=`;
		}
		public static GetConvertManyUrl(units: Custom.ModelId<'Unit'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Curriculum.Schedule.UnitController/ConvertMany?units=${MiaPlaza.RoutedHelper.GetParameter(units)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Gradebook {
	export interface ICheckpointGrade
	{
		Completion: string | null;
		Grade: number | null;
	}
	export interface IGradebookAssignment
	{
		Title: string;
		IsAssessment: boolean;
		HasPassingGrade: boolean;
		TaskCompleted: boolean;
		TaskViewed: boolean;
		ViewedOn: string | null;
		Completion: string | null;
		Grade: number | null;
		Attempts: number | null;
		AttemptLimit: number | null;
		BestAttemptUUId: string | null;
		IsConsideredPassed: boolean | null;
		IsExcused: boolean;
		Course: Custom.ModelId<'Curriculum.Course'>;
		Lesson: Custom.ModelId<'Curriculum.Lesson'>;
		LessonTitle: string;
		IsMissing: boolean;
	}
	export interface IGradebookCourse
	{
		Course: Custom.ModelId<'Curriculum.Course'>;
		Subject: MiaPlaza.Model.Subject;
		Title: string;
		NonZeroGradedCheckpoints: number;
		TotalCheckpoints: number;
		CompletedUngradedCheckpoints: number;
		InDevelopment: boolean;
		Grade: MiaPlaza.LO.Curriculum.ICourseGrade;
		StartDate: string;
		EndDate: string;
		Progress: MiaPlaza.LO.Curriculum.ICourseProgress;
		Credits: number;
		PassingScorePercentage: number | null;
	}
	export interface IGradebookPdfExportCourse
	{
		Course: MiaPlaza.Controllers.Gradebook.IGradebookCourse;
		Assignments: MiaPlaza.Controllers.Gradebook.IGradebookAssignment[];
	}
	export interface IGradebookPdfExportData
	{
		ExportData: MiaPlaza.LO.Gradebook.IGradebookExportData;
		Courses: MiaPlaza.Controllers.Gradebook.IGradebookPdfExportCourse[];
	}
	export interface IQuizAssessmentAttempt
	{
		Finished: string;
		Score: number;
		Passed: boolean;
	}
	export abstract class GradebookController
	{
		public static GetGradebookExportDataParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetGradebookExportDataParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetGradebookPdfExportDataParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetGradebookPdfExportDataParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetCoursesParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetCoursesParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetCoursesChildUrl() : string
		{
			return "/Controllers.Gradebook.GradebookController/GetCoursesChild?_=";
		}
		public static GetFinalizableCoursesParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetFinalizableCoursesParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetFinalizableCoursesAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetFinalizableCoursesAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetFinalizableCoursesChildUrl() : string
		{
			return "/Controllers.Gradebook.GradebookController/GetFinalizableCoursesChild?_=";
		}
		public static GetAssignmentsParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetAssignmentsParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetAssignmentsChildUrl(course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetAssignmentsChild?course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetFinishedQuizAssessmentAttemptsParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetFinishedQuizAssessmentAttemptsParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetFinishedQuizAssessmentAttemptsChildUrl(task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetFinishedQuizAssessmentAttemptsChild?task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetTaskAssignmentsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetTaskAssignments?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetSetTaskReviewUrl(task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, grade: number | MiaPlaza.IPlaceholder, completion: string | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/SetTaskReview?task=${MiaPlaza.RoutedHelper.GetParameter(task)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&grade=${MiaPlaza.RoutedHelper.GetParameter(grade)}&completion=${MiaPlaza.RoutedHelper.GetParameter(completion)}&_=`;
		}
		public static GetTaskReviewUrl(task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/GetTaskReview?task=${MiaPlaza.RoutedHelper.GetParameter(task)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetRemoveTaskReviewUrl(task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/RemoveTaskReview?task=${MiaPlaza.RoutedHelper.GetParameter(task)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetMarkAsMissingUrl(task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder, child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/MarkAsMissing?task=${MiaPlaza.RoutedHelper.GetParameter(task)}&child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetAddExtraAssessmentAttemptsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder, extraAttempts: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/AddExtraAssessmentAttempts?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&task=${MiaPlaza.RoutedHelper.GetParameter(task)}&extraAttempts=${MiaPlaza.RoutedHelper.GetParameter(extraAttempts)}&_=`;
		}
		public static GetConvertCourseParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/ConvertCourseParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetConvertCourseChildUrl(course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/ConvertCourseChild?course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
		public static GetConvertAssessmentAttemptParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, quizAssessmentGoal: Custom.ModelId<'QuizAssessmentGoal'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/ConvertAssessmentAttemptParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&quizAssessmentGoal=${MiaPlaza.RoutedHelper.GetParameter(quizAssessmentGoal)}&_=`;
		}
		public static GetConvertAssessmentAttemptChildUrl(quizAssessmentGoal: Custom.ModelId<'QuizAssessmentGoal'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/ConvertAssessmentAttemptChild?quizAssessmentGoal=${MiaPlaza.RoutedHelper.GetParameter(quizAssessmentGoal)}&_=`;
		}
		public static GetBatchConvertCoursesParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, courses: Custom.ModelId<'Curriculum.Course'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/BatchConvertCoursesParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&courses=${MiaPlaza.RoutedHelper.GetParameter(courses)}&_=`;
		}
		public static GetBatchConvertCoursesChildUrl(courses: Custom.ModelId<'Curriculum.Course'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/BatchConvertCoursesChild?courses=${MiaPlaza.RoutedHelper.GetParameter(courses)}&_=`;
		}
		public static GetBatchConvertAssignmentsParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, tasks: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/BatchConvertAssignmentsParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&tasks=${MiaPlaza.RoutedHelper.GetParameter(tasks)}&_=`;
		}
		public static GetBatchConvertAssignmentsChildUrl(tasks: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Gradebook.GradebookController/BatchConvertAssignmentsChild?tasks=${MiaPlaza.RoutedHelper.GetParameter(tasks)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Identity {
	export abstract class AccountController
	{
		public static GetConnectFacebookUrl(returnUrl: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Identity.AccountController/ConnectFacebook?returnUrl=${MiaPlaza.RoutedHelper.GetParameter(returnUrl)}&_=`;
		}
		public static GetExternalConnectCallbackUrl(returnUrl: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Identity.AccountController/ExternalConnectCallback?returnUrl=${MiaPlaza.RoutedHelper.GetParameter(returnUrl)}&_=`;
		}
		public static GetChildRequestedPasswordResetUrl(firstName: string | MiaPlaza.IPlaceholder, lastNameInitial: string | MiaPlaza.IPlaceholder, parentEmail: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Identity.AccountController/ChildRequestedPasswordReset?firstName=${MiaPlaza.RoutedHelper.GetParameter(firstName)}&lastNameInitial=${MiaPlaza.RoutedHelper.GetParameter(lastNameInitial)}&parentEmail=${MiaPlaza.RoutedHelper.GetParameter(parentEmail)}&_=`;
		}
		public static GetParentRequestedPasswordResetUrl(parentEmail: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Identity.AccountController/ParentRequestedPasswordReset?parentEmail=${MiaPlaza.RoutedHelper.GetParameter(parentEmail)}&_=`;
		}
	}
	export abstract class SignInController
	{
		public static GetSignInWithFacebookUrl(returnUrl: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Identity.SignInController/SignInWithFacebook?returnUrl=${MiaPlaza.RoutedHelper.GetParameter(returnUrl)}&_=`;
		}
		public static GetExternalSignInCallbackUrl(returnUrl: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Identity.SignInController/ExternalSignInCallback?returnUrl=${MiaPlaza.RoutedHelper.GetParameter(returnUrl)}&_=`;
		}
		public static GetExternalAdminSignInCallbackUrl(returnUrl: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Identity.SignInController/ExternalAdminSignInCallback?returnUrl=${MiaPlaza.RoutedHelper.GetParameter(returnUrl)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Lesson {
	export class LessonChildSettingsController
	{
		public static GetToggleDarkModeUrl() : string
		{
			return "/Controllers.Lesson.LessonChildSettingsController/ToggleDarkMode?_=";
		}
		public static GetSelectLessonBackgroundUrl(backgroundId: string | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.LessonChildSettingsController/SelectLessonBackground?backgroundId=${MiaPlaza.RoutedHelper.GetParameter(backgroundId)}&_=`;
		}
		public static GetSetSpeedLimitEnabledUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.LessonChildSettingsController/SetSpeedLimitEnabled?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetSetSpeedLimitDisabledUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.LessonChildSettingsController/SetSpeedLimitDisabled?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetSetHideCorrectAnswersEnabledUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.LessonChildSettingsController/SetHideCorrectAnswersEnabled?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetSetHideCorrectAnswersDisabledUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.LessonChildSettingsController/SetHideCorrectAnswersDisabled?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
	export class LessonController
	{
		public static GetAllowedTasksInLessonUrl(lesson: Custom.ModelId<'Curriculum.Lesson'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.LessonController/GetAllowedTasksInLesson?lesson=${MiaPlaza.RoutedHelper.GetParameter(lesson)}&_=`;
		}
		public static GetBatchConvertTasksUrl(tasks: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.LessonController/BatchConvertTasks?tasks=${MiaPlaza.RoutedHelper.GetParameter(tasks)}&_=`;
		}
		public static GetAssignedLessonInCourseUrl(course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.LessonController/GetAssignedLessonInCourseUrl?course=${MiaPlaza.RoutedHelper.GetParameter(course)}&_=`;
		}
	}
	export class LessonFeedbackController
	{
		public static GetSaveFeedbackUrl(task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder, difficulty: number | null | MiaPlaza.IPlaceholder, enjoyment: number | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.LessonFeedbackController/SaveFeedback?task=${MiaPlaza.RoutedHelper.GetParameter(task)}&difficulty=${MiaPlaza.RoutedHelper.GetParameter(difficulty)}&enjoyment=${MiaPlaza.RoutedHelper.GetParameter(enjoyment)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Lesson.Task {
	export class AssessmentController
	{
		public static GetAssessmentContentUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.AssessmentController/GetAssessmentContent?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&_=`;
		}
		public static GetLastFinishedAssessmentContentUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.AssessmentController/GetLastFinishedAssessmentContent?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&_=`;
		}
		public static GetLastAssessmentRewardUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.AssessmentController/GetLastAssessmentReward?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&_=`;
		}
		public static GetProcessMultipleChoiceAnswersUrl(quizAssessmentGoalId: string | MiaPlaza.IPlaceholder, answers: MiaPlaza.LO.PracticeAndAssessment.Dtos.Answers.IMultipleChoiceAnswer[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.AssessmentController/ProcessMultipleChoiceAnswers?quizAssessmentGoalId=${MiaPlaza.RoutedHelper.GetParameter(quizAssessmentGoalId)}&answers=${MiaPlaza.RoutedHelper.GetParameter(answers)}&_=`;
		}
		public static GetProcessFreeInputAnswersUrl(quizAssessmentGoalId: string | MiaPlaza.IPlaceholder, answers: MiaPlaza.LO.PracticeAndAssessment.Dtos.Answers.IFreeInputAnswer[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.AssessmentController/ProcessFreeInputAnswers?quizAssessmentGoalId=${MiaPlaza.RoutedHelper.GetParameter(quizAssessmentGoalId)}&answers=${MiaPlaza.RoutedHelper.GetParameter(answers)}&_=`;
		}
		public static GetProcessAnswerUrl(game: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder, answeredCorrectly: boolean | MiaPlaza.IPlaceholder, answerId: number | MiaPlaza.IPlaceholder, questionId: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.AssessmentController/ProcessAnswer?game=${MiaPlaza.RoutedHelper.GetParameter(game)}&answeredCorrectly=${MiaPlaza.RoutedHelper.GetParameter(answeredCorrectly)}&answerId=${MiaPlaza.RoutedHelper.GetParameter(answerId)}&questionId=${MiaPlaza.RoutedHelper.GetParameter(questionId)}&_=`;
		}
		public static GetRestartUrl(game: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.AssessmentController/Restart?game=${MiaPlaza.RoutedHelper.GetParameter(game)}&_=`;
		}
		public static GetQuestionDataUrl(game: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.AssessmentController/GetQuestionData?game=${MiaPlaza.RoutedHelper.GetParameter(game)}&_=`;
		}
	}
	export class CheckpointController
	{
		public static GetGoogleClassroomCheckpointDataUrl(task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.CheckpointController/GetGoogleClassroomCheckpointData?task=${MiaPlaza.RoutedHelper.GetParameter(task)}&_=`;
		}
		public static GetReportCheckpointProblemUrl(task: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder, reason: MiaPlaza.Model.CheckpointHelpReason | MiaPlaza.IPlaceholder, moreInfo: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.CheckpointController/ReportCheckpointProblem?task=${MiaPlaza.RoutedHelper.GetParameter(task)}&reason=${MiaPlaza.RoutedHelper.GetParameter(reason)}&moreInfo=${MiaPlaza.RoutedHelper.GetParameter(moreInfo)}&_=`;
		}
	}
	export class PracticeController
	{
		public static GetPracticeContentUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/GetPracticeContent?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&_=`;
		}
		public static GetSetLowerLevelUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/SetLowerLevel?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&_=`;
		}
		public static GetProcessMultipleChoiceAnswersUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder, level: number | MiaPlaza.IPlaceholder, answers: MiaPlaza.LO.PracticeAndAssessment.Dtos.Answers.IMultipleChoiceAnswer[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/ProcessMultipleChoiceAnswers?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&level=${MiaPlaza.RoutedHelper.GetParameter(level)}&answers=${MiaPlaza.RoutedHelper.GetParameter(answers)}&_=`;
		}
		public static GetProcessFreeInputAnswersUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder, level: number | MiaPlaza.IPlaceholder, answers: MiaPlaza.LO.PracticeAndAssessment.Dtos.Answers.IFreeInputAnswer[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/ProcessFreeInputAnswers?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&level=${MiaPlaza.RoutedHelper.GetParameter(level)}&answers=${MiaPlaza.RoutedHelper.GetParameter(answers)}&_=`;
		}
		public static GetProcessAnswerUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder, success: boolean | MiaPlaza.IPlaceholder, questionId: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/ProcessAnswer?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&success=${MiaPlaza.RoutedHelper.GetParameter(success)}&questionId=${MiaPlaza.RoutedHelper.GetParameter(questionId)}&_=`;
		}
		public static GetJumpLevelUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder, levelCount: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/JumpLevel?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&levelCount=${MiaPlaza.RoutedHelper.GetParameter(levelCount)}&_=`;
		}
		public static GetQuestionDataUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/GetQuestionData?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&_=`;
		}
		public static GetHtmlGameUrl(customGame: Custom.ModelId<'CustomFlashGame'> | MiaPlaza.IPlaceholder, medalType: MiaPlaza.Model.Games.MedalType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/GetHtmlGame?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&medalType=${MiaPlaza.RoutedHelper.GetParameter(medalType)}&_=`;
		}
		public static GetRepeatMedalTaskUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder, medalType: MiaPlaza.Model.Games.MedalType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/RepeatMedalTask?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&medalType=${MiaPlaza.RoutedHelper.GetParameter(medalType)}&_=`;
		}
		public static GetGiveTutorialVideoRewardUrl(video: Custom.ModelId<'Video.QuestionTutorialVideo'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.PracticeController/GiveTutorialVideoReward?video=${MiaPlaza.RoutedHelper.GetParameter(video)}&_=`;
		}
	}
	export class SupplementalMaterialController
	{
		public static GetReportSupplementalTaskCompletedUrl(supplementalTask: Custom.ModelId<'Curriculum.Task.SupplementalTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.SupplementalMaterialController/ReportSupplementalTaskCompleted?supplementalTask=${MiaPlaza.RoutedHelper.GetParameter(supplementalTask)}&_=`;
		}
		public static GetReportSupplementalTasksCompletedUrl(supplementalTasks: Custom.ModelId<'Curriculum.Task.SupplementalTask'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.SupplementalMaterialController/ReportSupplementalTasksCompleted?supplementalTasks=${MiaPlaza.RoutedHelper.GetParameter(supplementalTasks)}&_=`;
		}
		public static GetReportSupplementalTaskViewedUrl(supplementalTask: Custom.ModelId<'Curriculum.Task.SupplementalTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.SupplementalMaterialController/ReportSupplementalTaskViewed?supplementalTask=${MiaPlaza.RoutedHelper.GetParameter(supplementalTask)}&_=`;
		}
	}
	export class VideoController
	{
		public static GetReportTeachingVideoAsFullyWatchedUrl(videoTask: Custom.ModelId<'Curriculum.Task.VideoTask'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.VideoController/ReportTeachingVideoAsFullyWatched?videoTask=${MiaPlaza.RoutedHelper.GetParameter(videoTask)}&_=`;
		}
		public static GetGiveVideoRewardUrl(video: Custom.ModelId<'Video.TeachingVideo'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Lesson.Task.VideoController/GiveVideoReward?video=${MiaPlaza.RoutedHelper.GetParameter(video)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Login {
	export class LoginController
	{
		public static GetStoreStudentDataInSessionForForgotPasswordPageUrl(firstName?: string | MiaPlaza.IPlaceholder, lastName?: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Login.LoginController/StoreStudentDataInSessionForForgotPasswordPage?firstName=${MiaPlaza.RoutedHelper.GetParameter(firstName)}&lastName=${MiaPlaza.RoutedHelper.GetParameter(lastName)}&_=`;
		}
		public static GetStoreParentDataInSessionForForgotPasswordPageUrl(email: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Login.LoginController/StoreParentDataInSessionForForgotPasswordPage?email=${MiaPlaza.RoutedHelper.GetParameter(email)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Members {
	export interface IMemberProfileData
	{
		Name: string;
		Picture: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		ProfileLink: string;
	}
	export class FriendController
	{
		public static GetAllFriendsUrl(searchQuery?: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Members.FriendController/GetAllFriends?searchQuery=${MiaPlaza.RoutedHelper.GetParameter(searchQuery)}&_=`;
		}
		public static GetAllBlockedOnesFromCurrentUserUrl(searchQuery?: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Members.FriendController/GetAllBlockedOnesFromCurrentUser?searchQuery=${MiaPlaza.RoutedHelper.GetParameter(searchQuery)}&_=`;
		}
		public static GetRequestFriendshipUrl(toStudent: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Members.FriendController/RequestFriendship?toStudent=${MiaPlaza.RoutedHelper.GetParameter(toStudent)}&_=`;
		}
		public static GetUnfriendMemberUrl(friendToRemove: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Members.FriendController/UnfriendMember?friendToRemove=${MiaPlaza.RoutedHelper.GetParameter(friendToRemove)}&_=`;
		}
		public static GetUnblockMemberUrl(studentToUnblock: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Members.FriendController/UnblockMember?studentToUnblock=${MiaPlaza.RoutedHelper.GetParameter(studentToUnblock)}&_=`;
		}
		public static GetConvertUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Members.FriendController/Convert?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
	}
	export class GradeController
	{
		public static GetChangeVocabularyGradeUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, grade: MiaPlaza.Model.Grades.Grade | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Members.GradeController/ChangeVocabularyGrade?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&grade=${MiaPlaza.RoutedHelper.GetParameter(grade)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.MiaTours {
	export class MemberTourController
	{
		public static GetCreateMemberTourUrl(tour: MiaPlaza.Model.MiaTour.Tour | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.MiaTours.MemberTourController/CreateMemberTour?tour=${MiaPlaza.RoutedHelper.GetParameter(tour)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.MiniMe {
	export class MiniMeClosetController
	{
		public static LEGACY_DESIGNED_ITEM_ID_PREFIX: string = `ii_`;
		public static GetMemberDesignedItemsByClosetCategoryUrl(closetCategory: MiaPlaza.LO.MiniMe.MiniMeClosetService.MiniMeClosetItemCategory | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.MiniMe.MiniMeClosetController/GetMemberDesignedItemsByClosetCategory?closetCategory=${MiaPlaza.RoutedHelper.GetParameter(closetCategory)}&_=`;
		}
		public static GetConvertDesignedItemToMiniMeClosetItemUrl(itemInstance: Custom.ModelId<'Games.MiniWorld.ItemInstance'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.MiniMe.MiniMeClosetController/ConvertDesignedItemToMiniMeClosetItem?itemInstance=${MiaPlaza.RoutedHelper.GetParameter(itemInstance)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.MiniWorld {
	export interface IHouse
	{
		ChildName: string;
		ChildProfileLink: string;
		MiniWorldHouseLink: string;
		ChildAvatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Castle: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
	}
	export class MiniWorldController
	{
		public static GetTopHouseMembersUrl() : string
		{
			return "/Controllers.MiniWorld.MiniWorldController/GetTopHouseMembers?_=";
		}
		public static GetConvertUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.MiniWorld.MiniWorldController/Convert?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
		public static GetUpgradeHouseUrl() : string
		{
			return "/Controllers.MiniWorld.MiniWorldController/UpgradeHouse?_=";
		}
	}
}
export namespace MiaPlaza.Controllers.Moderation {
	export interface IActiveVideoModerator
	{
		Moderator: Custom.ModelId<'Member'>;
		Name: string;
		NumberOfLocks: number;
	}
	export enum ApprovalLevelFilter {
		NotModerated = "NotModerated",
		Moderated = "Moderated",
		Rejected = "Rejected",
		Approved = "Approved",
		InDiscussion = "InDiscussion"
	}
	export interface IUserUploadedVideo
	{
		VideoUrl: string;
		Thumbnail: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		ModerationApproval: MiaPlaza.Model.Video.ApprovalLevel;
		ParentApproval: MiaPlaza.Model.Video.ApprovalLevel;
		UploaderName: string;
		UploaderProfileUrl: string;
		Name: string;
		UploadDate: string;
		HintsForModerator: string;
		ModerationStatusTextResourceKey: string;
		ModerationApprovalComment: string;
		ModerationMessageForParents: string;
		ModerationRejectionReason: string;
		ModeratorRating: MiaPlaza.Model.Video.ModerationRating;
		IsEducational: boolean;
		ApprovedByChild: boolean;
	}
	export interface IUserUploadedVideoResult
	{
		Success: boolean;
		Message: string;
	}
	export class ContentModerationAssignmentController
	{
		public static GetUnmoderatedUserUploadedVideosUrl(childId?: number | MiaPlaza.IPlaceholder, keywords?: string[] | MiaPlaza.IPlaceholder, ascending: boolean | MiaPlaza.IPlaceholder = false, shouldReleaseLock: boolean | MiaPlaza.IPlaceholder = false) : string
		{
			return `/Controllers.Moderation.ContentModerationAssignmentController/GetUnmoderatedUserUploadedVideos?childId=${MiaPlaza.RoutedHelper.GetParameter(childId)}&keywords=${MiaPlaza.RoutedHelper.GetParameter(keywords)}&ascending=${MiaPlaza.RoutedHelper.GetParameter(ascending)}&shouldReleaseLock=${MiaPlaza.RoutedHelper.GetParameter(shouldReleaseLock)}&_=`;
		}
		public static GetActiveVideoModeratorsUrl() : string
		{
			return "/Controllers.Moderation.ContentModerationAssignmentController/GetActiveVideoModerators?_=";
		}
		public static GetReleaseVideoModeratorLocksUrl(moderator: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.ContentModerationAssignmentController/ReleaseVideoModeratorLocks?moderator=${MiaPlaza.RoutedHelper.GetParameter(moderator)}&_=`;
		}
		public static GetIsLockStaleUrl(content: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.ContentModerationAssignmentController/IsLockStale?content=${MiaPlaza.RoutedHelper.GetParameter(content)}&_=`;
		}
		public static GetConvertVideoModeratorUrl(member: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.ContentModerationAssignmentController/ConvertVideoModerator?member=${MiaPlaza.RoutedHelper.GetParameter(member)}&_=`;
		}
	}
	export class UserUploadedVideoController
	{
		public static GetUpdateApprovedUserUploadedVideoByAdminUrl(userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder, moderatorRating: MiaPlaza.Model.Video.ModerationRating | MiaPlaza.IPlaceholder, isEducational: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/UpdateApprovedUserUploadedVideoByAdmin?userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&moderatorRating=${MiaPlaza.RoutedHelper.GetParameter(moderatorRating)}&isEducational=${MiaPlaza.RoutedHelper.GetParameter(isEducational)}&_=`;
		}
		public static GetApproveUserUploadedVideoByAdminUrl(userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder, moderatorRating: MiaPlaza.Model.Video.ModerationRating | MiaPlaza.IPlaceholder, isEducational: boolean | MiaPlaza.IPlaceholder, moderationComment: string | MiaPlaza.IPlaceholder, parentMessage: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/ApproveUserUploadedVideoByAdmin?userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&moderatorRating=${MiaPlaza.RoutedHelper.GetParameter(moderatorRating)}&isEducational=${MiaPlaza.RoutedHelper.GetParameter(isEducational)}&moderationComment=${MiaPlaza.RoutedHelper.GetParameter(moderationComment)}&parentMessage=${MiaPlaza.RoutedHelper.GetParameter(parentMessage)}&_=`;
		}
		public static GetRejectUserUploadedVideoByAdminUrl(userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder, moderationComment: string | MiaPlaza.IPlaceholder, parentMessage: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/RejectUserUploadedVideoByAdmin?userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&moderationComment=${MiaPlaza.RoutedHelper.GetParameter(moderationComment)}&parentMessage=${MiaPlaza.RoutedHelper.GetParameter(parentMessage)}&_=`;
		}
		public static GetPutVideoInDiscussionUrl(userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/PutVideoInDiscussion?userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&_=`;
		}
		public static GetRejectUserUploadedVideoByParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/RejectUserUploadedVideoByParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&_=`;
		}
		public static GetApproveUserUploadedVideoByParentUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/ApproveUserUploadedVideoByParent?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&_=`;
		}
		public static GetParentModeratedVideosUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/GetParentModeratedVideos?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetParentUnmoderatedVideosUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/GetParentUnmoderatedVideos?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetUserUploadedVideosByApprovalLevelUrl(moderatorEmail: string | MiaPlaza.IPlaceholder, childId?: number | MiaPlaza.IPlaceholder, keywords?: string[] | MiaPlaza.IPlaceholder, approvalLevel: MiaPlaza.Controllers.Moderation.ApprovalLevelFilter | MiaPlaza.IPlaceholder = MiaPlaza.Controllers.Moderation.ApprovalLevelFilter.Moderated, ascending: boolean | MiaPlaza.IPlaceholder = false) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/GetUserUploadedVideosByApprovalLevel?moderatorEmail=${MiaPlaza.RoutedHelper.GetParameter(moderatorEmail)}&childId=${MiaPlaza.RoutedHelper.GetParameter(childId)}&keywords=${MiaPlaza.RoutedHelper.GetParameter(keywords)}&approvalLevel=${MiaPlaza.RoutedHelper.GetParameter(approvalLevel)}&ascending=${MiaPlaza.RoutedHelper.GetParameter(ascending)}&_=`;
		}
		public static GetConvertUrl(userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Moderation.UserUploadedVideoController/Convert?userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&_=`;
		}
		public static GetUserUploadedVideosCountDataUrl() : string
		{
			return "/Controllers.Moderation.UserUploadedVideoController/GetUserUploadedVideosCountData?_=";
		}
	}
}
export namespace MiaPlaza.Controllers.Newsletter {
	export class NewsletterController
	{
		public static GetDismissNewsletterUrl(newsletterContent: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Newsletter.NewsletterController/DismissNewsletter?newsletterContent=${MiaPlaza.RoutedHelper.GetParameter(newsletterContent)}&_=`;
		}
		public static GetRenderUrl(newsletterContent: Custom.ModelId<'Newsletter.NewsletterContent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Newsletter.NewsletterController/Render?newsletterContent=${MiaPlaza.RoutedHelper.GetParameter(newsletterContent)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Newspaper {
	export interface INewspaperEditionSidebarItem
	{
		ReleaseDate: string;
		EditionUrl: string;
		IsSelected: boolean;
	}
	export class NewspaperEditionSidebarController
	{
		public static GetEditionsUrl() : string
		{
			return "/Controllers.Newspaper.NewspaperEditionSidebarController/GetEditions?_=";
		}
		public static GetConvertUrl(edition: Custom.ModelId<'Newspaper.NewspaperEdition'> | MiaPlaza.IPlaceholder, selectedEditionId: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Newspaper.NewspaperEditionSidebarController/Convert?edition=${MiaPlaza.RoutedHelper.GetParameter(edition)}&selectedEditionId=${MiaPlaza.RoutedHelper.GetParameter(selectedEditionId)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Parents {
	export interface IConfirmPlanChangeResponse
	{
		ErrorMessage: string;
	}
	export class SubscriptionController
	{
		public static GetPauseUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder, resumeDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Parents.SubscriptionController/Pause?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&resumeDate=${MiaPlaza.RoutedHelper.GetParameter(resumeDate)}&_=`;
		}
		public static GetUnpauseUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Parents.SubscriptionController/Unpause?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&_=`;
		}
		public static GetPlanChangeBillingSummaryUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder, targetSubjects: MiaPlaza.Model.Subject[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Parents.SubscriptionController/GetPlanChangeBillingSummary?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&targetSubjects=${MiaPlaza.RoutedHelper.GetParameter(targetSubjects)}&_=`;
		}
		public static GetApplyPlanChangeCouponUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder, targetSubjects: MiaPlaza.Model.Subject[] | MiaPlaza.IPlaceholder, code: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Parents.SubscriptionController/ApplyPlanChangeCoupon?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&targetSubjects=${MiaPlaza.RoutedHelper.GetParameter(targetSubjects)}&code=${MiaPlaza.RoutedHelper.GetParameter(code)}&_=`;
		}
		public static GetClearPlanChangeCouponUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder, targetSubjects: MiaPlaza.Model.Subject[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Parents.SubscriptionController/ClearPlanChangeCoupon?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&targetSubjects=${MiaPlaza.RoutedHelper.GetParameter(targetSubjects)}&_=`;
		}
		public static GetConfirmPlanChangeUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder, targetSubjects: MiaPlaza.Model.Subject[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Parents.SubscriptionController/ConfirmPlanChange?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&targetSubjects=${MiaPlaza.RoutedHelper.GetParameter(targetSubjects)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Payments {
	export class BraintreeController
	{
		public static CAPTCHA_ACTION_CHECKOUT: string = `CHECKOUT`;
		public static CAPTCHA_ACTION_UPDATE_PAYMENT_METHOD: string = `UPDATE_PAYMENT_METHOD`;
		public static GetCheckoutUrl(paymentProcess: Custom.ModelId<'PayPal.BraintreePaymentProcess' | 'PayPal.ClassWalletPaymentProcess' | 'PayPal.PaymentProcess' | 'PayPal.StateFundedPaymentProcess'> | MiaPlaza.IPlaceholder, paymentMethodNonce: string | MiaPlaza.IPlaceholder, captchaToken: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Payments.BraintreeController/Checkout?paymentProcess=${MiaPlaza.RoutedHelper.GetParameter(paymentProcess)}&paymentMethodNonce=${MiaPlaza.RoutedHelper.GetParameter(paymentMethodNonce)}&captchaToken=${MiaPlaza.RoutedHelper.GetParameter(captchaToken)}&_=`;
		}
		public static GetUpdatePaymentMethodUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder, paymentMethodNonce: string | MiaPlaza.IPlaceholder, captchaToken: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Payments.BraintreeController/UpdatePaymentMethod?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&paymentMethodNonce=${MiaPlaza.RoutedHelper.GetParameter(paymentMethodNonce)}&captchaToken=${MiaPlaza.RoutedHelper.GetParameter(captchaToken)}&_=`;
		}
		public static GetRetryPaymentUrl(subscription: Custom.ModelId<'Payments.Subscription'> | MiaPlaza.IPlaceholder, paymentMethodNonce: string | MiaPlaza.IPlaceholder, captchaToken: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Payments.BraintreeController/RetryPayment?subscription=${MiaPlaza.RoutedHelper.GetParameter(subscription)}&paymentMethodNonce=${MiaPlaza.RoutedHelper.GetParameter(paymentMethodNonce)}&captchaToken=${MiaPlaza.RoutedHelper.GetParameter(captchaToken)}&_=`;
		}
	}
	export interface IRetryPaymentMethodResponse
	{
		ErrorMessage: string;
		PaymentMethod: MiaPlaza.LO.Payments.Display.IPaymentMethodData;
		RedirectUrl: string;
	}
	export interface IUpdatePaymentMethodResponse
	{
		ErrorMessage: string;
		PaymentMethod: MiaPlaza.LO.Payments.Display.IPaymentMethodData;
	}
	export interface IMemberCheckoutInfo
	{
		StudentName: string;
		StudentNameAndLastnameInitial: string;
		BraintreeClientToken: string;
		CaptchaSiteKey: string;
		IsoCountryCode?: string;
	}
	export interface IReceiptData
	{
		ParentName: string;
		ParentEmail: string;
		PaymentDate: string;
		StudentName: string;
		Amount: string;
		Product: string;
		PaymentMethodData: MiaPlaza.LO.Payments.Display.IPaymentMethodData;
	}
	export class CheckoutController
	{
		public static GetMemberCheckoutInfoUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Payments.CheckoutController/GetMemberCheckoutInfo?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
	export class CodeController
	{
		public static CODE_PLACEHOLDER: string = `PLH_code`;
		public static GetApplyCodeUrl(code: string | MiaPlaza.IPlaceholder, hasMembershipPlans: boolean | MiaPlaza.IPlaceholder, receiver?: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, paymentProcess?: Custom.ModelId<'PayPal.BraintreePaymentProcess' | 'PayPal.ClassWalletPaymentProcess' | 'PayPal.PaymentProcess' | 'PayPal.StateFundedPaymentProcess'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Payments.CodeController/ApplyCode?code=${MiaPlaza.RoutedHelper.GetParameter(code)}&hasMembershipPlans=${MiaPlaza.RoutedHelper.GetParameter(hasMembershipPlans)}&receiver=${MiaPlaza.RoutedHelper.GetParameter(receiver)}&paymentProcess=${MiaPlaza.RoutedHelper.GetParameter(paymentProcess)}&_=`;
		}
		public static GetClearCodeUrl() : string
		{
			return "/Controllers.Payments.CodeController/ClearCode?_=";
		}
	}
	export class ReceiptsController
	{
		public static GetConvertPaymentUrl(payment: Custom.ModelId<'Payments.BraintreePayment'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Payments.ReceiptsController/ConvertPayment?payment=${MiaPlaza.RoutedHelper.GetParameter(payment)}&_=`;
		}
		public static GetPaymentsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Payments.ReceiptsController/GetPayments?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Profile {
	export class GuestBookController
	{
		public static GetGuestBookEntriesUrl(owner: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Profile.GuestBookController/GetGuestBookEntries?owner=${MiaPlaza.RoutedHelper.GetParameter(owner)}&_=`;
		}
		public static GetConvertUrl(entry: Custom.ModelId<'GuestBookEntry'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Profile.GuestBookController/Convert?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
		public static GetDeleteUrl(entry: Custom.ModelId<'GuestBookEntry'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Profile.GuestBookController/Delete?entry=${MiaPlaza.RoutedHelper.GetParameter(entry)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Public {
	export interface IPaymentStatusResponse
	{
		Status: string;
	}
	export interface IPricing
	{
		ProductPlans: { [key:string]: MiaPlaza.Controllers.Public.IProductPlan };
		CallToActionProductPlanId?: string;
		DiscountExplanation?: string;
		AppliedCouponCode?: string;
	}
	export interface IProductPlan
	{
		FirstPeriodPrice?: number;
		RegularPrice: number;
		FinalPrice: number;
		FinalMonthlyEquivalentPrice?: number;
	}
	export interface ISubjectData
	{
		Subject: MiaPlaza.Model.Subject;
		Units: string[];
		Video: MiaPlaza.Controllers.Public.IVideoData;
	}
	export interface IVideoData
	{
		VideoSrc: string;
		ThumbnailSrc: string;
	}
	export class ClassWalletController
	{
		public static GetClassWalletOrderUrl(paymentProcessId: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Public.ClassWalletController/ClassWalletOrder?paymentProcessId=${MiaPlaza.RoutedHelper.GetParameter(paymentProcessId)}&_=`;
		}
		public static GetStartRegistrationUrl(request: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Public.ClassWalletController/StartRegistration?request=${MiaPlaza.RoutedHelper.GetParameter(request)}&_=`;
		}
		public static GetCreateClassWalletPaymentProcessForNewStudentUrl(productType: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Public.ClassWalletController/CreateClassWalletPaymentProcessForNewStudent?productType=${MiaPlaza.RoutedHelper.GetParameter(productType)}&_=`;
		}
	}
	export class PricingController
	{
		public static GetPricingUrl() : string
		{
			return "/Controllers.Public.PricingController/GetPricing?_=";
		}
		public static GetClassWalletPricingUrl() : string
		{
			return "/Controllers.Public.PricingController/GetClassWalletPricing?_=";
		}
		public static GetPlanPaymentUrl(productPlanId: string | MiaPlaza.IPlaceholder, selectedSubjects?: string[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Public.PricingController/GetPlanPaymentUrl?productPlanId=${MiaPlaza.RoutedHelper.GetParameter(productPlanId)}&selectedSubjects=${MiaPlaza.RoutedHelper.GetParameter(selectedSubjects)}&_=`;
		}
		public static GetClassWalletConsentUrl(productPlanId: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Public.PricingController/GetClassWalletConsentUrl?productPlanId=${MiaPlaza.RoutedHelper.GetParameter(productPlanId)}&_=`;
		}
	}
	export class SubjectsController
	{
		public static GetSubjectUrl(subject: MiaPlaza.Model.Subject | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Public.SubjectsController/GetSubject?subject=${MiaPlaza.RoutedHelper.GetParameter(subject)}&_=`;
		}
		public static GetSubjectsUrl() : string
		{
			return "/Controllers.Public.SubjectsController/GetSubjects?_=";
		}
	}
}
export namespace MiaPlaza.Controllers.RankedList {
	export interface IListItem
	{
		MemberName: string;
		MemberUrl: string;
		IsCurrentMember: boolean;
		Value: string;
	}
	export interface IListItemWithRank extends MiaPlaza.Controllers.RankedList.IListItem
	{
		Rank: number;
	}
}
export namespace MiaPlaza.Controllers.RankedList.ScoopCompetitionSidebar {
	export class ScoopCompetitionSidebarController
	{
		public static GetCompetitionLeadersUrl() : string
		{
			return "/Controllers.RankedList.ScoopCompetitionSidebar.ScoopCompetitionSidebarController/GetCompetitionLeaders?_=";
		}
		public static GetConvertCompetitionLeadersUrl(moneyMonthly: Custom.ModelId<'VirtualCurrency.VirtualMoneyMonthly'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.RankedList.ScoopCompetitionSidebar.ScoopCompetitionSidebarController/ConvertCompetitionLeaders?moneyMonthly=${MiaPlaza.RoutedHelper.GetParameter(moneyMonthly)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Reporting {
	export abstract class CourseReportController
	{
		public static GetFilteringOptionsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, startDate: string | MiaPlaza.IPlaceholder, endDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Reporting.CourseReportController/GetFilteringOptions?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&startDate=${MiaPlaza.RoutedHelper.GetParameter(startDate)}&endDate=${MiaPlaza.RoutedHelper.GetParameter(endDate)}&_=`;
		}
		public static GetConvertUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, course: Custom.ModelId<'Curriculum.Course'> | MiaPlaza.IPlaceholder, startDate: string | MiaPlaza.IPlaceholder, endDate: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Reporting.CourseReportController/Convert?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&course=${MiaPlaza.RoutedHelper.GetParameter(course)}&startDate=${MiaPlaza.RoutedHelper.GetParameter(startDate)}&endDate=${MiaPlaza.RoutedHelper.GetParameter(endDate)}&_=`;
		}
	}
	export abstract class ReportPrintingController
	{
		public static GetPrintActivityReportPDFUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, startDate: string | MiaPlaza.IPlaceholder, endDate: string | MiaPlaza.IPlaceholder, fullName: string | MiaPlaza.IPlaceholder, includeStudyTime: boolean | MiaPlaza.IPlaceholder, reportItems: MiaPlaza.LO.Curriculum.Display.ICourseReport[] | MiaPlaza.IPlaceholder, coursesToReport: Custom.ModelId<'Curriculum.Course'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Reporting.ReportPrintingController/PrintActivityReportPDF?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&startDate=${MiaPlaza.RoutedHelper.GetParameter(startDate)}&endDate=${MiaPlaza.RoutedHelper.GetParameter(endDate)}&fullName=${MiaPlaza.RoutedHelper.GetParameter(fullName)}&includeStudyTime=${MiaPlaza.RoutedHelper.GetParameter(includeStudyTime)}&reportItems=${MiaPlaza.RoutedHelper.GetParameter(reportItems)}&coursesToReport=${MiaPlaza.RoutedHelper.GetParameter(coursesToReport)}&_=`;
		}
		public static GetPrintActivityReportCSVUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, startDate: string | MiaPlaza.IPlaceholder, endDate: string | MiaPlaza.IPlaceholder, reportItems: MiaPlaza.LO.Curriculum.Display.ICourseReport[] | MiaPlaza.IPlaceholder, coursesToReport: Custom.ModelId<'Curriculum.Course'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Reporting.ReportPrintingController/PrintActivityReportCSV?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&startDate=${MiaPlaza.RoutedHelper.GetParameter(startDate)}&endDate=${MiaPlaza.RoutedHelper.GetParameter(endDate)}&reportItems=${MiaPlaza.RoutedHelper.GetParameter(reportItems)}&coursesToReport=${MiaPlaza.RoutedHelper.GetParameter(coursesToReport)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Settings {
	export class ChildAccessSettingsController
	{
		public static GetEnableGradebookPageUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ChildAccessSettingsController/EnableGradebookPage?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableGradebookPageUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ChildAccessSettingsController/DisableGradebookPage?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetEnableTaskCounterUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ChildAccessSettingsController/EnableTaskCounter?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetEnableUnrestrictedAllLessonAccessUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ChildAccessSettingsController/EnableUnrestrictedAllLessonAccess?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableUnrestrictedAllLessonAccessUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ChildAccessSettingsController/DisableUnrestrictedAllLessonAccess?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableTaskCounterUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ChildAccessSettingsController/DisableTaskCounter?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetEnableStreaksUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ChildAccessSettingsController/EnableStreaks?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableStreaksUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ChildAccessSettingsController/DisableStreaks?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetIsTaskCounterEnabledAdminUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ChildAccessSettingsController/IsTaskCounterEnabledAdmin?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
	export class ParentOnboardingSettingsController
	{
		public static GetSetPdfSplittingOnboardingSeenUrl() : string
		{
			return "/Controllers.Settings.ParentOnboardingSettingsController/SetPdfSplittingOnboardingSeen?_=";
		}
	}
	export class ReportsChildSettingsController
	{
		public static GetEnableAssessmentAttemptNotificationUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ReportsChildSettingsController/EnableAssessmentAttemptNotification?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableAssessmentAttemptNotificationUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ReportsChildSettingsController/DisableAssessmentAttemptNotification?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetSetSendAssessmentAttemptReportsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, maxAssessmentAttemptAmount: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ReportsChildSettingsController/SetSendAssessmentAttemptReports?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&maxAssessmentAttemptAmount=${MiaPlaza.RoutedHelper.GetParameter(maxAssessmentAttemptAmount)}&_=`;
		}
		public static GetEnableNotificationWhenMpgIsNotMetOnFinalAttemptUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ReportsChildSettingsController/EnableNotificationWhenMpgIsNotMetOnFinalAttempt?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetDisableNotificationWhenMpgIsNotMetOnFinalAttemptUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Settings.ReportsChildSettingsController/DisableNotificationWhenMpgIsNotMetOnFinalAttempt?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Shop {
	export interface IMiniWorldDraft
	{
		MiniworldDraft: Custom.ModelId<'MiniworldDraft'>;
		Image: string;
		Name: string;
		RedirectLink: string;
	}
	export interface IDesignTemplateData
	{
		Thumbnail: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Price: number;
		Url: string;
	}
	export interface IShapeData
	{
		Shape: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
	}
	export interface IAuthorData
	{
		Id: Custom.ModelId<'Member'>;
		Name: string;
		Avatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		ProfileUrl: string;
		ShopUrl: string;
		HouseUrl: string;
		CastleType: number;
	}
	export interface IDesignedItemData
	{
		Author: MiaPlaza.Controllers.Shop.IAuthorData;
		Item: Custom.ModelId<'Games.MiniWorld.DesignedItem'>;
		Price: number;
		ProductionCost: number;
		HighestAllowedPrice: number;
		Thumbnail: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		SoldTimes: number;
		Name: string;
		Sale: boolean;
		ItemShopType: MiaPlaza.Control.Games.Shop.PublicShopType;
	}
	export interface IShopWithCustomers
	{
		Name: string;
		Avatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		ProfileUrl: string;
		ShopUrl: string;
		HouseUrl: string;
		NumberOfCustomers: number;
	}
	export class MiniWorldDraftController
	{
		public static GetDraftsUrl() : string
		{
			return "/Controllers.Shop.MiniWorldDraftController/GetDrafts?_=";
		}
		public static GetConvertDraftUrl(draft: Custom.ModelId<'MiniworldDraft'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.MiniWorldDraftController/ConvertDraft?draft=${MiaPlaza.RoutedHelper.GetParameter(draft)}&_=`;
		}
		public static GetDeleteUrl(draft: Custom.ModelId<'MiniworldDraft'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.MiniWorldDraftController/Delete?draft=${MiaPlaza.RoutedHelper.GetParameter(draft)}&_=`;
		}
	}
	export class PrivateShopController
	{
		public static GetShopOwnerNameUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.PrivateShopController/GetShopOwnerName?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetSearchItemsUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, searchLine: string | MiaPlaza.IPlaceholder, shape: string | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.PrivateShopController/GetSearchItems?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&searchLine=${MiaPlaza.RoutedHelper.GetParameter(searchLine)}&shape=${MiaPlaza.RoutedHelper.GetParameter(shape)}&_=`;
		}
		public static GetShoutboxDataUrl(shopOwner: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.PrivateShopController/GetShoutboxData?shopOwner=${MiaPlaza.RoutedHelper.GetParameter(shopOwner)}&_=`;
		}
	}
	export class PublicShopController
	{
		public static GetNewItemsUrl(shopType: MiaPlaza.Control.Games.Shop.PublicShopType | MiaPlaza.IPlaceholder, shape: string | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.PublicShopController/GetNewItems?shopType=${MiaPlaza.RoutedHelper.GetParameter(shopType)}&shape=${MiaPlaza.RoutedHelper.GetParameter(shape)}&_=`;
		}
		public static GetBestSellersItemsUrl(shopType: MiaPlaza.Control.Games.Shop.PublicShopType | MiaPlaza.IPlaceholder, shape: string | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.PublicShopController/GetBestSellersItems?shopType=${MiaPlaza.RoutedHelper.GetParameter(shopType)}&shape=${MiaPlaza.RoutedHelper.GetParameter(shape)}&_=`;
		}
		public static GetSearchItemsUrl(shopType: MiaPlaza.Control.Games.Shop.PublicShopType | MiaPlaza.IPlaceholder, searchLine: string | MiaPlaza.IPlaceholder, shape: string | null | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.PublicShopController/GetSearchItems?shopType=${MiaPlaza.RoutedHelper.GetParameter(shopType)}&searchLine=${MiaPlaza.RoutedHelper.GetParameter(searchLine)}&shape=${MiaPlaza.RoutedHelper.GetParameter(shape)}&_=`;
		}
		public static GetShoutboxDataUrl() : string
		{
			return "/Controllers.Shop.PublicShopController/GetShoutboxData?_=";
		}
	}
	export class ShapeController
	{
		public static GetShapesForPublicShopUrl(shopType: MiaPlaza.Control.Games.Shop.PublicShopType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShapeController/GetShapesForPublicShop?shopType=${MiaPlaza.RoutedHelper.GetParameter(shopType)}&_=`;
		}
		public static GetShapesForTemplateShopUrl(shopType: MiaPlaza.Control.Games.Shop.PublicShopType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShapeController/GetShapesForTemplateShop?shopType=${MiaPlaza.RoutedHelper.GetParameter(shopType)}&_=`;
		}
		public static GetShapesForPrivateShopUrl(owner: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShapeController/GetShapesForPrivateShop?owner=${MiaPlaza.RoutedHelper.GetParameter(owner)}&_=`;
		}
		public static GetShoutboxDataUrl() : string
		{
			return "/Controllers.Shop.ShapeController/GetShoutboxData?_=";
		}
		public static GetConvertShapeUrl(shapeItem: Custom.ModelId<'Games.MiniWorld.Shape'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShapeController/ConvertShape?shapeItem=${MiaPlaza.RoutedHelper.GetParameter(shapeItem)}&_=`;
		}
		public static GetConvertDesignTemplateUrl(shapeItem: Custom.ModelId<'Games.MiniWorld.Shape'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShapeController/ConvertDesignTemplate?shapeItem=${MiaPlaza.RoutedHelper.GetParameter(shapeItem)}&_=`;
		}
	}
	export class ShopController
	{
		public static GetUpdatePriceUrl(item: Custom.ModelId<'Games.MiniWorld.DesignedItem'> | MiaPlaza.IPlaceholder, newPrice: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShopController/UpdatePrice?item=${MiaPlaza.RoutedHelper.GetParameter(item)}&newPrice=${MiaPlaza.RoutedHelper.GetParameter(newPrice)}&_=`;
		}
		public static GetRemoveFromShopUrl(item: Custom.ModelId<'Games.MiniWorld.DesignedItem'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShopController/RemoveFromShop?item=${MiaPlaza.RoutedHelper.GetParameter(item)}&_=`;
		}
		public static GetBuyItemUrl(item: Custom.ModelId<'Games.MiniWorld.DesignedItem'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShopController/BuyItem?item=${MiaPlaza.RoutedHelper.GetParameter(item)}&_=`;
		}
		public static GetConvertItemUrl(item: Custom.ModelId<'Games.MiniWorld.DesignedItem'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShopController/ConvertItem?item=${MiaPlaza.RoutedHelper.GetParameter(item)}&_=`;
		}
		public static GetTopShopOwnersUrl() : string
		{
			return "/Controllers.Shop.ShopController/GetTopShopOwners?_=";
		}
		public static GetConvertShopWithCustomersUrl(shopOwner: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Shop.ShopController/ConvertShopWithCustomers?shopOwner=${MiaPlaza.RoutedHelper.GetParameter(shopOwner)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.ShoutBox {
	export interface IShoutboxLineData
	{
		ShoutboxLine: Custom.ModelId<'ShoutboxLine'>;
		Author: string;
		Text: string;
		ProfileImage: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		ProfileLink: string;
		CreationDate: string;
		CanDelete: boolean;
		CanPublish: boolean;
		CanSetVisibility: boolean;
		IsPublic: boolean;
	}
	export interface ISubmitCommentResult
	{
		Successful: boolean;
		Message: string;
	}
	export class ShoutBoxListController
	{
		public static GetShoutboxLinesUrl(shoutBox: Custom.ModelId<'Shoutboxes.DesignStudioShoutbox' | 'Shoutboxes.GameShoutbox' | 'Shoutboxes.GroupShoutbox' | 'Shoutboxes.MemberCastleShoutbox' | 'Shoutboxes.MemberShopShoutbox' | 'Shoutboxes.NewspaperArticleShoutbox' | 'Shoutboxes.PetWorldShoutbox' | 'Shoutboxes.ShopShoutbox' | 'Shoutboxes.Shoutbox' | 'Shoutboxes.VideoShoutbox'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ShoutBox.ShoutBoxListController/GetShoutboxLines?shoutBox=${MiaPlaza.RoutedHelper.GetParameter(shoutBox)}&_=`;
		}
		public static GetConvertUrl(shoutboxLine: Custom.ModelId<'ShoutboxLine'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ShoutBox.ShoutBoxListController/Convert?shoutboxLine=${MiaPlaza.RoutedHelper.GetParameter(shoutboxLine)}&_=`;
		}
		public static GetDeleteCommentUrl(shoutboxLine: Custom.ModelId<'ShoutboxLine'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ShoutBox.ShoutBoxListController/DeleteComment?shoutboxLine=${MiaPlaza.RoutedHelper.GetParameter(shoutboxLine)}&_=`;
		}
		public static GetPublishCommentUrl(shoutboxLine: Custom.ModelId<'ShoutboxLine'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ShoutBox.ShoutBoxListController/PublishComment?shoutboxLine=${MiaPlaza.RoutedHelper.GetParameter(shoutboxLine)}&_=`;
		}
		public static GetSetVisibilityUrl(shoutboxLine: Custom.ModelId<'ShoutboxLine'> | MiaPlaza.IPlaceholder, isPublic: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ShoutBox.ShoutBoxListController/SetVisibility?shoutboxLine=${MiaPlaza.RoutedHelper.GetParameter(shoutboxLine)}&isPublic=${MiaPlaza.RoutedHelper.GetParameter(isPublic)}&_=`;
		}
		public static GetSubmitCommentUrl(shoutbox: Custom.ModelId<'Shoutboxes.DesignStudioShoutbox' | 'Shoutboxes.GameShoutbox' | 'Shoutboxes.GroupShoutbox' | 'Shoutboxes.MemberCastleShoutbox' | 'Shoutboxes.MemberShopShoutbox' | 'Shoutboxes.NewspaperArticleShoutbox' | 'Shoutboxes.PetWorldShoutbox' | 'Shoutboxes.ShopShoutbox' | 'Shoutboxes.Shoutbox' | 'Shoutboxes.VideoShoutbox'> | MiaPlaza.IPlaceholder, comment: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.ShoutBox.ShoutBoxListController/SubmitComment?shoutbox=${MiaPlaza.RoutedHelper.GetParameter(shoutbox)}&comment=${MiaPlaza.RoutedHelper.GetParameter(comment)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Streaks {
	export class StreakController
	{
		public static GetStreakLeaderboardMembersUrl() : string
		{
			return "/Controllers.Streaks.StreakController/GetStreakLeaderboardMembers?_=";
		}
		public static GetBatchConvertStreakLeaderboardMembersUrl(streaks: Custom.ModelId<'Streaks.MemberStreak'>[] | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Streaks.StreakController/BatchConvertStreakLeaderboardMembers?streaks=${MiaPlaza.RoutedHelper.GetParameter(streaks)}&_=`;
		}
		public static GetSetMemberStreakOnboardedAtUrl() : string
		{
			return "/Controllers.Streaks.StreakController/SetMemberStreakOnboardedAt?_=";
		}
		public static GetSetMemberStreakNotifiedAtUrl() : string
		{
			return "/Controllers.Streaks.StreakController/SetMemberStreakNotifiedAt?_=";
		}
	}
}
export namespace MiaPlaza.Controllers.StudentElections {
	export abstract class StudentElectionsController
	{
		public static GetVoteUrl(courseId: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.StudentElections.StudentElectionsController/Vote?courseId=${MiaPlaza.RoutedHelper.GetParameter(courseId)}&_=`;
		}
		public static GetResetVoteUrl() : string
		{
			return "/Controllers.StudentElections.StudentElectionsController/ResetVote?_=";
		}
	}
}
export namespace MiaPlaza.Controllers.TeamAchievements {
	export interface ITeamAchievements
	{
		TeamName: string;
		TeamProfileLink: string;
		GoldMedals: number;
		SilverMedals: number;
		BronzeMedals: number;
	}
	export class TeamAchievementsController
	{
		public static GetTopTeamsUrl() : string
		{
			return "/Controllers.TeamAchievements.TeamAchievementsController/GetTopTeams?_=";
		}
		public static GetConvertUrl(team: Custom.ModelId<'Team'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.TeamAchievements.TeamAchievementsController/Convert?team=${MiaPlaza.RoutedHelper.GetParameter(team)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.TextToSpeech {
	export class TextToSpeechController
	{
		public static GetTextToSpeechForGameUrl(customGame: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.TextToSpeech.TextToSpeechController/GetTextToSpeechForGame?customGame=${MiaPlaza.RoutedHelper.GetParameter(customGame)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.TimeTracking {
	export abstract class TimeTrackingController
	{
		public static GetSubmitTimeTrackingEventsUrl(timeTrackingEvents: MiaPlaza.LO.TimeTracking.Dtos.ITimeTrackingEventDto[] | MiaPlaza.IPlaceholder, memberUuid: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.TimeTracking.TimeTrackingController/SubmitTimeTrackingEvents?timeTrackingEvents=${MiaPlaza.RoutedHelper.GetParameter(timeTrackingEvents)}&memberUuid=${MiaPlaza.RoutedHelper.GetParameter(memberUuid)}&_=`;
		}
		public static GetSubmitAuditEventsUrl(memberUuid: string | MiaPlaza.IPlaceholder, payload: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.TimeTracking.TimeTrackingController/SubmitAuditEvents?memberUuid=${MiaPlaza.RoutedHelper.GetParameter(memberUuid)}&payload=${MiaPlaza.RoutedHelper.GetParameter(payload)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.TimeTracking.Dtos {
	export interface IUpsertTimeTrackingEventsResult
	{
		FailedEventUuids: string[];
		RejectedEventUuids: string[];
	}
}
export namespace MiaPlaza.Controllers.Tracking {
	export class AmplitudeController
	{
		public static GetSetAmplitudeDataUrl(sessionId: number | MiaPlaza.IPlaceholder, deviceId: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Tracking.AmplitudeController/SetAmplitudeData?sessionId=${MiaPlaza.RoutedHelper.GetParameter(sessionId)}&deviceId=${MiaPlaza.RoutedHelper.GetParameter(deviceId)}&_=`;
		}
	}
}
export namespace MiaPlaza.Controllers.Video {
	export interface IFilmmakerData
	{
		Name: string;
		Avatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		ProfileUrl: string;
	}
	export interface IUploaderData
	{
		Name: string;
		Avatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		ProfileUrl: string;
	}
	export interface IVideoData
	{
		Uploader: MiaPlaza.Controllers.Video.IUploaderData | null;
		AvailableSince: string;
		Thumbnail: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		VideoUrl: string;
		Title: string;
		Duration: string;
		IsNew: boolean;
	}
	export enum VideoFilterType {
		Highlighted = "Highlighted",
		New = "New",
		Popular = "Popular",
		Trending = "Trending",
		MoreVideos = "MoreVideos",
		Random = "Random"
	}
	export class FilmmakerController
	{
		public static GetTopFilmmakersUrl() : string
		{
			return "/Controllers.Video.FilmmakerController/GetTopFilmmakers?_=";
		}
		public static GetConvertFilmmakerUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.FilmmakerController/ConvertFilmmaker?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
	}
	export class UserUploadedVideoController
	{
		public static GetGiveVideoRewardUrl(userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.UserUploadedVideoController/GiveVideoReward?userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&_=`;
		}
		public static GetReportVideoAsFullyWatchedUrl(userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.UserUploadedVideoController/ReportVideoAsFullyWatched?userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&_=`;
		}
		public static GetSetSubtitlesOnUrl(subtitlesOn: boolean | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.UserUploadedVideoController/SetSubtitlesOn?subtitlesOn=${MiaPlaza.RoutedHelper.GetParameter(subtitlesOn)}&_=`;
		}
		public static GetCreateVideoUrl(videoName: string | MiaPlaza.IPlaceholder, hintsForModerator: string | MiaPlaza.IPlaceholder, fileSize: number | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.UserUploadedVideoController/CreateVideo?videoName=${MiaPlaza.RoutedHelper.GetParameter(videoName)}&hintsForModerator=${MiaPlaza.RoutedHelper.GetParameter(hintsForModerator)}&fileSize=${MiaPlaza.RoutedHelper.GetParameter(fileSize)}&_=`;
		}
		public static GetDeleteVideoUrl(videoId: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.UserUploadedVideoController/DeleteVideo?videoId=${MiaPlaza.RoutedHelper.GetParameter(videoId)}&_=`;
		}
	}
	export class VideoListController
	{
		public static GetVideosUrl(kind: MiaPlaza.Controllers.Video.VideoFilterType | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.VideoListController/GetVideos?kind=${MiaPlaza.RoutedHelper.GetParameter(kind)}&_=`;
		}
		public static GetSearchResultsUrl(searchQuery: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.VideoListController/GetSearchResults?searchQuery=${MiaPlaza.RoutedHelper.GetParameter(searchQuery)}&_=`;
		}
		public static GetUserUploadedVideosUrl(child: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.VideoListController/GetUserUploadedVideos?child=${MiaPlaza.RoutedHelper.GetParameter(child)}&_=`;
		}
		public static GetConvertVideoUrl(video: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.VideoListController/ConvertVideo?video=${MiaPlaza.RoutedHelper.GetParameter(video)}&_=`;
		}
	}
	export class VideoWatchController
	{
		public static GetDeleteVideoUrl(userUploadedVideo: Custom.ModelId<'Video.UserUploadedVideo2'> | MiaPlaza.IPlaceholder) : string
		{
			return `/Controllers.Video.VideoWatchController/DeleteVideo?userUploadedVideo=${MiaPlaza.RoutedHelper.GetParameter(userUploadedVideo)}&_=`;
		}
	}
}
export namespace MiaPlaza.Data {
	export enum PortalInstance {
		Girls = "Girls",
		Boys = "Boys"
	}
}
export namespace MiaPlaza.HttpPipeline {
	export interface IFile
	{
	}
}
export namespace MiaPlaza.HttpPipeline.Middlewares {
	export class RoutingMiddleware
	{
		public static POST_DATA_MARKER: string = `__SEE_POST_DATA__`;
		public static MANGLED_ARGUMENT: string = `_=`;
		public static MangledArgumentRegex: {Pattern:string, Options:number};
	}
}
export namespace MiaPlaza.HttpPipeline.Scalable {
	export interface IScalableRouteSnapshot
	{
		Enabled: boolean;
		InspectPostData: boolean;
		ScalablePaths: string[];
		ExcludedPaths: string[];
		UnknownExcludedPaths: string[];
	}
}
export namespace MiaPlaza.Identity.PasswordResetRequestResults {
	export interface IPasswordResetRequestDefaultResult extends MiaPlaza.Identity.PasswordResetRequestResults.IPasswordResetRequestResult
	{
		Title: string;
		Message: string;
	}
	export interface IPasswordResetRequestErrorResult extends MiaPlaza.Identity.PasswordResetRequestResults.IPasswordResetRequestResult
	{
		Title: string;
		Message: string;
	}
	export interface IPasswordResetRequestResult
	{
		Kind: MiaPlaza.Identity.PasswordResetRequestResults.PasswordResetRequestResultKind;
	}
	export enum PasswordResetRequestResultKind {
		Default = "Default",
		Error = "Error",
		ValidationMessage = "ValidationMessage"
	}
	export interface IPasswordResetRequestValidationMessageResult extends MiaPlaza.Identity.PasswordResetRequestResults.IPasswordResetRequestResult
	{
		Message: string;
	}
}
export namespace MiaPlaza.LO {
	export enum CourseState {
		None = "None",
		Required = "Required",
		Locked = "Locked"
	}
	export abstract class GradeName
	{
		public static CARDINAL_PREFIX: string = `GradeCardinalName`;
		public static ORDINAL_PREFIX: string = `GradeOrdinalName`;
		public static VERBOSE_PREFIX: string = `GradeVerboseName`;
		public static VERBOSE_VOCABULARY_PREFIX: string = `GradeVerboseVocabularyName`;
	}
}
export namespace MiaPlaza.LO.Assessment {
	export interface IAssessmentAttemptNotificationSettings
	{
		MaxAssessmentAttemptAmount: number;
		Enabled: boolean;
	}
	export interface IAttemptInfo
	{
		AttemptLimit: number;
		NumberOfAttempts: number;
	}
	export interface IProgressStatistics
	{
		Total: number;
		Correct: number;
		CorrectPercentage: number;
		Wrong: number;
		IsAssessmentPassed: boolean;
	}
}
export namespace MiaPlaza.LO.Attendance {
	export enum AttendanceReportAccess {
		Teacher = "Teacher",
		Parent = "Parent",
		Student = "Student"
	}
}
export namespace MiaPlaza.LO.Attendance.Dtos {
	export enum ActivitySubmitterRole {
		Student = "Student",
		Parent = "Parent",
		Teacher = "Teacher",
		Unknown = "Unknown"
	}
	export interface IAttendanceActivity
	{
		Title: string | null;
		Description: string | null;
		Type: MiaPlaza.LO.Attendance.Dtos.AttendanceActivityType;
		Date: string;
		StartTime: string | null;
		EndTime: string | null;
		DurationExcludingSeconds: string;
		DurationExcludingSecondsText: string;
		Course: MiaPlaza.LO.Attendance.Dtos.IAttendanceActivityCourse | null;
		IsVocabulary: boolean;
		RejectionReason: string | null;
		MeetingName: string | null;
	}
	export interface IAttendanceActivityCourse
	{
		Course: Custom.ModelId<'Curriculum.Course'>;
		Subject: MiaPlaza.Model.Subject;
		Title: string;
	}
	export enum AttendanceActivityType {
		Learning = "Learning",
		ExternalClassroom = "ExternalClassroom",
		Custom = "Custom"
	}
	export interface IAttendanceCourseFilter
	{
		CourseUuids: string[];
		IncludeNoCourse: boolean;
	}
	export interface IAttendanceCourseFilterOption
	{
		CourseUuid: string;
		Title: string;
		Subject: MiaPlaza.Model.Subject;
	}
	export interface IAttendanceCourseFilterOptions
	{
		Courses: MiaPlaza.LO.Attendance.Dtos.IAttendanceCourseFilterOption[];
		HasActivitiesWithoutCourse: boolean;
	}
	export interface IAttendanceReportEntry
	{
		Title: string;
		TotalTime: string;
		DayAttendanceReports: MiaPlaza.LO.Attendance.Dtos.IDayAttendanceReport[];
	}
	export interface IAttendanceReportSummary
	{
		Summary: MiaPlaza.LO.Attendance.Dtos.IAttendanceSummary;
		SubjectTimes: MiaPlaza.LO.Attendance.Dtos.ISubjectLearningTime[];
		CourseFilterOptions: MiaPlaza.LO.Attendance.Dtos.IAttendanceCourseFilterOptions;
	}
	export interface IAttendanceSummary
	{
		LearningDaysCount: number;
		TotalLearningMinutes: number;
	}
	export interface ICustomAttendanceActivity extends MiaPlaza.LO.Attendance.Dtos.IAttendanceActivity
	{
		Activity: Custom.ModelId<'Attendance.CustomAttendanceActivity'>;
		ActivityUuid: string;
		UpdatedAt: string;
		ActivityType: MiaPlaza.Model.Attendance.CustomAttendanceActivityType | null;
		Status: MiaPlaza.LO.Attendance.Dtos.CustomAttendanceActivityStatus;
		CreatedByCurrentUser: boolean;
		SubmittedBy: MiaPlaza.LO.Attendance.Dtos.ActivitySubmitterRole;
		ReviewedBy: string;
		ConfirmedAt: string;
	}
	export enum CustomAttendanceActivityStatus {
		Pending = "Pending",
		Approved = "Approved",
		Rejected = "Rejected",
		NeedsClarification = "NeedsClarification"
	}
	export interface IDailyAndWeeklyProgress
	{
		Daily: MiaPlaza.LO.Attendance.Dtos.IDailyProgress;
		Weekly: MiaPlaza.LO.Attendance.Dtos.IWeeklyProgress;
	}
	export interface IDailyProgress
	{
		ApprovedMinutes: number;
		PendingMinutes: number;
	}
	export interface IDayAttendanceReport
	{
		Day: string;
		Date: string;
		TotalTime: string;
		ExceedsMaxTime: boolean;
		AttendanceActivities: MiaPlaza.LO.Attendance.Dtos.IAttendanceActivity[];
	}
	export interface IExternalClassroomAttendanceActivity extends MiaPlaza.LO.Attendance.Dtos.IAttendanceActivity
	{
	}
	export interface IPendingReviewActivity
	{
		ActivityUuid: string;
		UpdatedAt: string;
		StudentName: string;
		StudentEmail: string | null;
		ParentName: string | null;
		SubmittedBy: MiaPlaza.LO.Attendance.Dtos.ActivitySubmitterRole;
		Course: MiaPlaza.LO.Attendance.Dtos.IAttendanceActivityCourse | null;
		ActivityName: string | null;
		ActivityType: MiaPlaza.Model.Attendance.CustomAttendanceActivityType | null;
		Description: string | null;
		DurationInMinutes: number;
		Date: string;
	}
	export interface IPendingReviewSubjectSummary
	{
		Subject: MiaPlaza.Model.Subject | null;
		PendingCount: number;
	}
	export interface IRejectedActivity
	{
		ActivityName: string | null;
		ActivityType: MiaPlaza.Model.Attendance.CustomAttendanceActivityType | null;
		UpdatedAt: string;
		Course: MiaPlaza.LO.Attendance.Dtos.IAttendanceActivityCourse | null;
		StudentName: string;
		DurationInMinutes: number;
		Date: string;
		ParentName: string | null;
		SubmittedBy: MiaPlaza.LO.Attendance.Dtos.ActivitySubmitterRole;
		ReviewedBy: string | null;
		RejectionReason: string | null;
	}
	export interface IStudentActivityTrays
	{
		Pending: MiaPlaza.LO.Attendance.Dtos.IStudentReviewActivity[];
		Rejected: MiaPlaza.LO.Attendance.Dtos.IStudentReviewActivity[];
	}
	export interface IStudentReviewActivity
	{
		ActivityUuid: string;
		ActivityName: string | null;
		ActivityType: MiaPlaza.Model.Attendance.CustomAttendanceActivityType | null;
		CourseTitle: string | null;
		DurationInMinutes: number;
		Date: string;
	}
	export interface ISubjectLearningTime
	{
		Subject: MiaPlaza.Model.Subject;
		Minutes: number;
	}
	export interface IWeeklyProgress
	{
		ApprovedMinutes: number;
		PendingMinutes: number;
		GoalMinutes: number;
	}
	export interface IYearlyProgress
	{
		CurrentHours: number;
		RequiredHours: number;
		ExpectedByTodayHours: number;
	}
}
export namespace MiaPlaza.LO.ClassWallet.Dtos {
	export interface IClassWalletOrder
	{
		OrderId: string;
		Detail: MiaPlaza.LO.ClassWallet.Dtos.IClassWalletOrderDetail;
	}
	export interface IClassWalletOrderDetail
	{
		Items: MiaPlaza.LO.ClassWallet.Dtos.IClassWalletOrderItem[];
		Shipping: number;
		Tax: number;
	}
	export interface IClassWalletOrderItem
	{
		ItemId: string;
		Description: string;
		Quantity: number;
		Price: number;
	}
}
export namespace MiaPlaza.LO.Curriculum {
	export interface ICourseGrade
	{
		AssessmentAverage: number;
		CheckpointAverage: number;
		OverallScoreText: string;
	}
	export interface ICourseProgress
	{
		Actual: number;
		Expected: number;
		Behind: boolean;
	}
	export class UnitCatalog
	{
	}
}
export namespace MiaPlaza.LO.Curriculum.AllLessons.Dtos {
	export interface ILessonData
	{
		Name: string;
		ThumbnailUrl: string | null;
		Link: string;
		HighestMedal: MiaPlaza.Model.Games.MedalType;
		Subject: MiaPlaza.Model.Subject;
		CheckpointAssessmentInLesson: boolean;
		IsExcused: boolean;
		IsLessonAvailableInAllLessonsView: boolean;
	}
	export interface ISubjectData
	{
		Subject: MiaPlaza.Model.Subject;
	}
	export interface IUnitData
	{
		Title: string;
		CourseTitle: string;
		IsExcused: boolean;
		Lessons: MiaPlaza.LO.Curriculum.AllLessons.Dtos.ILessonData[];
	}
}
export namespace MiaPlaza.LO.Curriculum.Configuration {
	export interface ICourseEnrollmentData
	{
		Title: string;
		Course: Custom.ModelId<'Curriculum.Course'>;
		UUId: Custom.ModelId<'Curriculum.CourseEnrollment'>;
		Status: MiaPlaza.LO.Curriculum.Configuration.CourseEnrollmentStatus;
		Start: string;
		End: string;
		SchoolWeek: string[];
		InDevelopment: boolean;
		PdfUrl: string | null;
		WorkbookUrl: string | null;
		ShowWorkbook: boolean;
	}
	export interface ICourseEnrollmentShift
	{
		CourseEnrollment: Custom.ModelId<'Curriculum.CourseEnrollment'>;
		Title: string;
		CurrentInterval: [string,string];
		AdjustedInterval: [string,string];
	}
	export enum CourseEnrollmentStatus {
		InProgress = "InProgress",
		AllAssignedTasksCompleted = "AllAssignedTasksCompleted",
		Completed = "Completed",
		NoTasks = "NoTasks"
	}
	export interface ICourseFinalizationResult
	{
		CoursesWithGoogleClassroomRosterFailure: string[];
	}
	export interface ICurriculumData
	{
		Child: Custom.ModelId<'Member'>;
		CurrentMember: Custom.ModelId<'Member'>;
		ChildName: string;
		AllowedSubjects: MiaPlaza.Model.Subject[];
		FirstCompletedDate: string | null;
		ShowPublicHolidays: boolean;
		HasNoServiceDays: boolean;
		ScopeAndSequenceLinks: { [key:string]: string };
		IsActiveOnlineSchoolStudent: boolean;
		CanEditCustomBreaks: boolean;
		IsOnlineSchool: boolean;
		AssessmentAttemptLimit: number | null;
		EnrollmentStartDate: string | null;
		EnrollmentEndDate: string | null;
		ChildCurrentDate: string;
	}
	export interface IEditCourseEnrollmentData
	{
		CourseEnrollment: Custom.ModelId<'Curriculum.CourseEnrollment'>;
		Subject: MiaPlaza.Model.Subject;
		Course: Custom.ModelId<'Curriculum.Course'>;
		CourseTitle: string;
		CourseDescription: string;
		Start: string;
		End: string;
		SchoolWeek: string[];
		IsRequired: boolean;
		IsFreeInputPreferable: boolean;
		PassingScorePercentage: number | null;
		AssessmentAttemptLimit: number | null;
		SuggestedTasksCountPerDayForInDevelopmentCourse: number | null;
		PdfUrl: string | null;
		WorkbookUrl: string | null;
		ShowWorkbook: boolean;
		PdfSplittingOnboarding: MiaPlaza.LO.Curriculum.Dtos.IPdfSplittingParentOnboarding;
		SchoolDays: number | null;
		ScheduleType: MiaPlaza.Model.Curriculum.Scheduling.ScheduleType;
		EnrollmentStartDate: string | null;
		EnrollmentEndDate: string | null;
		ChildCurrentDate: string;
	}
	export interface IEnrolledCoursesInSubject
	{
		Subject: MiaPlaza.Model.Subject;
		Courses: Custom.ModelId<'Curriculum.Course'>[];
	}
	export interface INumberOfAssessmentsToBeLockedInCourse
	{
		Course: Custom.ModelId<'Curriculum.Course'>;
		CourseTitle: string;
		CurrentAttemptLimit: number | null;
		NumberOfAssessmentsToBeLocked: number;
	}
}
export namespace MiaPlaza.LO.Curriculum.Configuration.GoogleClassroomRoster {
	export enum GoogleClassroomRosterSyncStatus {
		Succeeded = "Succeeded",
		CourseHasNoGoogleClassroomClass = "CourseHasNoGoogleClassroomClass",
		StudentHasNoEmail = "StudentHasNoEmail",
		Failed = "Failed"
	}
}
export namespace MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos {
	export interface IStudentTransferInfo
	{
		StudentId: number;
		Site: number;
		StudentName: string;
		ParentName: string;
		ParentEmail: string;
	}
	export interface ITransferredCompletedLevel
	{
		GameCommonIdentifier: string;
		Level: number;
		Date: string;
	}
	export interface ITransferredCourseEnrollment
	{
		CourseCommonIdentifier: string;
		Start: string;
		End: string;
		SchoolWeek: string[];
		IsRequired: boolean;
		PassingScorePercentage: number;
		PassingScorePercentageLastChangedAt: string;
		IsFreeInputPreferable: boolean;
		ScheduleType: MiaPlaza.Model.Curriculum.Scheduling.ScheduleType;
	}
	export interface ITransferredCourseProgress
	{
		StudentInfo: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.IStudentTransferInfo;
		StartDate: string;
		EndDate: string;
		CourseEnrollments: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ITransferredCourseEnrollment[];
		TaskAssignments: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ITransferredTaskAssignment[];
		QuizAssessmentGoals: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredQuizAssessmentGoal[];
		CompletedLevels: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ITransferredCompletedLevel[];
		GameLevels: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ITransferredGameLevel[];
		Medals: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ITransferredMemberMedal[];
	}
	export interface ITransferredGameLevel
	{
		GameCommonIdentifier: string;
		Level: number;
		Success: boolean;
		Creation: string;
		Progress: number;
	}
	export interface ITransferredMemberMedal
	{
		GameCommonIdentifier: string;
		Medal: MiaPlaza.Model.Games.MedalType;
		Creation: string;
	}
	export interface ITransferredTaskAssignment
	{
		Task: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredTask;
		Creation: string;
		Completion: string;
		CompletedEarly: boolean;
		IsManuallyAssigned: boolean;
	}
}
export namespace MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ImportResult {
	export interface ICourseProgressImportResult
	{
		TargetStudent: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.IStudentTransferInfo;
		SourceStudent: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.IStudentTransferInfo;
		CourseEnrollments: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ImportResult.IImportResult;
		CompletedTaskAssignments: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ImportResult.IImportResult;
		OngoingTaskAssignments: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ImportResult.IImportResult;
		QuizAssessmentGoals: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ImportResult.IImportResult;
	}
	export interface IImportResult
	{
		SuccessfulImports: number;
		AlreadyImported: number;
		MissingInstalledContent: number;
	}
}
export namespace MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks {
	export interface ITransferredAnswer
	{
		AnswerText: string;
		TextFormat: number;
		Color: string;
		ShowShadow: boolean;
	}
	export interface ITransferredAssessmentQuestion extends MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredQuestion
	{
		AnswerStatus: MiaPlaza.Model.PremiumParent.Status;
		Order: number;
	}
	export interface ITransferredMedalTask extends MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredTask
	{
		Medal: MiaPlaza.Model.Games.MedalType;
		GameCommonIdentifier: string;
	}
	export interface ITransferredQuestion
	{
		QuestionText: string;
		TextFormat: number;
		CorrectAnswer: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredAnswer;
		WrongAnswer1: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredAnswer;
		WrongAnswer2: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredAnswer;
		WrongAnswer3: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredAnswer;
	}
	export interface ITransferredQuizAssessmentGoal
	{
		Creation: string;
		Finished: string;
		GameCommonIdentifier: string;
		PassingScorePercentage: number;
		TaskAssignment: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.ITransferredTaskAssignment;
		AssessmentQuestions: MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredAssessmentQuestion[];
	}
	export interface ITransferredQuizAssessmentTask extends MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredTask
	{
		GameCommonIdentifier: string;
	}
	export interface ITransferredSupplementalTask extends MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredTask
	{
		SupplementalMaterialUrl: string;
	}
	export interface ITransferredTask
	{
		Type: MiaPlaza.Model.Curriculum.Task.TaskType;
		Inactive: boolean;
		LessonCommonIdentifier: string;
	}
	export interface ITransferredVideoTask extends MiaPlaza.LO.Curriculum.CourseProgressTransfer.Dtos.TransferredTasks.ITransferredTask
	{
		VideoId: string;
	}
}
export namespace MiaPlaza.LO.Curriculum.Display {
	export interface IAssessmentData
	{
		Name: string;
		Progress: string;
		Instant: string;
		Date: string;
		DetailsLink: string;
		IncludeInPrintableReport: boolean;
		UUId: string;
		CheckpointAssessment: boolean;
		IsExcused: boolean;
		IsMissing: boolean;
	}
	export interface ICourseReport
	{
		Title: string;
		Assessments: MiaPlaza.LO.Curriculum.Display.IAssessmentData[];
		StudyTime: string;
		Subject: MiaPlaza.Model.Subject;
		Course: Custom.ModelId<'Curriculum.Course'>;
		OverallScore: string;
		SelectedDatesScore: string;
	}
	export interface ITaskAssignmentData
	{
		TaskAssignmentId: Custom.ModelId<'Curriculum.Task.TaskAssignment'>;
		Name: string;
		Type: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType;
		Status: MiaPlaza.Controllers.Curriculum.Enums.ProgressStatus;
		Image: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Icon: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		PreviewData: MiaPlaza.LO.Curriculum.Display.IPreviewData;
		CheckpointAssessment: boolean;
		PdfSplitData: MiaPlaza.LO.Curriculum.Display.IPdfSplitData | null;
	}
	export interface ILessonInfoPreviewData extends MiaPlaza.LO.Curriculum.Display.IPreviewData
	{
		ExplanationParents: string;
	}
	export enum LightboxMode {
		Default = "Default",
		ElevenByNine = "ElevenByNine",
		FullScreen = "FullScreen"
	}
	export interface ILightboxPreviewData extends MiaPlaza.LO.Curriculum.Display.IPreviewData
	{
		Url: string;
	}
	export interface IPreviewData
	{
		Title: string;
	}
	export interface IRedirectPreviewData extends MiaPlaza.LO.Curriculum.Display.IPreviewData
	{
		Url: string;
	}
	export interface ISupplementalPreviewData extends MiaPlaza.LO.Curriculum.Display.IPreviewData
	{
		Url: string;
	}
	export interface IPdfSplitData
	{
		SectionNumber: number;
		ParentPdfTitle: string;
		ParentPdfUrl: string;
	}
}
export namespace MiaPlaza.LO.Curriculum.Dtos {
	export interface IPdfSplittingParentOnboarding
	{
		Show: boolean;
		IntroVideoUrl: string;
		GroupingModesVideoUrl: string;
		SectionsComparisonImageUrl: string;
		LessonPathImageUrl: string;
		SectionSelectionImageUrl: string;
	}
}
export namespace MiaPlaza.LO.Curriculum.Scheduling.Calendar.Dtos {
	export interface ICustomBreakData
	{
		Name: string;
	}
	export interface IDailyData
	{
		Date: string;
		Units: Custom.ModelId<'Unit'>[];
		UnitsTotalCount: number;
		UnitTasks: MiaPlaza.LO.Curriculum.Scheduling.Calendar.Dtos.IUnitTasksData[];
	}
	export interface IDayConversionData
	{
		Date: string;
		Data: MiaPlaza.LO.Curriculum.Scheduling.Calendar.Dtos.IDayData;
	}
	export interface IDayData
	{
		CustomBreak?: MiaPlaza.LO.Curriculum.Scheduling.Calendar.Dtos.ICustomBreakData;
		PublicHoliday?: MiaPlaza.LO.Curriculum.Scheduling.Calendar.Dtos.IPublicHolidayData;
		NoServiceDay?: MiaPlaza.LO.Curriculum.Scheduling.Calendar.Dtos.INoServiceDayData;
		CompletedTasksCount: number;
	}
	export interface INoServiceDayData
	{
		Name: string;
		IconUrl: string;
	}
	export interface IPublicHolidayData
	{
		PublicHoliday: MiaPlaza.Model.PublicHoliday;
		Observed: boolean;
	}
	export interface IUnitData
	{
		UnitId: Custom.ModelId<'Unit'>;
		Subject: MiaPlaza.Model.Subject;
		Title: string;
		CourseTitle: string;
	}
	export interface IUnitTasksData
	{
		Unit: Custom.ModelId<'Unit'>;
		TaskAssignments: Custom.ModelId<'Curriculum.Task.TaskAssignment'>[];
		TaskAssignmentsTotalCount: number;
	}
	export interface IWeeklyData
	{
		Days: MiaPlaza.LO.Curriculum.Scheduling.Calendar.Dtos.IDailyData[];
		DayConversions: MiaPlaza.LO.Curriculum.Scheduling.Calendar.Dtos.IDayConversionData[];
		UnitConversions: MiaPlaza.LO.Curriculum.Scheduling.Calendar.Dtos.IUnitData[];
		TaskAssignmentConversions: MiaPlaza.LO.Curriculum.Display.ITaskAssignmentData[];
	}
}
export namespace MiaPlaza.LO.Curriculum.ScopeAndSequence {
	export interface ICourseData
	{
		Name: string;
		RecommendedGradeMin: number;
		RecommendedGradeMax: number;
		Units: MiaPlaza.LO.Curriculum.ScopeAndSequence.IUnitData[];
		InDevelopment: boolean;
	}
	export interface IScopeAndSequenceData
	{
		Subject: MiaPlaza.Model.Subject;
		Courses: MiaPlaza.LO.Curriculum.ScopeAndSequence.ICourseData[];
	}
	export interface IUnitData
	{
		Name: string;
		Lessons: string[];
	}
}
export namespace MiaPlaza.LO.Curriculum.Tasks.GoogleClassroomCheckpoint {
	export interface IGoogleClassroomCheckpointDto
	{
		CheckpointState: MiaPlaza.LO.Curriculum.Tasks.GoogleClassroomCheckpoint.GoogleClassroomCheckpointState;
		DisplayTitle?: string;
		ClassroomURL?: string;
	}
	export enum GoogleClassroomCheckpointState {
		CheckNotRequired = "CheckNotRequired",
		CheckError = "CheckError",
		CheckPassed = "CheckPassed",
		CheckFailed = "CheckFailed"
	}
}
export namespace MiaPlaza.LO.Footer {
	export interface IBadge
	{
		ImageUrl: string;
		AltText: string;
		LinkUrl: string;
	}
	export interface ILink
	{
		Title: string;
		LinkUrl: string;
	}
	export interface INavigationColumn
	{
		Header: string;
		Links: MiaPlaza.LO.Footer.ILink[];
	}
}
export namespace MiaPlaza.LO.Games {
	export interface IAudioSettings
	{
		FeedbackSoundAvailableInGame: boolean;
		FeedbackSoundEnabled: boolean;
		TextToSpeechAvailableInGame: boolean;
		TextToSpeechEnabledByParent: boolean;
		TextToSpeechEnabled: boolean;
		SpeechMarksEnabled: boolean;
		TextToSpeechVoice: MiaPlaza.Model.Voice;
	}
	export interface IDragonMove
	{
	}
	export abstract class MultiplayerGame
	{
		public static GetAcceptInvitationUrl(host: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, instance: Custom.ModelId<'MultiplayerInstance'> | MiaPlaza.IPlaceholder) : string
		{
			return `/LO.Games.MultiplayerGame/AcceptInvitation?host=${MiaPlaza.RoutedHelper.GetParameter(host)}&instance=${MiaPlaza.RoutedHelper.GetParameter(instance)}&_=`;
		}
		public static GetDeclineInvitationUrl(host: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, instance: Custom.ModelId<'MultiplayerInstance'> | MiaPlaza.IPlaceholder, noInvitationsUntil: string | MiaPlaza.IPlaceholder) : string
		{
			return `/LO.Games.MultiplayerGame/DeclineInvitation?host=${MiaPlaza.RoutedHelper.GetParameter(host)}&instance=${MiaPlaza.RoutedHelper.GetParameter(instance)}&noInvitationsUntil=${MiaPlaza.RoutedHelper.GetParameter(noInvitationsUntil)}&_=`;
		}
	}
}
export namespace MiaPlaza.LO.Games.Quizzes {
	export interface IAssessmentAnswerResult
	{
		AssessmentScoreContent: string[];
		QuestionsLeft: number;
		Progress: number;
		Amount: number;
		IsSolved: boolean;
	}
	export interface IMediaText
	{
		Text: string;
		ViewTimeSeconds: number;
		SecondViewTimeSeconds: number;
	}
	export interface INextMedal
	{
		ImageSource: string;
		Level: number;
		NoNextMedal: boolean;
	}
	export interface IPracticeAnswerResult
	{
		Level: number;
		Amount: number;
		IsLevelUp: boolean;
		NewReward: number;
		Medal: string;
		MedalName: string;
		Pet: string;
		PetName: string;
		ChallengeWasCompleted: boolean;
		OpenProdding: string;
		IsLastLevelCompleted: boolean;
	}
	export interface IQuestionData
	{
		QuizContent: string[];
		AnswerPaths: string[];
		Progress: number;
		QuestionsLeft: number;
		MediaText: MiaPlaza.LO.Games.Quizzes.IMediaText;
		Path: string;
		Id: string;
		SoundFile: string;
		NextMedalImageSource: string;
		NextMedalLevel: number;
		NoNextMedal: boolean;
		NextMedal: MiaPlaza.LO.Games.Quizzes.INextMedal;
	}
}
export namespace MiaPlaza.LO.Games.Vocabulary {
	export interface IVocabularySettings
	{
		Grade: number | null;
		Grades: number[];
		Enabled: boolean;
		ConsentRequired: boolean;
	}
}
export namespace MiaPlaza.LO.Gradebook {
	export enum GradebookAccess {
		Admin = "Admin",
		Parent = "Parent",
		Child = "Child"
	}
	export interface IGradebookData
	{
		Child: Custom.ModelId<'Member'>;
		ChildName: string;
		IsOnlineSchoolStudent: boolean;
		IsActiveOnlineSchoolStudent: boolean;
		IsGradebookAvailable: boolean;
		IsPrintEnabled: boolean;
		Access: MiaPlaza.LO.Gradebook.GradebookAccess;
	}
	export interface IGradebookExportData
	{
		Child: Custom.ModelId<'Member'>;
		ChildName: string;
		IsActiveOnlineSchoolStudent: boolean;
		Access: MiaPlaza.LO.Gradebook.GradebookAccess;
		JoinedDate: string;
		ParentName: string;
	}
	export interface IGradebookOnlineSchoolAdminData extends MiaPlaza.LO.Gradebook.IGradebookData
	{
		ChildId: number;
		JoinedDate: string;
		LeftDate: string | null;
		DateOfLastCompletedTask: string | null;
		Parent: MiaPlaza.LO.Gradebook.IMemberLink;
		StudentEmail: string;
		ChildImpersonationUrl: string | null;
		NumberOfUngradedOrMissingCheckpoints: number;
		SapLink: string | null;
	}
	export interface IGradebookPublicOnlineSchoolAdminData
	{
		GradebookOnlineSchoolAdminData: MiaPlaza.LO.Gradebook.IGradebookOnlineSchoolAdminData;
		PublicOnlineSchoolStudentInformation: MiaPlaza.LO.Gradebook.IGradebookPublicOnlineSchoolStudentInformation;
		EnrollmentStartDate: string;
		EnrollmentEndDate: string;
	}
	export interface IGradebookPublicOnlineSchoolStudentInformation
	{
		StateStudentIdentifier: string;
		Advisor: MiaPlaza.LO.Gradebook.IMemberLink;
		Counselor: MiaPlaza.LO.Gradebook.IMemberLink;
		TotalHoursRequired: number;
	}
	export interface IMemberLink
	{
		Name: string;
		Url: string;
	}
}
export namespace MiaPlaza.LO.JSON {
	export interface IVideoModel
	{
	}
}
export namespace MiaPlaza.LO.JavaScript {
	export abstract class Log
	{
		public static ErrorLoggingUrl: string = `/LO.JavaScript.Log/Error?_=`;
		public static GetErrorUrl() : string
		{
			return "/LO.JavaScript.Log/Error?_=";
		}
	}
}
export namespace MiaPlaza.LO.Lesson.Dtos {
	export interface IPdfSplittingStudentOnboarding
	{
		Show: boolean;
		WalkthroughVideoUrl: string;
	}
	export interface ITtsOnboardingCarouselMedia
	{
		OldVoiceVideoUrl: string;
		NewVoiceVideoUrl: string;
		PlaybackControlsVideoUrl: string;
		MeetMaxAndLunaVideoUrl: string;
		TextHighlightingVideoUrl: string;
		SpotUpdatedLessonsImageUrl: string;
	}
	export interface IVideoPlaybackConfig
	{
		FallbackEnabled: boolean;
		FallbackS3BucketEndpoint: string;
		RewardTimeSpan: number;
		MaxSpeedEnabled: boolean;
		LogVimeoPlayerErrors: boolean;
		MaxSpeed: number;
	}
}
export namespace MiaPlaza.LO.Lesson.Dtos.Games {
	export interface IDragAndDropGame extends MiaPlaza.LO.Lesson.Dtos.Games.IGame
	{
		GameData: MiaPlaza.Control.Vue.IVueGameData;
	}
	export interface IGame
	{
		Type: MiaPlaza.LO.Lesson.Dtos.Games.GameType;
	}
	export enum GameType {
		PracticeAndAssessment = "PracticeAndAssessment",
		DragAndDrop = "DragAndDrop",
		Html = "Html"
	}
	export interface IHtmlGame extends MiaPlaza.LO.Lesson.Dtos.Games.IGame
	{
		Id: Custom.ModelId<'CustomFlashGame'>;
	}
	export interface IPracticeAndAssessmentGame extends MiaPlaza.LO.Lesson.Dtos.Games.IGame
	{
		Id: Custom.ModelId<'CustomFlashGame' | 'CustomGame' | 'Games.VueGame'>;
		Version: string;
		FreeInput: boolean;
		VideoPlaybackConfig: MiaPlaza.LO.Lesson.Dtos.IVideoPlaybackConfig;
	}
}
export namespace MiaPlaza.LO.Lesson.Dtos.Tasks {
	export interface IAssessmentTask extends MiaPlaza.LO.Lesson.Dtos.Tasks.ITask
	{
		Id: Custom.ModelId<'Curriculum.Task.QuizAssessmentTask'>;
		Game: MiaPlaza.LO.Lesson.Dtos.Games.IGame;
		TaskAssignmentId: string;
		QuizAssessmentGoalId: string;
		AttemptInfo: MiaPlaza.LO.Assessment.IAttemptInfo | null;
		SubmissionRetryEnabled: boolean;
	}
	export interface ICheckpointTask extends MiaPlaza.LO.Lesson.Dtos.Tasks.ITask
	{
		TaskTypeIsCheckpoint: boolean;
		IsCheckpoint: boolean;
		IsGoogleClassroomCheckRequired: boolean;
	}
	export interface IIFrameTask extends MiaPlaza.LO.Lesson.Dtos.Tasks.ITask
	{
		Id: Custom.ModelId<'Curriculum.Task.SupplementalTask'>;
		Url: string;
	}
	export interface IPdfTask extends MiaPlaza.LO.Lesson.Dtos.Tasks.ICheckpointTask
	{
		Id: Custom.ModelId<'Curriculum.Task.SupplementalTask'>;
		Url: string;
		SplitData: MiaPlaza.LO.Lesson.Dtos.Tasks.ISplitPdfTaskPart;
	}
	export interface IPracticeTask extends MiaPlaza.LO.Lesson.Dtos.Tasks.ITask
	{
		Id: Custom.ModelId<'Curriculum.Task.MedalTask'>;
		Game: MiaPlaza.LO.Lesson.Dtos.Games.IGame;
		Medal: MiaPlaza.Model.Games.MedalType;
		MinLevel: number;
		MaxLevel: number;
		AdditionalAttempts: number;
	}
	export interface ISplitPdfTaskPart
	{
		PdfActivityTypes: MiaPlaza.Model.SupplementalMaterials.PdfActivityType[];
		SourcePdfUrl: string;
		SourcePdfSplitStartPage: number;
	}
	export interface ITask
	{
		Id: Custom.ModelId<'Curriculum.Task.MedalTask' | 'Curriculum.Task.QuizAssessmentTask' | 'Curriculum.Task.SupplementalTask' | 'Curriculum.Task.Task' | 'Curriculum.Task.VideoTask'>;
		Type: MiaPlaza.LO.Lesson.Dtos.Tasks.TaskType;
		TaskTypeIsCheckpoint: boolean;
		Assigned: boolean;
		Completed: boolean;
		ShouldAskForFeedback: boolean;
	}
	export enum TaskType {
		Video = "Video",
		Practice = "Practice",
		Assessment = "Assessment",
		Pdf = "Pdf",
		IFrame = "IFrame"
	}
	export interface IVideoTask extends MiaPlaza.LO.Lesson.Dtos.Tasks.ITask
	{
		Id: Custom.ModelId<'Curriculum.Task.VideoTask'>;
		Url: string;
		VimeoId: string;
		ShowSubtitles: boolean;
		AllowSeekForward: boolean;
		VideoPlaybackConfig: MiaPlaza.LO.Lesson.Dtos.IVideoPlaybackConfig;
		Video: Custom.ModelId<'Video.TeachingVideo'>;
	}
}
export namespace MiaPlaza.LO.Members.BozoMember.Models {
	export interface IBozoMemberData
	{
		Name: string;
		Id: Custom.ModelId<'Member'>;
		AccountDetailsLink: string;
		ReviewerName: string;
		CreationDate: string;
	}
}
export namespace MiaPlaza.LO.Membership {
	export interface ICodeHandlerResponse
	{
		Success: boolean;
		SuccessMessage: string;
		ErrorMessage: string;
		RedirectUrl: string;
		UpdateProductSelector: boolean;
		UpdatePurchaseSummary: boolean;
	}
}
export namespace MiaPlaza.LO.Memberships {
	export interface IAdminManageMembershipData
	{
		Summary: MiaPlaza.LO.Memberships.IAdminMembershipSummary;
		ExpirationDate: string | null;
		PausedThrough: string | null;
		PaidThrough: string | null;
		CanSetExpirationDate: boolean;
		CanSetLifetime: boolean;
		CanSetPausedThrough: boolean;
		CanSetSubjects: boolean;
		IsFullCurriculum: boolean;
		GrantedSubjects: MiaPlaza.Model.Subject[];
		AvailableSubjects: MiaPlaza.LO.Memberships.IAdminSubjectOption[];
		CommunityAccessLevel: MiaPlaza.Model.FeatureAccessLevel;
		CanSetCommunityAccessLevel: boolean;
	}
	export interface IAdminMembershipChangeLogEntry
	{
		Creation: string;
		MembershipType: string;
		Reason: string;
		Subjects: string;
		CommunityAccessLevel: string;
		MembershipValues: string;
	}
	export interface IAdminMembershipSummary
	{
		Status: string;
		HasSiteAccess: boolean;
		Subjects: string;
		CommunityAccessLevel: string;
	}
	export interface IAdminSubjectOption
	{
		Subject: MiaPlaza.Model.Subject;
		Name: string;
	}
}
export namespace MiaPlaza.LO.Memberships.Dtos {
	export interface IMembershipAction
	{
		Text: string;
		Link: string;
	}
	export interface IMembershipSaleBadge
	{
		Text: string;
		Link: string;
	}
	export interface IMembershipStatus
	{
		Status: string;
		StatusShort: string;
		Action?: MiaPlaza.LO.Memberships.Dtos.IMembershipAction;
	}
}
export namespace MiaPlaza.LO.MiaTours {
	export interface IMiaTour
	{
		Active: boolean;
		Steps: MiaPlaza.LO.MiaTours.IMiaTourStep[];
		Triggers: MiaPlaza.LO.MiaTours.TourTrigger[];
	}
	export interface IMiaTourStep
	{
		Selector: string | HTMLElement;
		Heading?: string;
		Optional: boolean;
		Position: string;
		ScrollTo: string;
		DisableInteraction: boolean;
	}
	export enum TourTrigger {
		FirstLogin = "FirstLogin"
	}
}
export namespace MiaPlaza.LO.MiniMe.MiniMeClosetService {
	export interface IMiniMeClosetItem
	{
		Id: string;
		Category: MiaPlaza.LO.MiniMe.MiniMeClosetService.MiniMeClosetItemCategory;
		ItemType: MiaPlaza.LO.MiniMe.MiniMeClosetService.MiniMeClosetItemType;
		ImageSrc: string;
		ObjectChains: string[][];
		X: number;
		Y: number;
		Width: number;
		Height: number;
	}
	export enum MiniMeClosetItemCategory {
		Face = "Face",
		Hair = "Hair",
		Top = "Top",
		Bottom = "Bottom",
		Shoes = "Shoes"
	}
	export enum MiniMeClosetItemType {
		Default = "Default",
		Custom = "Custom"
	}
}
export namespace MiaPlaza.LO.Moderation.ChildPenaltyReasons {
	export interface IBlackListReason extends MiaPlaza.LO.Moderation.ChildPenaltyReasons.IChildPenaltyReason
	{
		PenaltyType: MiaPlaza.LO.Moderation.Enums.ChildPenaltyType;
		BlackListComment: string;
		UnacceptedText: string;
		ModeratorMessage: string;
		ModerationHistoryLink: string;
		ModerationItemContextSegments: MiaPlaza.LO.Moderation.ModerationItemContextSegments.IModerationItemContextSegment[];
	}
	export interface IChildPenaltyReason
	{
		PenaltyType: MiaPlaza.LO.Moderation.Enums.ChildPenaltyType;
	}
	export interface ISimpleReason extends MiaPlaza.LO.Moderation.ChildPenaltyReasons.IChildPenaltyReason
	{
		PenaltyType: MiaPlaza.LO.Moderation.Enums.ChildPenaltyType;
		Reason: string;
	}
}
export namespace MiaPlaza.LO.Moderation.Enums {
	export enum ChildPenaltyType {
		Simple = 0,
		BlackList = 1
	}
	export enum ModerationItemContextSegmentType {
		Text = 0,
		Link = 1,
		Profile = 2
	}
}
export namespace MiaPlaza.LO.Moderation.ModerationItemContextSegments {
	export interface IModerationItemContextSegment
	{
		SegmentType: MiaPlaza.LO.Moderation.Enums.ModerationItemContextSegmentType;
	}
	export interface IModerationItemContextLinkSegment extends MiaPlaza.LO.Moderation.ModerationItemContextSegments.IModerationItemContextSegment, MiaPlaza.LO.Moderation.ModerationItemContextSegments.IModerationItemContextTextSegment
	{
		Url: string;
	}
	export interface IModerationItemContextProfileSegment extends MiaPlaza.LO.Moderation.ModerationItemContextSegments.IModerationItemContextSegment
	{
		SegmentType: MiaPlaza.LO.Moderation.Enums.ModerationItemContextSegmentType;
		Profile: MiaPlaza.LO.Moderation.ModerationItemContextSegments.IModerationItemContextLinkSegment;
		AccountDetails: MiaPlaza.LO.Moderation.ModerationItemContextSegments.IModerationItemContextLinkSegment;
	}
	export interface IModerationItemContextTextSegment extends MiaPlaza.LO.Moderation.ModerationItemContextSegments.IModerationItemContextSegment
	{
		SegmentType: MiaPlaza.LO.Moderation.Enums.ModerationItemContextSegmentType;
		Text: string;
	}
}
export namespace MiaPlaza.LO.OnlineSchool.Enums {
	export enum OnlineSchoolActionErrorType {
		IdError = "IdError",
		EMailError = "EMailError",
		RestoreMemberError = "RestoreMemberError",
		StaffAssignmentError = "StaffAssignmentError",
		SsidError = "SsidError",
		EnrollmentDatesError = "EnrollmentDatesError",
		EnrollmentStartAfterFirstSchoolDayError = "EnrollmentStartAfterFirstSchoolDayError",
		EnrollmentEndBeforeLastSchoolDayError = "EnrollmentEndBeforeLastSchoolDayError"
	}
}
export namespace MiaPlaza.LO.OnlineSchool.Models {
	export interface IChildData
	{
		Name: string;
		Id: number | null;
		UUId: string;
	}
	export interface IOnlineSchoolStudentFilter
	{
		SearchTerm: string;
		IsActive: boolean | null;
		SortByDateOfLastCompletedTaskAscending: boolean | null;
		HasCompleteAccountInfo: boolean | null;
	}
	export interface IOnlineSchoolStudentInformation
	{
		Child: MiaPlaza.LO.OnlineSchool.Models.IChildData;
		SapLink: string | null;
		EMail: string | null;
		CounselorUuid: string | null;
		AdvisorUuid: string | null;
		IsPawsPartnerStudent: boolean;
	}
	export interface IParentData
	{
		Name: string;
		Url: string;
	}
	export interface IPublicOnlineSchoolStudentInformation extends MiaPlaza.LO.OnlineSchool.Models.IOnlineSchoolStudentInformation
	{
		StateStudentIdentifier: string | null;
		TotalHoursRequired: number;
		EnrollmentStartDate: string;
		EnrollmentEndDate: string;
		FirstScheduledSchoolDay: string | null;
		LastScheduledSchoolDay: string | null;
	}
	export interface ITeacherDropdownOption
	{
		Uuid: string;
		FullName: string;
	}
}
export namespace MiaPlaza.LO.Payments {
	export interface ICheckoutResponse
	{
		ErrorMessage: string;
		RedirectUrl: string;
	}
	export interface IPurchaseData
	{
		PaymentType: MiaPlaza.Model.Payments.ProductType;
		Quantity: number;
	}
	export interface IPurchaseStatistics
	{
		PurchaseCount: MiaPlaza.LO.Payments.IPurchaseData[];
		FirstSubscriptionDate: string;
		LatestPurchaseDate: string;
	}
}
export namespace MiaPlaza.LO.Payments.Banner {
	export interface IStudentNeedingPaymentIntervention
	{
		Student: Custom.ModelId<'Member'>;
		StudentName: string;
		FailedPaymentDate: string;
		FixPaymentPageLink: string;
		Type: MiaPlaza.LO.Payments.Banner.StudentNeedingPaymentInterventionType;
	}
	export enum StudentNeedingPaymentInterventionType {
		Blocked = "Blocked",
		Grace = "Grace"
	}
	export interface IStudentOnGracePeriod extends MiaPlaza.LO.Payments.Banner.IStudentNeedingPaymentIntervention
	{
		Type: MiaPlaza.LO.Payments.Banner.StudentNeedingPaymentInterventionType;
		SuspensionDate: string;
		CancellationLink: string;
	}
	export interface IStudentWithBlockedAccess extends MiaPlaza.LO.Payments.Banner.IStudentNeedingPaymentIntervention
	{
		Type: MiaPlaza.LO.Payments.Banner.StudentNeedingPaymentInterventionType;
	}
}
export namespace MiaPlaza.LO.Payments.Display {
	export interface IPaymentMethodData
	{
		Description: string;
		PaymentMethodType: string;
	}
}
export namespace MiaPlaza.LO.Payments.Information {
	export interface ICouponCodeDiscountInformation extends MiaPlaza.LO.Payments.Information.IDiscountInformation
	{
		CouponCode: string;
	}
	export interface IDiscountInformation
	{
		DiscountedPrice: number;
		MonthlyEquivalentDiscountedPrice: number;
	}
	export interface IOneTimePaymentInformation
	{
		RegularPrice: number;
		RegularMonthlyEquivalentPrice: number;
		FinalPrice: number;
		FinalMonthlyEquivalentPrice: number;
		AppliedDiscount: MiaPlaza.LO.Payments.Information.IDiscountInformation;
		MultipleDiscountsApplicable: boolean;
	}
	export interface ISalesDiscountInformation extends MiaPlaza.LO.Payments.Information.IDiscountInformation
	{
	}
	export interface ISubscriptionInformation
	{
		FirstPeriodPrice: number;
		RegularPrice: number;
		FinalPrice: number;
		AppliedDiscount: MiaPlaza.LO.Payments.Information.IDiscountInformation;
		MultipleDiscountsApplicable: boolean;
	}
}
export namespace MiaPlaza.LO.PracticeAndAssessment {
	export interface IAssessment extends MiaPlaza.LO.PracticeAndAssessment.IPracticeAndAssessmentContent
	{
		QuizAssessmentGoalId: string;
		Questions: MiaPlaza.LO.PracticeAndAssessment.Dtos.Questions.IAssessmentQuestion[];
	}
	export interface IPractice extends MiaPlaza.LO.PracticeAndAssessment.IPracticeAndAssessmentContent
	{
		Questions: MiaPlaza.LO.PracticeAndAssessment.Dtos.Questions.IPracticeQuestion[];
		CurrentLevel: number;
		HighestStudentMedal: MiaPlaza.Model.Games.MedalType;
		LevelReferenceMaterials: { [key:number]: MiaPlaza.LO.PracticeAndAssessment.Dtos.ReferenceMaterials.IReferenceMaterial[] };
		NumberOfLevels: number;
		LevelsInformation: { [key:number]: MiaPlaza.LO.PracticeAndAssessment.Dtos.Levels.ILevel };
	}
	export interface IPracticeAndAssessmentContent
	{
		TextToSpeechUsesFallback: boolean;
	}
}
export namespace MiaPlaza.LO.PracticeAndAssessment.Dtos {
	export interface IAssessmentReward
	{
		Reward: number;
		Passed: boolean;
		PassingScorePercentage: number | null;
		BestFinishedAssessmentScore: number | null;
		FirstAttempt: boolean;
		TotalQuestionsCount: number;
		CorrectQuestionsCount: number;
	}
	export interface IPracticeReward
	{
		HighestStudentMedal: MiaPlaza.Model.Games.MedalType;
		Reward: number;
	}
	export interface IProcessAssessmentResult
	{
		Success: boolean;
		Error: 'GOAL_NOT_FOUND' | 'ANSWERS_LIST_EMPTY' | null;
		Data: MiaPlaza.LO.PracticeAndAssessment.Dtos.IAssessmentReward | null;
	}
}
export namespace MiaPlaza.LO.PracticeAndAssessment.Dtos.AnswerSections {
	export interface IAnswerChoice
	{
		AnswerId: string;
		Correct: boolean;
		Content: MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.IContentBlock[];
	}
	export interface IAnswerSection
	{
		Type: MiaPlaza.LO.PracticeAndAssessment.Dtos.AnswerSections.AnswerSectionType;
	}
	export enum AnswerSectionType {
		FreeInputText = "FreeInputText",
		MultipleChoice = "MultipleChoice"
	}
	export interface IFreeInputTextAnswerSection extends MiaPlaza.LO.PracticeAndAssessment.Dtos.AnswerSections.IAnswerSection
	{
		CorrectAnswers: string[];
	}
	export interface IMultipleChoiceAnswerSection extends MiaPlaza.LO.PracticeAndAssessment.Dtos.AnswerSections.IAnswerSection
	{
		AnswerChoices: MiaPlaza.LO.PracticeAndAssessment.Dtos.AnswerSections.IAnswerChoice[];
	}
}
export namespace MiaPlaza.LO.PracticeAndAssessment.Dtos.Answers {
	export interface IAnswer
	{
		Type: MiaPlaza.LO.PracticeAndAssessment.Dtos.AnswerSections.AnswerSectionType;
		Correct: boolean;
		QuestionId: string;
	}
	export interface IFreeInputAnswer extends MiaPlaza.LO.PracticeAndAssessment.Dtos.Answers.IAnswer
	{
		FreeInputAnswerValue: string;
	}
	export interface IMultipleChoiceAnswer extends MiaPlaza.LO.PracticeAndAssessment.Dtos.Answers.IAnswer
	{
		AnswerId: string;
	}
}
export namespace MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks {
	export interface IContentBlock
	{
		Type: MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.ContentBlockType;
	}
	export enum ContentBlockType {
		Text = "Text",
		Image = "Image",
		LaTeX = "LaTeX",
		HTML = "HTML"
	}
	export interface IHtmlBlock extends MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.ITtsBlock, MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.IContentBlock
	{
		Content: string;
		AudioUrl: string;
		SpeechMarksUrl: string;
	}
	export interface ITtsBlock
	{
		AudioUrl: string;
		SpeechMarksUrl: string;
	}
	export interface IImageBlock extends MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.IContentBlock
	{
		Url: string;
	}
	export interface ILaTeXBlock extends MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.ITtsBlock, MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.ITextBlock
	{
	}
	export interface ITextBlock extends MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.ITtsBlock, MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.IContentBlock
	{
		Content: string;
		AudioUrl: string;
		SpeechMarksUrl: string;
	}
}
export namespace MiaPlaza.LO.PracticeAndAssessment.Dtos.Levels {
	export interface ILevel
	{
		NumberOfQuestions: number;
		MedalInformation: MiaPlaza.LO.PracticeAndAssessment.Dtos.Levels.IPracticeMedal;
		Reward: number;
	}
	export interface IPracticeMedal
	{
		Medal: MiaPlaza.Model.Games.MedalType;
		Received: boolean;
	}
}
export namespace MiaPlaza.LO.PracticeAndAssessment.Dtos.Questions {
	export interface IAssessmentQuestion extends MiaPlaza.LO.PracticeAndAssessment.Dtos.Questions.IQuestion
	{
		StudentAnswer: MiaPlaza.LO.PracticeAndAssessment.Dtos.Answers.IAnswer;
	}
	export interface IPracticeQuestion extends MiaPlaza.LO.PracticeAndAssessment.Dtos.Questions.IQuestion
	{
		MinLevel: number;
		MaxLevel: number;
		TutorialVideo: MiaPlaza.LO.PracticeAndAssessment.Dtos.Questions.IQuestionTutorialVideo;
	}
	export interface IQuestion
	{
		QuestionId: string;
		Prompt: MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.IContentBlock[];
		AnswerSection: MiaPlaza.LO.PracticeAndAssessment.Dtos.AnswerSections.IAnswerSection;
		ReferenceMaterials: MiaPlaza.LO.PracticeAndAssessment.Dtos.ReferenceMaterials.IReferenceMaterial[];
	}
	export interface IQuestionTutorialVideo
	{
		Id: Custom.ModelId<'Video.QuestionTutorialVideo'>;
		Url: string;
		VimeoId: string;
	}
}
export namespace MiaPlaza.LO.PracticeAndAssessment.Dtos.ReferenceMaterials {
	export interface IReferenceMaterial
	{
		Id: number;
		ContentBlock: MiaPlaza.LO.PracticeAndAssessment.Dtos.ContentBlocks.IContentBlock;
	}
}
export namespace MiaPlaza.LO.PremiumParent {
	export interface ICustomAttendanceActivityInformation
	{
		Date: string;
		DurationInMinutes: number;
		Description: string;
		Type: MiaPlaza.Model.Attendance.CustomAttendanceActivityType | null;
		Name: string | null;
		StartTimeHour: number | null;
		StartTimeMinute: number | null;
		Course: Custom.ModelId<'Curriculum.Course'> | null;
	}
	export interface ITeacherReviewRequest
	{
		ActivityUuid: string;
		ExpectedUpdatedAt: string;
		Comment: string | null;
	}
	export interface ITeacherReviewResult
	{
		ActivityUuid: string;
		Success: boolean;
		ErrorType: MiaPlaza.LO.PremiumParent.Enums.CustomAttendanceActivityErrorType | null;
	}
	export class RememberTimeSpan
	{
		public static GetSetUrl(predefinedDateRangeType: MiaPlaza.Model.PremiumParent.PredefinedDateRangeType | MiaPlaza.IPlaceholder) : string
		{
			return `/LO.PremiumParent.RememberTimeSpan/Set?predefinedDateRangeType=${MiaPlaza.RoutedHelper.GetParameter(predefinedDateRangeType)}&_=`;
		}
	}
}
export namespace MiaPlaza.LO.PremiumParent.Enums {
	export enum CustomAttendanceActivityErrorType {
		OverlapError = "OverlapError",
		DailyTimeLimitExceededError = "DailyTimeLimitExceededError",
		PublicOnlineSchoolDailyTimeLimitExceededError = "PublicOnlineSchoolDailyTimeLimitExceededError",
		ActivityNotInEditableState = "ActivityNotInEditableState",
		ActivityNotOwnedByCaller = "ActivityNotOwnedByCaller",
		ActivityModifiedConflict = "ActivityModifiedConflict",
		ActivityNotFound = "ActivityNotFound",
		ActivityTypeNotAllowed = "ActivityTypeNotAllowed"
	}
}
export namespace MiaPlaza.LO.Profile.GuestBook.Dtos {
	export interface IGuestBookEntry
	{
		AuthorName: string;
		CreationDate: string;
		AuthorAvatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		AuthorUrl: string;
		Text: string;
		AllowDelete: boolean;
	}
}
export namespace MiaPlaza.LO.Registration {
	export interface IParentRegistrationData
	{
		FirstName: string;
		LastName: string;
		Email: string;
		Country: string;
		AcceptNewsletters: boolean;
	}
	export interface IStudentRegistrationData
	{
		FirstName: string;
		LastNameInitial: string;
		FeatureLevel: MiaPlaza.Model.FeatureAccessLevel;
		Grade: MiaPlaza.Model.Grades.Grade;
		AcceptReports: boolean;
	}
}
export namespace MiaPlaza.LO.Registration.Dtos {
	export interface IStudentOption
	{
		Name: string;
		ContinueUrl: string;
		ShouldAskForConsent: boolean;
		IsDisabled: boolean;
		WarningTextKey?: string;
	}
}
export namespace MiaPlaza.LO.Results {
	export interface IActionResultError<T>
	{
		ErrorMessage: string;
		ErrorType: T;
	}
	export interface IActionResult<T>
	{
		Success: boolean;
		Errors: MiaPlaza.LO.Results.IActionResultError<T>[];
	}
}
export namespace MiaPlaza.LO.Shoutboxes {
	export interface IShoutboxData
	{
		Shoutbox: Custom.ModelId<'Shoutboxes.DesignStudioShoutbox' | 'Shoutboxes.GameShoutbox' | 'Shoutboxes.GroupShoutbox' | 'Shoutboxes.MemberCastleShoutbox' | 'Shoutboxes.MemberShopShoutbox' | 'Shoutboxes.NewspaperArticleShoutbox' | 'Shoutboxes.PetWorldShoutbox' | 'Shoutboxes.ShopShoutbox' | 'Shoutboxes.Shoutbox' | 'Shoutboxes.VideoShoutbox'>;
		SmileyList: string[];
		ShoutboxLineTextLimit: number;
		ChildMayPost: boolean;
		ChildMayPostErrorMessage: string;
	}
}
export namespace MiaPlaza.LO.Social {
	export enum FriendshipState {
		CantBeFriends = "CantBeFriends",
		PendingFriendshipRequest = "PendingFriendshipRequest",
		AlreadyFriends = "AlreadyFriends",
		CanBecomeFriends = "CanBecomeFriends"
	}
	export enum RequestStatus {
		AlreadyConnected = "AlreadyConnected",
		ConnectionSuccessful = "ConnectionSuccessful",
		AwaitingConfirm = "AwaitingConfirm"
	}
}
export namespace MiaPlaza.LO.Streaks.Dtos {
	export interface INextStreakMilestone
	{
		Day: number;
		Reward: MiaPlaza.LO.Streaks.Dtos.IStreakRewardGrant;
	}
	export interface IPreviousStreakSnapshot
	{
		NextMilestone: MiaPlaza.LO.Streaks.Dtos.INextStreakMilestone;
		World: MiaPlaza.LO.Streaks.Dtos.IStreakWorld;
		PreviousMilestoneDay: number;
	}
	export interface IStreakLeaderboardMember
	{
		Name: string;
		MemberUrl: string;
		IsCurrentMember: boolean;
		StreakDay: number;
		Avatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Rank: number;
		World: MiaPlaza.LO.Streaks.Dtos.IStreakWorld;
	}
	export enum StreakProgressType {
		DayAdvanced = "DayAdvanced",
		MilestoneReached = "MilestoneReached",
		WorldCompleted = "WorldCompleted"
	}
	export interface IStreakRewardGrant
	{
		Type: MiaPlaza.LO.Streaks.Dtos.StreakRewardType;
		Image: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Label: string;
	}
	export enum StreakRewardType {
		Pet = "Pet",
		Accessory = "Accessory",
		Scoops = "Scoops"
	}
	export interface IStreakStore
	{
		MemberUrl: string;
		MemberName: string;
		MemberAvatar: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		Worlds: MiaPlaza.LO.Streaks.Dtos.IStreakWorld[];
		CurrentWorld: MiaPlaza.LO.Streaks.Dtos.IStreakWorld;
		NextMilestone: MiaPlaza.LO.Streaks.Dtos.INextStreakMilestone;
		StreakDay: number;
		PreviousMilestoneDay: number;
		LastAction: string;
		Rank: number | null;
		ExpirationDate: string | null;
		WeekCalendar: MiaPlaza.LO.Streaks.Dtos.IStreakWeekCalendar;
		ProgressType: MiaPlaza.LO.Streaks.Dtos.StreakProgressType | null;
		PreviousStreakSnapshot: MiaPlaza.LO.Streaks.Dtos.IPreviousStreakSnapshot | null;
	}
	export interface IStreakWeekCalendar
	{
		TaskCompletedDays: string[];
		UnscheduledDays: string[];
		StreakMilestoneDay: string;
		ScheduledBreakDays: string[];
	}
	export interface IStreakWorld
	{
		Id: string;
		Name: string;
		LastMilestone: number;
		BackgroundUrl: string;
		IconUrl: string;
		Theme: ColorScheme;
	}
}
export namespace MiaPlaza.LO.StudentElections.Dtos {
	export interface IElectionCourse
	{
		Name: string;
		Description: string;
		ThumbnailUrl: string;
		Id: string;
	}
	export enum ElectionPhase {
		Campaign = "Campaign",
		Voting = "Voting",
		Closed = "Closed",
		Results = "Results"
	}
}
export namespace MiaPlaza.LO.Subscriptions.Dtos {
	export interface IPlanChangeBillingSummary
	{
		ProratedFinalPrice: number;
		ProratedRegularPrice: number;
		NextBillingFinalPrice: number;
		NextBillingRegularPrice: number;
		AddedSubjects: MiaPlaza.Model.Subject[];
		RemovedSubjects: MiaPlaza.Model.Subject[];
		SelectedSubjects: MiaPlaza.Model.Subject[];
		IsFullCurriculum: boolean;
		IsWithinTrialPeriod: boolean;
		DaysLeftInBillingCycle: number;
		NextChargeDate: string;
		NextChargeStatus: string;
	}
	export interface IPlanChangeCouponResult
	{
		Success: boolean;
		ErrorMessage: string;
		BillingSummary: MiaPlaza.LO.Subscriptions.Dtos.IPlanChangeBillingSummary;
	}
}
export namespace MiaPlaza.LO.Testimonials {
	export interface ITestimonial
	{
		Author: string;
		Highlight: string;
		Text: string;
	}
}
export namespace MiaPlaza.LO.TextToSpeech.Models {
	export interface ITextToSpeechResponse
	{
		Text: string;
		Language: string;
		Voice: string;
		AudioUrl: string | null;
		SpeechMarksUrl: string | null;
	}
}
export namespace MiaPlaza.LO.TimeTracking.Dtos {
	export interface ITimeTrackingEventDto
	{
		LessonUuid: string | null;
		CourseUuid: string | null;
		IsVocabulary: boolean;
		Uuid: string;
		Start: string;
		DurationInSeconds: number;
		ReportedAt: string | null;
	}
}
export namespace MiaPlaza.LO.Tracking {
	export enum TrackingProductType {
		SubscriptionMonthlyTrial = "SubscriptionMonthlyTrial",
		SubscriptionMonthlyRegular = "SubscriptionMonthlyRegular",
		OnetimeOneMonth = "OnetimeOneMonth",
		OnetimeTwoMonths = "OnetimeTwoMonths",
		OnetimeThreeMonths = "OnetimeThreeMonths",
		OnetimeFourMonths = "OnetimeFourMonths",
		OnetimeFiveMonths = "OnetimeFiveMonths",
		OnetimeSixMonths = "OnetimeSixMonths",
		OnetimeSevenMonths = "OnetimeSevenMonths",
		OnetimeEightMonths = "OnetimeEightMonths",
		OnetimeNineMonths = "OnetimeNineMonths",
		OnetimeTenMonths = "OnetimeTenMonths",
		OnetimeElevenMonths = "OnetimeElevenMonths",
		OnetimeTwelveMonths = "OnetimeTwelveMonths",
		OnetimeFamilyLifetime = "OnetimeFamilyLifetime",
		OnetimeLifetime = "OnetimeLifetime",
		SubscriptionSingleSubjectMonthlyTrial = "SubscriptionSingleSubjectMonthlyTrial",
		SubscriptionSingleSubjectMonthlyRegular = "SubscriptionSingleSubjectMonthlyRegular",
		SubscriptionMidCycleUpgrade = "SubscriptionMidCycleUpgrade"
	}
}
export namespace MiaPlaza.LO.Tracking.GoogleAds {
	export interface IGoogleAdsConversionEvent
	{
		Label: string;
		Type: MiaPlaza.LO.Tracking.GoogleAds.GoogleAdsConversionType;
	}
	export enum GoogleAdsConversionType {
		PageVisit = "PageVisit",
		Purchase = "Purchase"
	}
	export interface IGoogleAdsPageVisitConversionEvent extends MiaPlaza.LO.Tracking.GoogleAds.IGoogleAdsConversionEvent
	{
		Type: GoogleAdsConversionType.PageVisit;
	}
	export interface IGoogleAdsPurchaseConversionEvent extends MiaPlaza.LO.Tracking.GoogleAds.IGoogleAdsConversionEvent
	{
		Purchase: MiaPlaza.LO.Tracking.GoogleAds.IGoogleAdsPurchaseEvent;
		Type: GoogleAdsConversionType.Purchase;
	}
	export interface IGoogleAdsPurchaseEvent
	{
		TransactionId: string;
		Value: number;
		Currency: string;
		Email: string;
		FirstName: string;
		LastName: string;
	}
}
export namespace MiaPlaza.LO.Videos.UserUploadedVideos.Moderation.Dtos {
	export interface IUserUploadedVideosCountData
	{
		TotalUnmoderatedCount: number;
		TotalInDiscussionCount: number;
	}
}
export namespace MiaPlaza.LO.Vimeo {
	export interface IVideoCreationResponse
	{
		UploadLink: string;
		VideoId: string;
		HasTooManyVideosUploaded: boolean;
		UploaderHasNoCommunityFeatures: boolean;
	}
}
export namespace MiaPlaza.LO.VirtualCurrency {
	export interface IGiveMoneyToChildResult extends MiaPlaza.LO.Results.IActionResult<number>
	{
		AmountLeft?: number;
	}
	export interface IUserPrize
	{
		DaysLeft: number;
		Image: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string | null;
	}
}
export namespace MiaPlaza.Model {
	export enum Lifetime {
		VOLATILE = "VOLATILE",
		UNTIL_SEEN = "UNTIL_SEEN",
		UNTIL_DISMISSED = "UNTIL_DISMISSED"
	}
	export enum PortalType {
		Children = "Children",
		Parents = "Parents"
	}
	export enum TTSModeType {
		Language = "Language",
		Markup = "Markup",
		SoundFile = "SoundFile"
	}
	export enum FeatureAccessLevel {
		NoCommunityFeatures = "NoCommunityFeatures",
		InteractionAllowed = "InteractionAllowed",
		FullSocial = "FullSocial",
		Parent = "Parent"
	}
	export enum SpecialUserType {
		HAPPY_ME = "HAPPY_ME",
		AKI = "AKI",
		ADMIN = "ADMIN",
		DEFAULT_MEMBER = "DEFAULT_MEMBER",
		MODERATOR_CHILD = "MODERATOR_CHILD",
		NEWSPAPER_CORRESPONDENT = "NEWSPAPER_CORRESPONDENT"
	}
	export enum Subject {
		LanguageArts = "LanguageArts",
		Math = "Math",
		Science = "Science",
		GeographyAndHistory = "GeographyAndHistory",
		MusicAndArts = "MusicAndArts",
		ForeignLanguages = "ForeignLanguages",
		LifeSkills = "LifeSkills",
		BiblicalStudies = "BiblicalStudies"
	}
	export enum PublicHoliday {
		NewYearsDay = "NewYearsDay",
		MartinLutherKingJrDay = "MartinLutherKingJrDay",
		PresidentsDay = "PresidentsDay",
		MemorialDay = "MemorialDay",
		Juneteenth = "Juneteenth",
		IndependenceDay = "IndependenceDay",
		LaborDay = "LaborDay",
		VeteransDay = "VeteransDay",
		ThanksgivingDay = "ThanksgivingDay",
		ChristmasDay = "ChristmasDay"
	}
	export enum CheaterStatus {
		None = "None",
		Cheater = "Cheater",
		Watchlist = "Watchlist"
	}
	export enum CompetitionType {
		MostVirtualCurrencyEarned = "MostVirtualCurrencyEarned",
		VirtualCurrencyRaffle = "VirtualCurrencyRaffle"
	}
	export enum Voice {
		Luna = "Luna",
		Max = "Max"
	}
	export enum AssessmentGoalState {
		Assigned = "Assigned",
		Started = "Started",
		Finished = "Finished"
	}
	export enum CheckpointHelpReason {
		ClassroomAccess = "ClassroomAccess",
		NotWorking = "NotWorking",
		AssignmentMissing = "AssignmentMissing",
		Other = "Other"
	}
}
export namespace MiaPlaza.Model.Attendance {
	export enum CustomAttendanceActivityType {
		Workbook = "Workbook",
		Checkpoint = "Checkpoint",
		GoogleClassroom = "GoogleClassroom",
		SupplementalWork = "SupplementalWork",
		Reading = "Reading",
		FieldTrip = "FieldTrip",
		PeActivity = "PeActivity"
	}
}
export namespace MiaPlaza.Model.Curriculum {
	export abstract class CourseEnrollment
	{
		public static PASSING_SCORE_MIN: number = 1;
		public static PASSING_SCORE_MAX: number = 100;
	}
	export abstract class CurriculumChildBreak
	{
		public static MAX_BREAK_NAME_LENGTH: number = 50;
	}
}
export namespace MiaPlaza.Model.Curriculum.Scheduling {
	export enum ScheduleType {
		Default = "Default",
		Task = "Task"
	}
}
export namespace MiaPlaza.Model.Curriculum.Task {
	export enum TaskType {
		Medal = "Medal",
		Video = "Video",
		QuizAssessment = "QuizAssessment",
		Supplemental = "Supplemental"
	}
}
export namespace MiaPlaza.Model.Games {
	export enum MedalType {
		None = "None",
		Bronze = "Bronze",
		Silver = "Silver",
		Gold = "Gold",
		Diamond = "Diamond"
	}
}
export namespace MiaPlaza.Model.Games.MiniWorld {
	export enum Type {
		Designed = "Designed",
		PreDesigned = "PreDesigned",
		Pet = "Pet"
	}
}
export namespace MiaPlaza.Model.Grades {
	export enum Grade {
		K = 0,
		First = 1,
		Second = 2,
		Third = 3,
		Fourth = 4,
		Fifth = 5,
		Sixth = 6,
		Seventh = 7,
		Eighth = 8,
		Ninth = 9,
		Tenth = 10,
		Eleventh = 11,
		Twelfth = 12
	}
}
export namespace MiaPlaza.Model.MiaTour {
	export enum Tour {
		ParentsMembershipDetails = "ParentsMembershipDetails",
		ParentsCurriculumAssigned = "ParentsCurriculumAssigned",
		ParentsCurriculumCalendar = "ParentsCurriculumCalendar",
		ParentsCurriculumCourseUnit = "ParentsCurriculumCourseUnit",
		ChildLearningPath = "ChildLearningPath",
		ChildAllLessons = "ChildAllLessons",
		ChildCommunity = "ChildCommunity",
		ParentsAttendance = "ParentsAttendance",
		ParentsReport = "ParentsReport",
		ParentsGradebook = "ParentsGradebook"
	}
}
export namespace MiaPlaza.Model.Newsletter {
	export enum Status {
		Design = "Design",
		Sending = "Sending",
		Finished = "Finished",
		Paused = "Paused"
	}
}
export namespace MiaPlaza.Model.Payments {
	export enum ProductType {
		FixedEndDate = "FixedEndDate",
		OneWeek = "OneWeek",
		OneMonth = "OneMonth",
		TrialMonth = "TrialMonth",
		TwoMonths = "TwoMonths",
		ThreeMonths = "ThreeMonths",
		FourMonths = "FourMonths",
		FiveMonths = "FiveMonths",
		SixMonths = "SixMonths",
		SevenMonths = "SevenMonths",
		EightMonths = "EightMonths",
		NineMonths = "NineMonths",
		TenMonths = "TenMonths",
		ElevenMonths = "ElevenMonths",
		TwelveMonths = "TwelveMonths",
		TenYearsFree = "TenYearsFree",
		Lifelong = "Lifelong",
		FamilyLifetime = "FamilyLifetime",
		SubscriptionPayment = "SubscriptionPayment",
		FixedEndDateBundle = "FixedEndDateBundle",
		SingleSubjectSubscriptionPayment = "SingleSubjectSubscriptionPayment",
		MidCycleSubscriptionUpgradePayment = "MidCycleSubscriptionUpgradePayment"
	}
}
export namespace MiaPlaza.Model.PremiumParent {
	export enum PredefinedDateRangeType {
		Today = "Today",
		Yesterday = "Yesterday",
		SevenDays = "SevenDays",
		LastWeek = "LastWeek",
		LastMonth = "LastMonth",
		LastSchoolYear = "LastSchoolYear",
		ThisSchoolYear = "ThisSchoolYear",
		Lifetime = "Lifetime"
	}
	export enum Status {
		NoAnswer = "NoAnswer",
		WrongFreeInputUnknown = "WrongFreeInputUnknown",
		CorrectAnswer = "CorrectAnswer",
		WrongFirstAnswer = "WrongFirstAnswer",
		WrongSecondAnswer = "WrongSecondAnswer",
		WrongThirdAnswer = "WrongThirdAnswer",
		WrongFreeInput = "WrongFreeInput"
	}
}
export namespace MiaPlaza.Model.SupplementalMaterials {
	export enum PdfActivityType {
		Activity = "Activity",
		Vocabulary = "Vocabulary",
		GuidedNotes = "GuidedNotes",
		Project = "Project",
		ResearchActivity = "ResearchActivity",
		ExtraSupportActivity = "ExtraSupportActivity",
		ExtensionActivity = "ExtensionActivity",
		AnchorChart = "AnchorChart",
		ReadingActivity = "ReadingActivity",
		WritingActivity = "WritingActivity",
		ListeningActivity = "ListeningActivity",
		VerbalActivity = "VerbalActivity",
		ConversationActivity = "ConversationActivity",
		LabActivity = "LabActivity",
		CreativeActivity = "CreativeActivity",
		LessonOverview = "LessonOverview",
		LessonOverviewWithActivity = "LessonOverviewWithActivity"
	}
}
export namespace MiaPlaza.Model.Video {
	export enum ApprovalLevel {
		NotDecided = "NotDecided",
		Denied = "Denied",
		Approved = "Approved",
		InDiscussion = "InDiscussion"
	}
	export enum ModerationRating {
		Unrated = "Unrated",
		Poor = "Poor",
		Fair = "Fair",
		Good = "Good",
		VeryGood = "VeryGood",
		Excellent = "Excellent"
	}
}
export namespace MiaPlaza.Model.VirtualCurrency.Transaction {
	export enum PresetTransactionType {
		StartingMoney = "StartingMoney",
		ActiveInvitedFriendReward = "ActiveInvitedFriendReward",
		AdminBonus = "AdminBonus",
		CompetitionReward = "CompetitionReward",
		NewspaperArticlePublishedReward = "NewspaperArticlePublishedReward",
		EducationVideoApprovedReward = "EducationVideoApprovedReward",
		EarlyInvitationBonus = "EarlyInvitationBonus",
		MiniWorldBoughtShopItem = "MiniWorldBoughtShopItem",
		MiniWorldSoldShopItem = "MiniWorldSoldShopItem",
		MiniWorldBoughtShape = "MiniWorldBoughtShape",
		MiniWorldUpgradedHouse = "MiniWorldUpgradedHouse",
		MiniWorldBoughtRoom = "MiniWorldBoughtRoom",
		MiniWorldBoughtDraft = "MiniWorldBoughtDraft",
		GNOMTreasureHuntWin = "GNOMTreasureHuntWin",
		GNOMBoughtItems = "GNOMBoughtItems",
		GNOMBoughtEggs = "GNOMBoughtEggs",
		GNOMBoughtActions = "GNOMBoughtActions",
		GNOMCircusWin = "GNOMCircusWin",
		GNOMBoughtPlayAction = "GNOMBoughtPlayAction"
	}
}
export namespace MiaPlaza.Navigation {
	export class VueRoutes
	{
		public static SHOP_ROUTE_KEY: string = `shop`;
		public static SHOP_TEMPLATE: string = `/shop/:shopType`;
		public static DESIGN_STUDIO: string = `/design-studio`;
		public static DESIGN_STUDIO_SHOP_PARAMETER: string = `PublicShopType`;
		public static MEMBER_SHOP: string = `/shop/child/:child`;
	}
}
export namespace MiaPlaza.Navigation.JSON.Converters {
	export interface ILazySizes
	{
		OriginalUrl: string;
		Sizes?: MiaPlaza.Navigation.JSON.Converters.IPictureAtSize[];
		AspectRatio: string;
	}
	export interface IPictureAtSize
	{
		Width: number;
		Url: string;
	}
}
export namespace MiaPlaza.Navigation.MenuBuilder {
	export abstract class Profile
	{
		public static END_FRIENDSHIP_BUTTON: string = `mia-js-endFriendshipButton`;
	}
}
export namespace MiaPlaza.Parents.Control {
	export class ChangePassword
	{
		public static GetUpdateParentPasswordUrl() : string
		{
			return "/Parents.Control.ChangePassword/UpdateParentPassword?_=";
		}
	}
	export class LoginFormParent
	{
		public static GetSaveDataInSessionsForForgotPasswordPageUrl(email: string | MiaPlaza.IPlaceholder) : string
		{
			return `/Parents.Control.LoginFormParent/SaveDataInSessionsForForgotPasswordPage?email=${MiaPlaza.RoutedHelper.GetParameter(email)}&_=`;
		}
	}
}
export namespace MiaPlaza.Parents.Control.Vue {
	export interface IGlyphiconMenuItem
	{
		Name: string;
		NavigateUrl: string;
		GlyphiconName: string;
		IsSelected: boolean;
	}
	export interface IOnlineSchoolStudent
	{
		FirstName: string;
		SapLink: string;
	}
	export interface IChild
	{
		Name: string;
		NavigateUrl: string;
		ProfilePicture: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
		IsSelected: boolean;
		IsActiveOnlineSchoolStudent: boolean;
	}
	export interface IStudentData
	{
		Child: Custom.ModelId<'Member'>;
		StudentName: string;
	}
}
export namespace MiaPlaza.Parents.Control.Vue.Notifications {
	export interface IChildIsGrounded extends MiaPlaza.Control.Vue.Notifications.Shared.INotification
	{
		Template: 'MemberPenalty';
		Portal: MiaPlaza.Model.PortalType;
		Reason: string;
		Until: string;
		PenaltyImage: MiaPlaza.Navigation.JSON.Converters.ILazySizes | string;
	}
}
export namespace MiaPlaza.Parents.Control.Vue.Payments {
	export interface ICheckoutLinks
	{
		ChangePlanUrl: string;
		ApplyCouponUrl: string;
	}
	export interface ICheckoutProduct
	{
		Name: string;
		Price: number;
		RegularPrice: number;
		OngoingPrice: number;
		FirstMonthDiscount: number;
		CouponDiscount: number;
		SaleDiscount: number;
		Currency: string;
		IsSubscription: boolean;
		ShowFirstMonthDiscount: boolean;
	}
	export interface ICheckoutReceiver
	{
		Name: string;
		NameShort: string;
	}
	export interface ICouponInfo
	{
		Code: string;
		DiscountPercent: number;
	}
	export interface IFixPaymentProduct
	{
		Name: string;
		Price: number;
		OngoingPrice: number;
		Currency: string;
	}
	export interface ITheme
	{
		Brand: "always-icecream" | "clever-dragons" | "miacademy" | "miaprep";
		Audience: "elementary" | "middle" | "high" | "parent";
		Appearance: "light" | "dark";
	}
}
export namespace MiaPlaza.PublicOnlineSchool.Application {
	export interface IGetStudentsQuery
	{
		SearchTerm: string;
		AdvisorUuids: string[];
		IsStudentActive: boolean | null;
		InactiveHoursRanges: MiaPlaza.PublicOnlineSchool.Application.IInactiveHoursRange[];
		YearlyHoursStatuses: MiaPlaza.PublicOnlineSchool.Domain.YearlyHoursStatus[];
	}
	export interface IInactiveHoursRange
	{
		MinHours: number;
		MaxHours: number | null;
	}
}
export namespace MiaPlaza.PublicOnlineSchool.Application.Reports.TotalLearningOpportunity {
	export interface IStudentLearningOpportunity extends MiaPlaza.PublicOnlineSchool.Application.Reports.TotalLearningOpportunity.IStudentLearningOpportunityReportBase
	{
		StudentName: string;
		PercentVsExpected: number;
		SchoolDays: number;
		PercentThroughSchoolYear: number;
		Email: string | null;
		ParentEmail: string;
		Advisor: string | null;
		DifferenceInHoursVsExpected: number;
		DateOfLastCompletedTask: string | null;
		InactiveHours: number;
		PendingOfflineActivityHours: number;
		YearlyHoursStatus: MiaPlaza.PublicOnlineSchool.Domain.YearlyHoursStatus;
		OnlineSchoolStudentUuid: string;
	}
	export interface IStudentLearningOpportunityReportBase
	{
		Ssid: string;
		EnrollmentStartDate: string;
		EnrollmentEndDate: string;
		TotalEnroll: number;
		ComputerBasedHours: number;
		OtherHours: number;
		TotalDocumentedHours: number;
		PercentOfTime: number;
	}
}
export namespace MiaPlaza.PublicOnlineSchool.Domain {
	export enum YearlyHoursStatus {
		Completed = "Completed",
		OnTrack = "OnTrack",
		Concern = "Concern",
		Alarm = "Alarm"
	}
}
export namespace MiaPlaza.PublicOnlineSchool.Web.Controllers {
	export abstract class ReportsController
	{
		public static GetExportOnlineActivityReportCsvUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/PublicOnlineSchool.Web.Controllers.ReportsController/ExportOnlineActivityReportCsv?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetExportOnlineActivityReportXlsxUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/PublicOnlineSchool.Web.Controllers.ReportsController/ExportOnlineActivityReportXlsx?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetExportOfflineActivityReportCsvUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/PublicOnlineSchool.Web.Controllers.ReportsController/ExportOfflineActivityReportCsv?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetExportOfflineActivityReportXlsxUrl(student: Custom.ModelId<'Member'> | MiaPlaza.IPlaceholder, start: string | MiaPlaza.IPlaceholder, end: string | MiaPlaza.IPlaceholder) : string
		{
			return `/PublicOnlineSchool.Web.Controllers.ReportsController/ExportOfflineActivityReportXlsx?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&start=${MiaPlaza.RoutedHelper.GetParameter(start)}&end=${MiaPlaza.RoutedHelper.GetParameter(end)}&_=`;
		}
		public static GetExportTotalLearningOpportunityReportCsvUrl() : string
		{
			return "/PublicOnlineSchool.Web.Controllers.ReportsController/ExportTotalLearningOpportunityReportCsv?_=";
		}
		public static GetExportTotalLearningOpportunityReportXlsxUrl() : string
		{
			return "/PublicOnlineSchool.Web.Controllers.ReportsController/ExportTotalLearningOpportunityReportXlsx?_=";
		}
		public static GetPublicOnlineSchoolStudentsUrl(query?: MiaPlaza.PublicOnlineSchool.Application.IGetStudentsQuery | MiaPlaza.IPlaceholder) : string
		{
			return `/PublicOnlineSchool.Web.Controllers.ReportsController/GetPublicOnlineSchoolStudents?query=${MiaPlaza.RoutedHelper.GetParameter(query)}&_=`;
		}
		public static GetConvertStudentUrl(student: Custom.ModelId<'PublicOnlineSchoolStudent'> | MiaPlaza.IPlaceholder) : string
		{
			return `/PublicOnlineSchool.Web.Controllers.ReportsController/ConvertStudent?student=${MiaPlaza.RoutedHelper.GetParameter(student)}&_=`;
		}
	}
}
export namespace MiaPlaza.SignalR {
	export abstract class Configuration
	{
		public static PATH: string = `/signalr`;
	}
	export class MultiplayerGameHub
	{
		public static PATH: string = `/multiplayerGameHub`;
	}
	export interface InvitationResponse
	{
		Status: number;
		Instance: Custom.ModelId<'MultiplayerInstance'>;
	}
	export class SessionHub
	{
		public static PATH: string = `/sessionHub`;
		public static SESSION_TIMEZONE_SET: string = `timezone_set`;
	}
	export interface IFundsUpdate
	{
		Balance: number;
		TimeStamp: string;
		PlaySound: boolean;
	}
}
export namespace MiaPlaza.TextToSpeechClient.Models.Enums {
	export enum SpeechFileType {
		Audio = "Audio",
		Metadata = "Metadata"
	}
}
export namespace MiaPlaza.TextToSpeechClient.Models.SpeechMarks {
	export interface ISpeechMarks
	{
		Words: MiaPlaza.TextToSpeechClient.Models.SpeechMarks.ITimedWord[];
	}
	export interface ITimedWord
	{
		Word: string;
		Start: number;
		End: number;
	}
}
export namespace MiaPlaza.Website.LO.Contest.Dtos {
	export interface IContestVideo
	{
		Url: string;
		Title: string;
		UploaderID: number;
		UploaderUsername: string;
		Rating: number;
		IsUploaderActive: boolean;
	}
	export interface INewspaperContestArticle
	{
		Link: string;
		Title: string;
		WriterID: number;
		WriterUsername: string;
		Rating: number;
		IsWriterActive: boolean;
	}
}
